var _g, _path, _path2, _g2, _g3, _path3, _path4, _g4, _path5, _path6, _path7, _path8, _path9, _path0, _g5, _g6, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _path2271, _path2272, _path2273, _path2274, _path2275, _path2276, _path2277, _path2278, _path2279, _path2280, _path2281, _path2282, _path2283, _path2284, _path2285, _path2286, _path2287, _path2288, _path2289, _path2290, _path2291, _path2292, _path2293, _path2294, _path2295, _path2296, _path2297, _path2298, _path2299, _path2300, _path2301, _path2302, _path2303, _path2304, _path2305, _path2306, _path2307, _path2308, _path2309, _path2310, _path2311, _path2312, _path2313, _path2314, _path2315, _path2316, _path2317, _path2318, _path2319, _path2320, _path2321, _path2322, _path2323, _path2324, _path2325, _path2326, _path2327, _path2328, _path2329, _path2330, _path2331, _path2332, _path2333, _path2334, _path2335, _path2336, _path2337, _path2338, _path2339, _path2340, _path2341, _path2342, _path2343, _path2344, _path2345, _path2346, _path2347, _path2348, _path2349, _path2350, _path2351, _path2352, _path2353, _path2354, _path2355, _path2356, _path2357, _path2358, _path2359, _path2360, _path2361, _path2362, _path2363, _path2364, _path2365, _path2366, _path2367, _path2368, _path2369, _path2370, _path2371, _path2372, _path2373, _path2374, _path2375, _path2376, _path2377, _path2378, _path2379, _path2380, _path2381, _path2382, _path2383, _path2384, _path2385, _path2386, _path2387, _path2388, _path2389, _path2390, _path2391, _path2392, _path2393, _path2394, _path2395, _path2396, _path2397, _path2398, _path2399, _path2400, _path2401, _path2402, _path2403, _path2404, _path2405, _path2406, _path2407, _path2408, _path2409, _path2410, _path2411, _path2412, _path2413, _path2414, _path2415, _path2416, _path2417, _path2418, _path2419, _path2420, _path2421, _path2422, _path2423, _path2424, _path2425, _path2426, _path2427, _path2428, _path2429, _path2430, _path2431, _path2432, _path2433, _path2434, _path2435, _path2436, _path2437, _path2438, _path2439, _path2440, _path2441, _path2442, _path2443, _path2444, _path2445, _path2446, _path2447, _path2448, _path2449, _path2450, _path2451, _path2452, _path2453, _path2454, _path2455, _path2456, _path2457, _path2458, _path2459, _path2460, _path2461, _path2462, _path2463, _path2464, _path2465, _path2466, _path2467, _path2468, _path2469, _path2470, _path2471, _path2472, _path2473, _path2474, _path2475, _path2476, _path2477, _path2478, _path2479, _path2480, _path2481, _path2482, _path2483, _path2484, _path2485, _path2486, _path2487, _path2488, _path2489, _path2490, _path2491, _path2492, _path2493, _path2494, _path2495, _path2496, _path2497, _path2498, _path2499, _path2500, _path2501, _path2502, _path2503, _path2504, _path2505, _path2506, _path2507, _path2508, _path2509, _path2510, _path2511, _path2512, _path2513, _path2514, _path2515, _path2516, _path2517, _path2518, _path2519, _path2520, _path2521, _path2522, _path2523, _path2524, _path2525, _path2526, _path2527, _path2528, _path2529, _path2530, _path2531, _path2532, _path2533, _path2534, _path2535, _path2536, _path2537, _path2538, _path2539, _path2540, _path2541, _path2542, _path2543, _path2544, _path2545, _path2546, _path2547, _path2548, _path2549, _path2550, _path2551, _path2552, _path2553, _path2554, _path2555, _path2556, _path2557, _path2558, _path2559, _path2560, _path2561, _path2562, _path2563, _path2564, _path2565, _path2566, _path2567, _path2568, _path2569, _path2570, _path2571, _path2572, _path2573, _path2574, _path2575, _path2576, _path2577, _path2578, _path2579, _path2580, _path2581, _path2582, _path2583, _path2584, _path2585, _path2586, _path2587, _path2588, _path2589, _path2590, _path2591, _path2592, _path2593, _path2594, _path2595, _path2596, _path2597, _path2598, _path2599, _path2600, _path2601, _path2602, _path2603, _path2604, _path2605, _path2606, _path2607, _path2608, _path2609, _path2610, _path2611, _path2612, _path2613, _path2614, _path2615, _path2616, _path2617, _path2618, _path2619, _path2620, _path2621, _path2622, _path2623, _path2624, _path2625, _path2626, _path2627, _path2628, _path2629, _path2630, _path2631, _path2632, _path2633, _path2634, _path2635, _path2636, _path2637, _path2638, _path2639, _path2640, _path2641, _path2642, _path2643, _path2644, _path2645, _path2646, _path2647, _path2648, _path2649, _path2650, _path2651, _path2652, _path2653, _path2654, _path2655, _path2656, _path2657, _path2658, _path2659, _path2660, _path2661, _path2662, _path2663, _path2664, _path2665, _path2666, _path2667, _path2668, _path2669, _path2670, _path2671, _path2672, _path2673, _path2674, _path2675, _path2676, _path2677, _path2678, _path2679, _path2680, _path2681, _path2682, _path2683, _path2684, _path2685, _path2686, _path2687, _path2688, _path2689, _path2690, _path2691, _path2692, _path2693, _path2694, _path2695, _path2696, _path2697, _path2698, _path2699, _path2700, _path2701, _path2702, _path2703, _path2704, _path2705, _path2706, _path2707, _path2708, _path2709, _path2710, _path2711, _path2712, _path2713, _path2714, _path2715, _path2716, _path2717, _path2718, _path2719, _path2720, _path2721, _path2722, _path2723, _path2724, _path2725, _path2726, _path2727, _path2728, _path2729, _path2730, _path2731, _path2732, _path2733, _path2734, _path2735, _path2736, _path2737, _path2738, _path2739, _path2740, _path2741, _path2742, _path2743, _path2744, _path2745, _path2746, _path2747, _path2748, _path2749, _path2750, _path2751, _path2752, _path2753, _path2754, _path2755, _path2756, _path2757, _path2758, _path2759, _path2760, _path2761, _path2762, _path2763, _path2764, _path2765, _path2766, _path2767, _path2768, _path2769, _path2770, _path2771, _path2772, _path2773, _path2774, _path2775, _path2776, _path2777, _path2778, _path2779, _path2780, _path2781, _path2782, _path2783, _path2784, _path2785, _path2786, _path2787, _path2788, _path2789, _path2790, _path2791, _path2792, _path2793, _path2794, _path2795, _path2796, _path2797, _path2798, _path2799, _path2800, _path2801, _path2802, _path2803, _path2804, _path2805, _path2806, _path2807, _path2808, _path2809, _path2810, _path2811, _path2812, _path2813, _path2814, _path2815, _path2816, _path2817, _path2818, _path2819, _path2820, _path2821, _path2822, _path2823, _path2824, _path2825, _path2826, _path2827, _path2828, _path2829, _path2830, _path2831, _path2832, _path2833, _path2834, _path2835, _path2836, _path2837, _path2838, _path2839, _path2840, _path2841, _path2842;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlasticBag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    height: 128,
    width: 77,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d9d8de"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 95v-1h1v1h2v2h1v1h1v1h1v1h1v1h-2v-1h-2v-2h-1v-1h-3v-1h-1v1h1v1h-1v1h-4v-1h3v-1h-2v-2h1v1h1v-1zm-9 4v-1h2v2h-1v-1zm-1 1v-1h1v2h-2v-1zm2-3h-1v-1h2v1zm-6 6v-1h2v1h-1zm11-35v1h-1v-1zm-2 26h-1v-1h1zm-3 1v-1h1v1zm-2 2h1v1h-1zm4 0v1h-1v-1zm-5 2v-1h1v1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 101h-1v-1h1zm12 2h-1v-1h1zm-6 3v-1h1v1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 40h-1v1h-2v-1h1v-1h1v-1h2v3h-1zm-4-1h-3v1h-1v-2h4zm-5-3h3v1h-3zm8 0v1h-3v-1zm4 18h1v2h-2v-1h1zM25 38v1h-2v-1h1zm2 1v1h-1v-2h1zm18 0v1h-1v-2h1zM21 16v1h-1v-1zm1 3v1h-1v-1zm-1 5h-1v-1h1zm1 0v1h-1v-1zm-5 4h1v1h-1zm5 4v-1h1v1zm27 3h1v1h-1zm-1 3v1h-1v-1zm-17 3v-1h1v1zm17 2v1h-1v-1zm0 4h1v1h-1zm-1 2v-1h1v1zm1 1v1h-1v-1zm-1 3v1h-1v-1z",
    fill: "#e0dfe4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37v1h-7v-1h1zm7-1h1v-1h1v2h-1v1h-1v-1zm-4 5v-3h1v2h1v1zM19 30v1h-1v-2h1zm13 9h-2v-1h2zm23 3v1h-2v-1h1zm-8 9v1h-1v-2h1zM19 17h-1v-1h1zm-1 4v1h-1v-1zm2 1v1h-1v-1zm33 10v1h-1v-1zm-3 2h1v1h-1zm-8 2h-1v-1h1zm-20 1v-1h1v1zm25 1v1h-1v-1zm-22 2h-1v-1h1zm21 0h-1v-1h1zm0 0h1v1h-1zm0 4v1h-1v-1zm5 1v-1h1v1zm-7 10v-1h1v1zm0 2h-1v-1h1zm-3 2h-1v-1h1zm0 0h1v1h-1zm-2 50h1v1h-1z",
    fill: "#e1e0e5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ebe9ec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 50h1v-1h1v1h1v1h-2v2h-1v-1zm-5-3v1h-2v-1h-1v-1h1v-1h1v2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 44h1v1h-1v1h-1v-3h1zm0 5h1v1h-2v-3h1zm7 3v1h1v1h-1v1h-1v-3zm-1-3v1h-3v-1zm4-5h-2v-1h2zm-16 8v-1h2v1h-1zm-2 4v2h-1v-2zm3-23h1v1h-1zm-2 14h-1v-1h1zm6 0h-1v-1h1zm6 0h-1v-1h1zm7 2v1h-1v-1zm-13 3v-1h1v1zm-5 0v1h-1v-1zm6 2v-1h1v1zm6 2v1h-1v-1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#dad9df"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 98h-1v1h-1v1h-1v1h-2v-2h1v-1h1v-1h3zm-9 2v-2h1v2h1v-1h1v2h-3v1h-1v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 98h1v2h2v1h-5v-1h2zm6 8v-1h2v1h-1zM51 35h1v1h-1zm2 16h-1v-1h1zm-1 1h-1v-1h1zm-4 2h1v1h-1zm4 43h-1v-1h1zm-7 3h-1v-1h1zm-2 1v1h-1v-1z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h1v1h2v1h-3zm-6 0v-1h3v1h-1zM21 20h2v1h-2zm28 21h-2v-1h2zm0 2h2v1h-2zm15-29h1v1h-1zm-45 4h-1v-1h1zm2-1v1h-1v-1zm5 1h1v1h-1zm-6 6h-1v-1h1zm1 0v-1h1v1zm0 1h-1v-1h1zm2 5v-1h1v1zm15 5h-1v-1h1zm-6 2h1v1h-1zm13 4v-1h1v1zm-13 3v-1h1v1zm16 1v-1h1v1zm-5 0v1h-1v-1zm1 2h-1v-1h1zm4 1h1v1h-1zm0 4h-1v-1h1zm-4 2v1h-1v-1zm0 55v-1h1v1zm4 0h-1v-1h1zm-9 1h-1v-1h1z",
    fill: "#e2e1e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 95v1h-1v-1h-1v-2h2v1h2v-1h1v2h-2zm8 1h1v1h-1v1h-1v-1h-1v-2h2zm-4-43h-2v-1h1v-1h1zm-9 45h-1v-1h2v1zm3-1h2v1h-2zM17 33v-1h1v1zm45 3v1h-1v-1zm-6 43v-1h1v1zm-1 15v1h-1v-1zm-12 3v-1h1v1zm-1 0h1v1h-1zm1 2v-1h1v1zm15-1h1v1h-1zm2 1v1h-1v-1zm1 1v1h-1v-1zm1 3h1v1h-1z",
    fill: "#d8d7dd"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#eceaed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 53v-1h-6v-2h1v-1h-2v-2h1v1h3v1h-1v1h3v-1h3v1h-1v3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 47v1h-2v-1h1zm-7 5h1v2h-1v-1zm6 1h1v2h-1v-1zm-4-8v1h-1v-1zm6 1v1h-1v-1zm3 3h1v1h-1z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h-2v1h-1v1h-1v-2h1v-1h1v-1h1v1h1zm-14-1v-1h-1v-3h1v1h1v3zm12-4v1h-3v-2h2v1zm-13-2v1h-1v-2h1zm16 2h2v1h-2zm-5 9h-2v-1h2zM25 34h1v1h-1zm4 11h-1v-1h1zm-5 0v1h-1v-1zm9 1v1h-1v-1zm10 4v1h-1v-1zm-13 2v-1h1v1zm-9 3h1v1h-1zm14 4h-1v-1h1z",
    fill: "#e9e7ea"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18v-1h1v2h-3v-1zm28 22h2v1h-2zm-1 3v-1h2v1h-1zm4 1h2v1h-2zm6-31h1v1h-1zm7 0v1h-1v-1zm-2 1h1v1h-1zm-41 7h1v1h-1zm-2 4v1h-1v-1zm3 3h1v1h-1zm-5 4v-1h1v1zm34 1v1h-1v-1zm-14 2v1h-1v-1zm5 0v1h-1v-1zm-16 6h-1v-1h1zm27 1v-1h1v1zm-11 1v-1h1v1zm7 2h-1v-1h1zm-12 0v1h-1v-1zm9 2h1v1h-1zm0 2h-1v-1h1zm-29 8v-1h1v1zm16 9v1h-1v-1zm26 41v-1h1v1z",
    fill: "#e3e2e7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36 48v-1h1v2h-3v-1zm7 2h-1v-1h-2v-1h3zm-7 6v-1h1v-1h1v2zm-8-9h1v2h-1v-1zm1 4v-1h2v1h-1zm6 7h-1v-1h2v1zm-7-14v-1h1v1zm14-1v1h-1v-1zm-10 1v1h-1v-1zm-4 2v-1h1v1zm5-1v1h-1v-1zm-4 1h1v1h-1zm7 1h-1v-1h1zm1 0v-1h1v1zm-11 3v1h-1v-1zm15 0h1v1h-1zm-2 2v-1h1v1zm-15 0h1v1h-1zm7 0v1h-1v-1z",
    fill: "#eae8eb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21 56v2h1v1h-1v1h-1v-4zm15 2v-1h2v1h-1v1h-2v-1zm-9-9h-1v-2h2v1h-1zm6-2v-1h1v2h-1zm10 5h-2v-1h2zm-18 2h-2v-1h2zm15 0v2h-1v-2zM19 36h1v1h-1zm15 9h1v1h-1zm-13 4h1v1h-1zm22 1h1v1h-1zm-19 2h-1v-1h1zm17 2h-1v-1h1zm-2 2v1h-1v-1zm-4 3v1h-1v-1z",
    fill: "#e8e6e9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38 40v-2h3v1h-1v1zm-4 0h-3v-1h3zm-9-2h-1v-2h1v1zm12-2h1v1h-2v-1zM18 17h-1v-1h1zm4 13h1v1h-1zm28 5h1v1h-1zm0 1v1h-1v-1zm-28 3v-1h1v1zm25 1h-1v-1h1zm-22 0h1v1h-1zm17 1h-1v-1h1zm11 3h-1v-1h1zm-6 1h-1v-1h1zm1 5v-1h1v1zm0 2v1h-1v-1zM38 66v-1h1v1zm24 40h1v1h-1zm-18 2v1h-1v-1z",
    fill: "#dfdee3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26 104v-2h2v-2h2v-1h1v3h-1v1h-3v1zm11-7v1h-2v1h1v1h-3v-1h-1v-2h1zm25-59v1h-1v-1zm-5 3h-1v-1h1zm-2 28h-1v-1h1z",
    fill: "#d7d5da"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#d4d4dc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 51v1h-1v1h-1v-1h-1v2h-2v-2h1v-1h-1v-1h2v-1h1v2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 51v-1h-1v-1h2v2zm-3-7h1v2h-1v-1zm-1 3h2v1h-2zm0-2v1h-1v-1zm5 8h-1v-1h1zm-2 0h1v1h-1zm-3 2h1v1h-1zm4 1h-1v-1h1zm-2 0v1h-1v-1z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#d3d3db"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 48h3v-2h1v2h1v1h-2v1h1v1h-2v-2h-2zm1 8v-4h1v1h1v3zm3-38v-1h2v1h-1zm2 6v1h-1v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 46h1v1h-1zm-1 3v1h-1v-1z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M64 53v4h-1v-4zm-2-4v-3h1v3zm3 23h-1v-3h1v1zm-1-22v2h-1v-2zm2 12h1v2h-1v-1zm-3 28v-2h1v2zm0-58h1v1h-1zm-1 11h-1v-1h1zm-3 2v-1h1v1zm2-1h1v1h-1zm4 20h-1v-1h1zm-1 2v-1h1v1z",
    fill: "#d1d0d8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50 53v1h-2v-1h1v-1h3v1zm3 46h1v-1h1v2h-2zm-4 2v-2h1v2zm6 5h1v1h-2v-1zM22 35h1v1h-1zm30 15v1h-1v-1zm0 1h1v1h-1zm-33 3h-1v-1h1zm29 1h1v1h-1zm-1 1h1v1h-1zm1 11v-1h1v1zm5 22h1v1h-1zm-5 10v1h-1v-1zm7 3v-1h1v1z",
    fill: "#dbdae0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13 57h1v4h-1v-1h-1v-1h1zm-1 16h-1v-3h1zm-1 11h-1v1H9v-2h2zm2-20v-2h1v2zm-1 17h-1v-2h1v1zm1-27h1v1h-1zm-2 6v1h-1v-1zm2 2h-1v-1h1zm-1 8v-1h1v1zM9 82v1H8v-1zm10 18v1h-1v-1z",
    fill: "#d0c8c6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96v1h-2v1h-1v-2zm-8 6v-1h2v-1h1v2zm-1 0v2h-3v-1h2v-1zm4-2v-1h1v-1h1v2zm1 1h1v2h-1v-1zM22 39h-1v-1h1zm30 53h1v1h-1zm-8 3v1h-1v-1z",
    fill: "#d9d7dc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11 61v-4h2v2h-1v2zm1 14v4h-1v-4zm0-22v-1h1v1zm-2 11v-1h1v1zm1 2h-1v-1h1zm0 2v-1h1v1zm1 6h-1v-1h1zm0 8v-1h1v1zm-2 4v1H9v-1zm1 4h1v1h-1zm1 4v-1h1v1zm2 8h-1v-1h1z",
    fill: "#d0c8c5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11 68h2v1h-1v1h-1zm2 25h-1v-3h1zm-2-26v1h-1v-2h1zm2-21h-1v-1h1zm0 3h-1v-1h1zm1 4h-1v-1h1zm-2 9h-1v-1h1zm0 12v1h-1v-1zm2 9h-1v-1h1zm4 10h-1v-1h1zm-6 1h1v1h-1zm5 0v1h-1v-1zm-3 8v1h-1v-1z",
    fill: "#d1c9c6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35 100v1h-2v2h-1v-1h-1v-1h1v-1zm3-4v2h-1v-1h-1v-1zm-10 8v1h-1v-2h2v1zm8-5h-1v-1h2v1zM26 89v1h-1v-1zm40 0v1h-1v-1zm-31 6v1h-1v-1zm-4 8h-1v-1h1z",
    fill: "#d8d6db"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v1h-1v-4h1zm0-5v1h-3v-1h1zm5 24h-1v-3h1zm-4-17v1h-1v-2h1zm3 7v-1h1v2h-1zm-8-12v-1h1v1zm9 0v1h-1v-1zm-3 32v1h-1v-1z",
    fill: "#d2d1d9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37 35v1h-2v-1h1zm14 8v-1h1v2h-1zm-8 2h2v1h-2zm0 1v1h-2v-1h1zm22-31v-1h1v1zm-45 2v1h-1v-1zm-2 5v-1h1v1zm7 2h1v1h-1zm28 19h1v1h-1zm-7 5v-1h1v1zm2 1v1h-1v-1zm-2 60v-1h1v1z",
    fill: "#e4e3e8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54 50h1v1h1v1h-1v1h-1v-1zm3 4v1h-1v1h-2v-1h1v-1zm5-26h-1v-1h1zm0 2v1h-1v-1zm0 3v1h-1v-1zm-5 12v1h-1v-1zm-2 3h1v1h-1zm1 2v-1h1v1zm4 2v1h-1v-1zm0 1h1v1h-1z",
    fill: "#d5d5dd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M36 103v1h-4v-1h1zm11-6h-1v-1h2v1zM22 39h1v1h-1zm29 0v1h-1v-1zm4 1h1v1h-1zm-7 23h1v1h-1zm3 0v1h-1v-1zm-2 23v1h-1v-1zm-4 2v-1h1v1zm-9 7h1v1h-1zm9 0v1h-1v-1zm-16 10h1v1h-1z",
    fill: "#d9d8dd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96v1h-4v2h1v1h-1v1h-1v-5zM19 44h-1v-1h1zm38 29v-1h1v1zM23 84v1h-1v-1zm42 3v-1h1v1zm-35 13h-1v-1h1zm-2 2h-1v-1h1z",
    fill: "#d6d4d9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10 73h1v3h-1v-1zm1-16v2h-1v-2zm-1 15v-2h1v2zm2 4h1v2h-1v-1zm-1-27h-1v-1h1zm0 0h1v1h-1zm0 5v-1h1v1zm-1 11v-1h1v1zm1 16v1h-1v-1zm8 21v1h-1v-1zm-5 8v-1h1v1z",
    fill: "#cec6c3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15 61v1h-1v-2h1v-1h1v2zm-1 10h-1v-3h1zm0 4v1h-1v-2h1zm-3 6h-1v-2h1v1zm3 14h-1v-2h1v1zm0-37h1v1h-1zm1 21v1h-1v-1zm2 25h1v1h-1z",
    fill: "#cdc5c3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49h1v-1h2v2h-3zm6-6v-1h2v1h-1zm7-30v1h-1v-1zM49 52v-1h1v1zm2 1v1h-1v-1zm-4 1h1v1h-1zm0 2h-1v-1h1zm-11 49v-1h1v1zm13 1h1v1h-1zm7 2h-1v-1h1z",
    fill: "#dddce2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64 45h1v2h1v4h-1v-2h-1v-2zm2 28h-1v-3h1zm-2-31h-1v-1h1zm0 3h-1v-1h1zm2 11v1h-1v-1zm-1 4v-1h1v1z",
    fill: "#cdccd4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v4h-1v-4zm0 21v-4h1v4zm0 7v1h-1v-2h1zm-2-34h1v1h-1zm0 3v-1h1v1zm3 15h-1v-1h1zm0 12v1h-1v-1zm0 3h-1v-1h1z",
    fill: "#cecdd5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24 36v1h-1v-2h1zm25 12v-1h1v2h-1zm10-35h1v1h-1zm-37 4h-1v-1h1zm-4 0v1h-1v-1zm0 18h-1v-1h1zm30 3v-1h1v1zm9 3v1h-1v-1zm-9 13h-1v-1h1zm-30 2v-1h1v1zm20 17v1h-1v-1zm4 36v-1h1v1z",
    fill: "#dedde2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M33 103v-1h3v-2h2v1h-1v2zm7-6h2v1h-2zM22 38h-1v-1h1zm2 3v-1h1v1zm-7 12v-1h1v1zm33 32v1h-1v-1zm-21 21h-1v-1h1z",
    fill: "#dad8dd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v-3h1v3zm2 8h1v3h-1zm2 12h-1v-3h1zm-2-18h-1v-2h1v1zm-1 1h1v1h-1zm0 3h1v1h-1zm1 21v-1h1v1z",
    fill: "#d0cfd7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M63 55h-1v-3h-1v-1h2zm4 5h-1v-2h1v1zm-6-15h-1v-1h1zm-2 0h1v1h-1zm7 2v-1h1v1zm-5 0v1h-1v-1zm1 3h-1v-1h1zm5 5h-1v-1h1zm-1 12h1v1h-1z",
    fill: "#d3d2da"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M14 67h-1v-3h1zm-1 6h-1v-3h1zm-2-18h1v1h-1zm2 6h-1v-1h1zm0 0h1v1h-1zm1 19v1h-1v-1zm-5 7h1v1H9zm11 1v1h-1v-1zm0 5h1v1h-1zm-9 10v-1h1v1z",
    fill: "#cfc7c5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M13 71h1v3h-1v-1zm2-15v2h-1v-2zm0 3v1h-1v-1zm-1 8v1h-1v-1zm-1 11v1h-1v-1zm5 1v-1h1v1zm-4 1h1v1h-1zm-3 11h1v1h-1zm2 1h1v1h-1zm-1 9v1h-1v-1zm5 3v-1h1v1z",
    fill: "#cec6c4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15 62v11h-1V62zm-4 29v1h-1v-2h1zm4-29v-1h1v1z",
    fill: "#ccc4c2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M58 95h-3v-2h1v1h2zm2 2v2h-1v-1h-1v-1zm-7-50v-1h1v1zm-34 2v-1h1v1zm35 5h-1v-1h1zm0 40h-1v-1h1zm6 6v-1h1v1zm3 3h1v1h-1z",
    fill: "#d7d6dc"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M66 73v-1h1v4h-1zm-6-17v-1h1v-1h1v2zm6-6v-2h1v2zm-6 2v-1h1v1zm0 2v1h-1v-1zm0 8v1h-1v-1zm-2 9v1h-1v-1z",
    fill: "#d5d4dc"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47h-2v-1h2zm19-31h-1v-1h1zm-45 0v1h-1v-1zm-3 2h1v1h-1zm9 3h1v1h-1zm6 15h1v1h-1zm-3 2v-1h1v1zm4 0v1h-1v-1zm13 0v1h-1v-1zm6 7h1v1h-1zm-1 63v-1h1v1z",
    fill: "#e1e0e6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M24 46h1v2h-1v-1zm10 30h-1v-1h2v1zm-9-56v-1h1v1zm-4 19h-1v-1h1zm-1 7h1v1h-1zm-1 7v-1h1v1zm13 21h-1v-1h1zm17 2v1h-1v-1zm-17 6h-1v-1h1zm4 28h-1v-1h1z",
    fill: "#dedce1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M67 68v4h-1v-4zm-6-12h1v-1h1v2h-2zm1-3v1h-1v-2h1zm2-28v1h-1v-1zm-6 18h1v1h-1zm8 7h1v1h-1z",
    fill: "#d4d3db"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M41 55v1h-1v-2h1v-1h1v2zm-3 3h1v1h-2v-1zM24 33v-1h1v1zm1 11h-1v-1h1zm6-1h1v1h-1zm-4 2v-1h1v1zm0 4v1h-1v-1zm11 7v-1h1v1z",
    fill: "#e7e5e8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M41 99h-1v-1h2v3h-1zM19 52v1h-1v-1zm29 10h1v1h-1zM38 95v1h-1v-1zm1 0h1v1h-1zm27 1h-1v-1h1zm-25 0h1v1h-1zm-2 3h-1v-1h1zm0 3h-1v-1h1z",
    fill: "#d9d7dd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M65 13v-1h1v2h-1zm-47 7v1h-1v-1zm3 2v-1h1v1zm6 0v1h-1v-1zm-3 1h1v1h-1zm25 19h-1v-1h1zm4 1h-1v-1h1zm-20 1v-1h1v1zm12 0v-1h1v1zm-6 3v-1h1v1z",
    fill: "#e5e4e9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M51 51v1h-1v-2h1zM22 32h1v1h-1zm-2 1h1v1h-1zm32 1v1h-1v-1zm-4 18h1v1h-1zm-2 4h1v1h-1zm2 11h1v1h-1zm17 36v1h-1v-1zm-30 2v-1h1v1zm22 2h-1v-1h1z",
    fill: "#dcdbe1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M65 76h1v3h-1zm-2-33h-1v-2h1v1zm2 20v-2h1v2zm-1-30v1h-1v-1zm-1 16v-1h1v1zm2 5h-1v-1h1zm0 20h1v1h-1z",
    fill: "#cfced6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M28 46v1h-1v-2h1zm-2-11v1h-1v-1zm1 7v-1h1v1zm-1 2h-1v-1h1zm2 8h-1v-1h1zm14 1h1v1h-1zm-1 2h1v1h-1zm-20 6h-1v-1h1zm-1 2v1h-1v-1zm0 10h-1v-1h1z",
    fill: "#e6e4e7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M12 73h1v3h-1zm0-24h-1v-1h1zm-1 5h1v1h-1zm1 3h-1v-1h1zm-2 3v-1h1v1zm0 9v1H9v-1zm0 3h1v1h-1zm2 8v-1h1v1zm2 9v1h-1v-1z",
    fill: "#cfc7c4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v1h-2v-1h1zm17-23v1h-1v-1zM20 24v1h-1v-1zm1 3v-1h1v1zm3 7h-1v-1h1zm21 1h-1v-1h1zm-14 1h1v1h-1zm22 5v-1h1v1zm-16 4h-1v-1h1z",
    fill: "#e3e2e6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M18 40h-1v-3h1v1zm13 0v1h-1v-2h1zm29-26h1v1h-1zm-37 2v1h-1v-1zm-1 11v1h-1v-1zm25 17h1v1h-1zm-26 7v1h-1v-1z",
    fill: "#e1e0e4"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M15 45v2h-1v-1h-1v-2h1v1zm-2 3h3v1h-1v1h-1v-1h-1zm1-7v1h-1v-1zm0 9v1h-1v-1z",
    fill: "#d1ccc8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M12 101v-1h2v1h-1zm0-48h-1v-1h1zm-2 16h1v1h-1zm0 7h1v1h-1zm0 2h1v1h-1zm3 13h1v1h-1zm-1 2h-1v-1h1zm0 15h1v1h-1zm2 1v1h-1v-1z",
    fill: "#cdc5c2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M30 57v-3h1v3zm-5-1v-1h2v2h-1v-1zm-1 1h1v1h-1zm1 1h1v1h-1zm8 0v1h-1v-1zm-10 6h1v1h-1z",
    fill: "#ede9ea"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M12 105v-1h1v2h-1zm7-11v1h-1v-1zm-2 3v-1h1v1zm-5 0v1h-1v-1zm6 1v1h-1v-1zm-2 3v1h-1v-1zm-1 2h-1v-1h1zm1 0v-1h1v1zm-1 5v-1h1v1z",
    fill: "#c8bebc"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M41 41v1h-3v-1zM16 17h-1v-1h1zm10 1v-1h1v1zm-3 6v-1h1v1zm26 17h1v1h-1zm-2 2v1h-1v-1zm-11 3v-1h1v1z",
    fill: "#e6e5ea"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v1h-1v-2h1zM23 17v-1h1v1zm-2 15v-1h1v1zm30 4v1h-1v-1zM20 50h-1v-1h1zm30 22h-1v-1h1zm-16 2v1h-1v-1zm7 35v1h-1v-1z",
    fill: "#dcdbe0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M42 97v-2h1v2zM25 17h-1v-1h1zm34 25h-1v-1h1zm-3 29h-1v-1h1zM39 88v1h-1v-1zm19 5h-1v-1h1zm-13 2h1v1h-1zm-14 10v-1h1v1z",
    fill: "#d8d7dc"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M54 47v-1h3v1zm7-30v-1h1v1zm3 2v-1h1v1zm1 8h-1v-1h1zm-4 1h1v1h-1zm0 7v-1h1v1zm-6 19v1h-1v-1z",
    fill: "#d6d6de"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M18 27v1h-1v-1zm4 4h-1v-1h1zm19 7h-1v-1h1zm-8 1v-1h1v1zm14 16h-1v-1h1zm-3 2v-1h1v1zm3 16v1h-1v-1zm18 32h-1v-1h1zm-15 3v-1h1v1z",
    fill: "#dfdee4"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M27 50v2h-1v-2zm-3-17h1v1h-1zm1 10v-1h1v1zm-3 3v-1h1v1zm0 6h1v1h-1zm20 3v-1h1v1zm0 2h-1v-1h1zm-21 2h1v1h-1z",
    fill: "#e5e3e6"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M28 43v1h-1v-2h1zm-8 15h-1v-2h1v1zm5-23h-1v-1h1zm2 10h-1v-1h1zm-8 15h-1v-1h1zm2 1v-1h1v1zm-2 9h1v1h-1z",
    fill: "#e4e2e5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M23 43v2h-1v-2zm-4-5v1h-1v-1zm0 1h1v1h-1zm-1 3v-1h1v1zm6 0v1h-1v-1zm-2 4v1h-1v-1zm24 8h-1v-1h1zm-9 55h1v1h-1z",
    fill: "#e2e0e5"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M22 52v2h-1v-1h-1v-1zm1-11h-1v-1h1zm-2 3v-1h1v1zm-2 2v-1h1v1zm2 0v-1h1v1zm24 10h1v1h-1zM33 74v-1h1v1z",
    fill: "#dfdde2"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M65 92h1v3h-1zM21 48h-1v-1h1zm30 16h1v1h-1zm-4 2v-1h1v1zm7 1h1v1h-1zM38 90h-1v-1h1zm6 4h1v1h-1z",
    fill: "#dad8df"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M11 67v-1h1v-1h1v2zm-1-5h1v1h-1zm1 2h1v1h-1zm-2 7v-1h1v1zm3 11h1v1h-1zm1 2v-1h1v1zm0 20v-1h1v1z",
    fill: "#d2cac7"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M42 102h-3v-1h3zm3-36v-1h1v1zm2 22h1v1h-1zm-1 14v-1h1v1zm-8 1v-1h1v1zm14 0h-1v-1h1zm8 3v-1h1v1z",
    fill: "#dad8de"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18v-1h1v1zm-6 1v-1h1v1zm36 27h-1v-1h1zm-2 1h-1v-1h1zm-3 3h1v1h-1zm0 2h-1v-1h1zM35 74v-1h1v1zm23 32v1h-1v-1z",
    fill: "#dedde3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M39 104h-1v-1h2v1zM18 20v-1h1v1zm36 31h-1v-1h1zm-5 5v1h-1v-1zm-2 3v-1h1v1zm-4 43v-1h1v1zm15 4h-1v-1h1z",
    fill: "#dadae0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21v1h-1v-1zm-28 3h1v1h-1zm27 3h-1v-1h1zm13 2h1v1h-1zM11 39h-1v-1h1zM7 66v-1h1v1zm61 1v-1h1v1zM8 68v1H7v-1z",
    fill: "#fff",
    fillOpacity: 0.008
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M61 96v2h-1v-1h-1v-1zm4-70v-1h1v1zm-6 16v-1h1v1zm-1 29h1v1h-1zm2 23v1h-1v-1zm1 5h1v1h-1z",
    fill: "#d5d4da"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M19 33h-1v-1h1zm2 4v1h-1v-1zm2 0v1h-1v-1zm3 4h1v1h-1zm0 6h-1v-1h1zm14 1h-1v-1h1zm4 5v1h-1v-1zM19 71h1v1h-1z",
    fill: "#e5e3e7"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M13 40v-1h1v2h-1zm3 6v2h-1v-2zm-3-12v-1h1v1zm0 9h1v1h-1zm2 1v1h-1v-1zm0 7h-1v-1h1z",
    fill: "#d2cdc9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M32 42h1v1h-2v-2h1zm12-6h-1v-1h1zm-2 2v-1h1v1zm-10 2h1v1h-1zm5 1h-1v-1h1zm-9 40h1v1h-1z",
    fill: "#e1e1e3"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44h-1v-1h1zm-4 1h1v1h-1zm0 9v-1h1v1zm-1 0h1v1h-1zm7 0h1v1h-1zm1 3h-1v-1h1zm0 7h-1v-1h1zm-2 0h1v1h-1z",
    fill: "#d6d5dd"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M32 55v2h-1v-3h4v1zm-7 3v2h-1v-2z",
    fill: "#eeeaeb"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v-2h2v1h-1v1zm22-32h-1v-1h1zM33 35h1v1h-1zm19 6v1h-1v-1zm-12 1h1v1h-1z",
    fill: "#e7e6eb"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15v1h-1v-1zm2 7h-1v-1h1zm0 3h1v1h-1zm1 11h-1v-1h1zm4 2v1h-1v-1zm29 6v1h-1v-1zm-5 2v-1h1v1z",
    fill: "#e0e0e5"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18h-1v-1h1zm53 6v-1h1v1zm-54 0v1h-1v-1zm-2 8v-1h1v1zm37 0v1h-1v-1zM7 97v-1h1v1zm15 16v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.004
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M62 23v1h-1v-1zm0 47v1h-1v-1zm-2 24h-1v-1h1zm1 2h-1v-1h1zm0 0h1v1h-1zm0 3v-1h1v1zm2 0v1h-1v-1z",
    fill: "#d3d2d8"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M58 35v-2h1v2zm-3-7h1v1h-1zm4 2v1h-1v-1zm-4 4v1h-1v-1zm1 1v-1h1v1zm2 4h-1v-1h1z",
    fill: "#d3d1d3"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M22 33h-1v-1h1zm24 31h1v1h-1zm-4 1h1v1h-1zm9 14h-1v-1h1zm4 22v1h-1v-1zm3 1h-1v-1h1zm2 2v-1h1v1z",
    fill: "#dadbe0"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40v-1h1v1zm3-1h1v1h-1zm1 10h-1v-1h1zm24 33h1v1h-1zm-10 7h1v1h-1zm16 1v1h-1v-1zm-21 20v-1h1v1z",
    fill: "#dbd9de"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M30 97h1v2h-2v-1h1zM20 44h-1v-1h1zm0 7v1h-1v-1zm7 50v-1h1v1zm0 0v1h-1v-1z",
    fill: "#d5d3d8"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81h1v2h-1v-1zm2-38v1h-1v-1zm-4 40h1v1h-1zm1 5v-1h1v1zm-4 5h1v1h-1zm1 1h1v1h-1z",
    fill: "#d2cfd6"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49h-1v-1h1zm-6 9v-1h1v1zm0 43h1v1h-1zm-1 2h-1v-1h1zm-12 1v1h-1v-1zm5 5v-1h1v1zm-6 0v1h-1v-1z",
    fill: "#dadadf"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M13 57v-2h1v2zm-1 11v-1h1v1zm7 9h-1v-1h1zm-8 4h1v1h-1zm1 14h1v1h-1zm-2 4v-1h1v1z",
    fill: "#d1c9c7"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55v1h-1v-1zm2 1h-1v-1h1zm-1 6v-1h1v1zm1 25h-1v-1h1zm-2 2v1h-1v-1zm2 13h-1v-1h1zm13 3h1v1h-1z",
    fill: "#dad9e0"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M12 65v-2h1v2zm-3 8v-2h1v2zm3-8v1h-1v-1zm2 19v1h-1v-1zm-2 6v-1h1v1z",
    fill: "#d3cbc8"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M68 11v-1h1v1zm-42 2v1h-1v-1zm1 19h1v1h-1zm41 18h1v1h-1zm-10 59v-1h1v1zm-47 1v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.012
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14v1h-1v-1zM7 67h1v1H7zm0 8v-1h1v1zm61 13v1h-1v-1zM9 107h1v1H9zm19 6v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.016
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M36 108h2v1h-2zM25 16h1v1h-1zm22 42h-1v-1h1zM37 87h1v1h-1zm8 1h1v1h-1z",
    fill: "#dbdbdf"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45v1h-2v-1h1zm17-27h-1v-1h1zM23 28h-1v-1h1zm-2 1h-1v-1h1zm23 43h1v1h-1z",
    fill: "#dfe0e5"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M25 19h-1v-1h1zm6 18v1h-1v-1zm20 5v1h-1v-1zm-11 4h-1v-1h1zm2 0h-1v-1h1zm19 60h1v1h-1z",
    fill: "#e2e2e6"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M27 21h-1v-1h1zm28 21v-1h1v1zm-3 3v1h-1v-1zm-8 13h-1v-1h1zm-10 8h1v1h-1zm25 41h-1v-1h1z",
    fill: "#e0dfe5"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95h1v1h-2v-1zM15 23v-1h1v1zm3 9h-1v-1h1zm18 57v-1h1v1zm5 0h-1v-1h1z",
    fill: "#d9d8dc"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M21 26v1h-1v-2h1zm22 11h-1v-1h1zm-16 1h-1v-1h1zm15 0h-1v-1h1zm-11 4h-1v-1h1z",
    fill: "#e1e1e4"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25v1h-2v-1h1zm-6 8h1v1h-1zm0 1v1h-1v-1zm23 9h1v1h-1zM24 73v-1h1v1z",
    fill: "#e7e6e9"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98h-1v-2h1v1zm-3-72v-1h1v1zm5 67v1h-1v-1zm-3 2v1h-1v-1zm1 5v-1h1v1z",
    fill: "#d1d0d6"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30v-1h1v1zM21 42h1v1h-1zm30 44h-1v-1h1zm-3 5h-1v-1h1zm-9 7v-1h1v1zm-8 6v1h-1v-1z",
    fill: "#dad8dc"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M23 34v1h-1v-2h1zm30 15v1h-1v-1zm-2 44v1h-1v-1zm-6 9h-1v-1h1zm8-1v1h-1v-1z",
    fill: "#d9d9df"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v-1h1v1zm-8 61h-1v-1h1zm4 7v-1h1v1zm-3 0v1h-1v-1zm-8 2v-1h1v1zm19 2h-1v-1h1z",
    fill: "#dbd9df"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M53 34v1h-1v-1zm-2 14h-1v-1h1zm0 53h1v1h-1zm8 0v1h-1v-1zm-17 1h1v1h-1zm-5 1v1h-1v-1z",
    fill: "#dad9de"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39v-1h1v1zm0 2h-1v-1h1zm6 5h-1v-1h1zm-6 7h1v1h-1zm17 56h1v1h-1zm-5 2h-1v-1h1z",
    fill: "#e0dee3"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M61 40v-1h1v1zm-42 8v-1h1v1zm-1 0h1v1h-1zm32 13v-1h1v1zm4 32h-1v-1h1zm-27 16h-1v-1h1z",
    fill: "#d8d6dc"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M23 44h2v1h-2zm11 0v1h-1v-1zm-11 4v1h-1v-1zm-3 2v-1h1v1zm24 0h1v1h-1z",
    fill: "#e6e4e8"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M58 48v-3h1v3zm6 20h1v1h-1zm-2 10v-1h1v1zm-4 1h1v1h-1z",
    fill: "#d2d2da"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M9 77h1v3H9zm6-23v1h-1v-2h1zm-2 2h-1v-1h1z",
    fill: "#d1cac7"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M16 82v-2h1v3h-2v-1zm0-9v-2h1v2z",
    fill: "#c4b9b7"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M64 81h1v3h-1zm-2 12h1v2h-1v-1zm-1-15h-1v-1h1z",
    fill: "#cfcdd4"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M18 81h-1v-1h1zm-3 9h-1v-1h1zm0 10h1v1h-1zm-3 2h1v1h-1zm4 1h1v1h-1zm-2 4h1v1h-1z",
    fill: "#cbc1bf"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M22 102v-2h1v2zm2-13h-1v-1h1zm-2 6v1h-1v-1zm2 5h-1v-1h1zm1 1h-1v-1h1z",
    fill: "#d5d0d4"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M41 99v2h-3v-1h1v-1zm6-11v1h-1v-1z",
    fill: "#dad7de"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M67 12v2h-1v-2zM39 35v-1h2v1h-1zM26 16h1v1h-1z",
    fill: "#ebeaef"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M25 18v-1h1v2h-1zm35-4v-1h1v1zm-44 3v-1h1v1zm32 57h1v1h-1z",
    fill: "#dddce0"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M63 13v1h-1v-1zm-39 5h-1v-1h1zm-7 0v1h-1v-1zm5 12h-1v-1h1zm21 25h1v1h-1z",
    fill: "#e2e1e7"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M59 15v-1h1v1zm-35 8h-1v-1h1zm-2 3v-1h1v1zm24 16h-1v-1h1zm-7 17h1v1h-1z",
    fill: "#e3e3e8"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M65 16v-1h1v1zm-45 4h1v1h-1zm19 26h-1v-1h1zm14 62h-1v-1h1zm1-1h1v1h-1z",
    fill: "#e2e2e7"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17h1v1h-1zm7 3h1v1h-1zm-5 2h1v1h-1zm4 1h-1v-1h1zm33 21h-1v-1h1z",
    fill: "#e4e4e8"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38v1h-2v-1h1zm2-18h-1v-1h1zm-3 15v-1h1v1zm-1 2v-1h1v1z",
    fill: "#d4d2d4"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21v-1h1v1zm-1 6h1v1h-1zm1 4h1v1h-1zm26 27v-1h1v1zm6 48v1h-1v-1z",
    fill: "#dcdde3"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21v-1h1v1zm22 14v1h-1v-1zm-17 5h1v1h-1zm7 1h1v1h-1zm-6 1h1v1h-1z",
    fill: "#e2e2e4"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25h1v1h-1zm34 14v-1h1v1zm-33 1h1v1h-1zm2 11v-1h1v1zm26 36v1h-1v-1z",
    fill: "#dbdade"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M21 29v-1h1v1zm4 7h1v1h-1zm-2 11h1v1h-1zm-1 4h-1v-1h1zm1 0v1h-1v-1z",
    fill: "#e2e0e4"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M14 32v-2h1v2zm0 4v-1h1v1zm1 1v1h-1v-1zm2 5h-1v-1h1z",
    fill: "#d3cfcc"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M50 58h-1v-2h1v1zM19 31v-1h1v1zm38 12v1h-1v-1zm-2 6v1h-1v-1z",
    fill: "#d9d9e0"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M23 32v-1h1v1zm1 12h-1v-1h1zm22 8v1h-1v-1zm-3 4h-1v-1h1zM30 73v1h-1v-1z",
    fill: "#e3e1e6"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M21 33h-1v-1h1zm32 15h1v1h-1zm-3 15v1h-1v-1zm2 16h-1v-1h1zm-3 14h-1v-1h1z",
    fill: "#d8d9de"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M17 33h1v1h-1zm34 5h-1v-1h1zm-7 63v-1h1v1zm-10 3h1v1h-1zm4 1h-1v-1h1z",
    fill: "#dbdadf"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M45 53h-1v-2h2v1h-1zM21 34v1h-1v-1zm19 23h1v1h-1z",
    fill: "#e5e3e8"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M35 40v-1h3v1h-1zm-11-5h-1v-1h1zm31 6h-1v-1h1z",
    fill: "#dfdee2"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40h-2v-1h1v-1h1zm0-2v-1h1v1zm0 12v1h-1v-1z",
    fill: "#dddce1"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M62 40v1h-1v-1zm-41 4h-1v-1h1zm44 44v1h-1v-1zm-5 7v-1h1v1zm5 4v1h-1v-1z",
    fill: "#d2d0d6"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M19 59h1v2h-1v-1zm7-16v-1h1v1zm-5 11h1v1h-1zm-1 1h1v1h-1z",
    fill: "#e3e1e4"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h1v1h-1zm7 5h1v1h-1zm1 5h-1v-1h1zm0 25v1h-1v-1zm-5 3h-1v-1h1z",
    fill: "#d4d3da"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46v1h-1v-2h1zm-1 9v-1h1v2h-1zm0-11v1h-1v-1z",
    fill: "#cccbd3"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M60 46v-1h1v2h-1zm2 4v1h-1v-1zm0 21v-1h1v1zm1 0h1v1h-1z",
    fill: "#d3d1d9"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53v-1h2v1h-1zm-19-6v-1h1v1zm15 0v-1h1v1zm6 2h1v1h-1z",
    fill: "#e7e5e9"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M12 48v-1h1v1zm-2 28v1H9v-1zm7 17h1v1h-1zm-4 4h-1v-1h1zm1 13h1v1h-1z",
    fill: "#d0c9c6"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M13 51v1h-1v-1zm6 28v1h-1v-1zm-1 2h1v1h-1zm0 7v1h-1v-1zm1 11v1h-1v-1z",
    fill: "#d0c7c5"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M51 55h-1v-1h2v1zm2 0v1h-1v-1zm-5 9h1v1h-1zm0 21h1v1h-1z",
    fill: "#d9d8e0"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M22 66v1h-1v-2h1zm2-9h-1v-1h1zm-4 13h-1v-1h1zm0 6h1v1h-1z",
    fill: "#e4dfe3"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M19 60v1h-1v-1zm4 1h-1v-1h1zm14 5v1h-1v-1zm12 12h-1v-1h1zm-12 4h1v1h-1z",
    fill: "#dfdde0"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M12 64h-1v-2h1v1zm-2 5v-1h1v1zm2 13v1h-1v-1zm2 4h-1v-1h1z",
    fill: "#d4ccc9"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M16 67h-1v-5h1v2z",
    fill: "#cbc3c1"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M24 101v1h1v1h-2v-2zm29-37h1v1h-1zM28 98h-1v-1h1z",
    fill: "#d6d1d5"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M12 99v-1h2v1h-1zM9 67v-1h1v1zm3 34h-1v-1h1zm1 10v-1h1v1z",
    fill: "#cdc6c3"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M9 67h1v2H9v-1zm3 13h1v1h-1zm3 3v1h-1v-1zm4 4h1v1h-1z",
    fill: "#cfc6c4"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M15 99v-3h1v3zm1-30v1h-1v-1zm-4 34h1v1h-1z",
    fill: "#c9c0be"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M13 105h1v3h-1zm1-21h1v2h-1v-1z",
    fill: "#d0c6c4"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M21 96h1v2h-1v-1zm2-8v1h-1v-1zm-3 15h1v1h-1zm1 3v-1h1v1z",
    fill: "#d3ced2"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M34 89h1v1h-1zm32 2v1h-1v-1zm-26 7v1h-1v-1zm19 6v-1h1v1zm4 1h-1v-1h1z",
    fill: "#dad7dd"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M54 94v-2h1v2zm3-1h1v1h-2v-1zm1 2h1v1h-1z",
    fill: "#d7d6db"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M60 13v-1h1v1zM49 35v-1h1v1zm-15 0h1v1h-1zm20 7h-1v-1h1z",
    fill: "#e5e4ea"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M63 12h1v1h-1zm-41 4h-1v-1h1zm20 18v1h-1v-1zm-10 1h1v1h-1z",
    fill: "#e9e8ed"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M62 15h-1v-1h1zm-46 7h-1v-1h1zm25 65v1h-1v-1zm16 18v1h-1v-1z",
    fill: "#dcdce2"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M47 47h-1v-1h-1v-1h2zm13-31v-1h1v1z",
    fill: "#e3e2e8"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M62 16h-1v-1h1zm-45 6h1v1h-1zm23 44v-1h1v1zm11 41v-1h1v1z",
    fill: "#dbdce3"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M56 48h-2v-1h2zm8-31h1v1h-1zm-1 85v1h-1v-1z",
    fill: "#d7d7df"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M58 18v1h-1v-1zm-42 9v-1h1v1zm36 12v-1h1v1zm7-1v1h-1v-1z",
    fill: "#d4d2d5"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20h-1v-1h1zm-2 3v1h-1v-1zm29 19v1h-1v-1zm0 4h-1v-1h1z",
    fill: "#e1e1e6"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20h1v1h-1zm-2 5v-1h1v1zm6 3h1v1h-1zm10 83h-1v-1h1z",
    fill: "#dfdfe4"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M26 21v1h-1v-2h1zm-6 16v-1h1v1zm4 0v1h-1v-1z",
    fill: "#e0dee2"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M57 23h-1v-1h1zm-4 10h1v1h-1zm-24 76v1h-1v-1zm-5 3v-1h1v1z",
    fill: "#d9d7d9"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M66 22v2h-1v-2zm-22 81v1h-1v-1zm8 3h1v1h-1z",
    fill: "#dbdbe2"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M26 23v1h-1v-1zm18 12h1v1h-1zm-13 3v-1h1v1zm-6 4v-1h1v1z",
    fill: "#e2e1e4"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24h1v1h-1zm3 16v-1h1v1zm20 5h-1v-1h1zm0 2h1v1h-1z",
    fill: "#e5e3e9"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M19 35v2h-1v-2zm4-8v-1h1v1zm-1 22h-1v-1h1z",
    fill: "#e8e6ea"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M15 29h1v1h-1zm0 5h-1v-1h1zm2 8v1h-1v-1zm-4 70v-1h1v1z",
    fill: "#d1cdca"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M19 29h1v1h-1zm34 18v1h-1v-1zm-4 11v1h-1v-1zm5 43v1h-1v-1z",
    fill: "#dadae1"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M66 51v3h-1v-3zm-1-21h-1v-1h1z",
    fill: "#cdccd3"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M20 32v-1h1v1zm19 34v1h-1v-1zm8 15v-1h1v1zm-8 27v1h-1v-1z",
    fill: "#dbdbe0"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M23 32h1v1h-1zm14 13v-1h1v1zM27 75h-1v-1h1zm27 32v1h-1v-1z",
    fill: "#e4e3e7"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v3h-1v-3zm-8 30v1h-1v-1z",
    fill: "#d6d8df"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M22 33v1h-1v-1zm32 15h1v1h-1zm-6 9h1v1h-1zm6 5v-1h1v1z",
    fill: "#d8d9e0"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M64 33h2v1h-1v2h-1z",
    fill: "#c9c6cd"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36h-1v-1h1zm-19 2v1h-1v-1zm1 0h1v1h-1zm0 2h-1v-1h1z",
    fill: "#e3e3e5"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35h1v1h-2v-1zM24 97h1v1h-1zm-4 14v1h-1v-1z",
    fill: "#d4d0d1"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M57 40h-2v-1h2zm2-3h-1v-1h1zm-35 67h-1v-1h1z",
    fill: "#d3d1d4"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M25 38v-1h1v1zm14 3h-1v-1h1zm-6 32v1h-1v-1zm0 9v1h-1v-1z",
    fill: "#dfdfe3"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M18 40v-1h1v1zm2 5h1v1h-1zm1 2h1v1h-1zm3 3h-1v-1h1z",
    fill: "#e1dfe4"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M27 39h1v1h1v1h-2zm10 2h1v1h-1z",
    fill: "#e5e5e7"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M23 41v-1h1v1zm34 0h1v1h-1zm-34 9h-1v-1h1zm25 57v-1h1v1z",
    fill: "#dcdadf"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40h1v1h-2v-1zm-4 1v1h-1v-1zm3 0v1h-1v-1z",
    fill: "#e0e0e2"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M61 41v1h-1v-1zm-3 2v-1h1v1zm9 10v1h-1v-1zm-1 26v-1h1v1z",
    fill: "#d3d2d9"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M16 44h-1v-1h-1v-1h2zm0 7h-1v-1h1z",
    fill: "#d4cfcb"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42v1h-1v-1zm6 14h1v1h-1zm-21 1v1h-1v-1zm1 7v1h-1v-1z",
    fill: "#e5e4e7"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M38 42v2h-1v-1h-1v-1zM24 69h-1v-1h1z",
    fill: "#eaeaec"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M44 43v-1h3v1zm3 3h1v1h-1z",
    fill: "#e2e2e8"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v-1h1v1zm-6 11v-1h1v1zm3 32h-1v-1h1zm-6 12h-1v-1h1z",
    fill: "#d8d7de"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M66 45v-1h1v1zm-7 33v-1h1v1zm4 0h1v1h-1zm4 2h-1v-1h1z",
    fill: "#d2d0d8"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M19 46h1v1h-1zm3 4h1v1h-1zm-3 4v1h-1v-1zm30 25v1h-1v-1z",
    fill: "#dddbe0"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47v1h-1v-1zm-3 8v-1h1v1zm-1 5h1v1h-1zm-3 4h1v1h-1z",
    fill: "#dbdae2"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M17 48h1v1h-1zm12 49h1v1h-1zm-2 3v1h-1v-1zm-2 6h-1v-1h1z",
    fill: "#d4d2d7"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M25 49h-1v-1h1zm22 0v1h-1v-1zm-2 2v-1h1v1zm0 2v1h-1v-1z",
    fill: "#e4e2e7"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M11 56h-1v-1h1zm8 43h-1v-1h1zm-1 6v1h-1v-1zm-1 2v1h-1v-1z",
    fill: "#cdc4c1"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M16 61v-1h1v1zm0 1h1v1h-1zm4 29h-1v-1h1zm-3 10h-1v-1h1z",
    fill: "#c6bdbb"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M65 62h-1v-2h1v1zm-1 12h1v1h-1zm0 13v1h-1v-1z",
    fill: "#d1d1d9"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M16 61h1v1h-1zm1 6h1v1h-1zm0 3v-1h1v1zm-2 30v1h-1v-1z",
    fill: "#c6bdba"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M22 62v-1h1v1zm0 4h1v1h-1zm-1 1h1v1h-1zm-1 2h1v1h-1z",
    fill: "#e2dde1"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M16 64h1v1h-1zm-1 32v-1h1v1zm0 2v1h-1v-1zm1 4v1h-1v-1z",
    fill: "#c5bbb9"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M58 94v-1h1v2h-1zm0-23h-1v-1h1zm-2 1h-1v-1h1z",
    fill: "#d6d5da"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M60 70v2h-1v-1h-1v-1zm1 31v-1h1v1z",
    fill: "#d5d5db"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M11 78h-1v-1h1zm8 17h1v1h-1zm-1 3v-1h1v1zm-1 8v1h-1v-1z",
    fill: "#ccc4c1"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M13 96h1v2h-1v-1zm0-17v-1h1v1zm5 12v-1h1v1z",
    fill: "#cdc6c4"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M21 85v1h-1v-2h1zm1-7v1h-1v-1zm23 1v1h-1v-1z",
    fill: "#e1dbdf"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M22 81v1h-1v-1zm0 2v1h-1v-1zm2 4v1h-1v-1zm-2 6h-1v-1h1z",
    fill: "#d9d4d8"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M22 84v2h-1v-2zm2 6v-1h1v1zm1 11v1h-1v-1z",
    fill: "#d7d2d6"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M14 87v-1h1v2h-1zm3 16v-1h1v1zm-4 5h1v1h-1z",
    fill: "#cfc5c3"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M16 90h-1v-4h1v1z",
    fill: "#c2b7b5"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M15 91h-1v-1h1zm-4 5h1v1h-1zm3 9v-1h1v1zm1 1h1v1h-1z",
    fill: "#c9bfbd"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M21 91v-1h1v1zm0 3v-1h1v1zm11 2v-1h1v1zm-6 14v-1h1v1z",
    fill: "#d8d4d8"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98v-2h1v2zm1-6v1h-1v-1zm1 4h-1v-1h1z",
    fill: "#cfced4"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93h-1v-1h1zm-3 4v1h-1v-1zm1 1v1h-1v-1zm1 3h-1v-1h1z",
    fill: "#d2d1d7"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M11 93h1v1h-1zm7 3h1v1h-1zm-6 4h-1v-1h1zm2 0h-1v-1h1z",
    fill: "#cbc3c0"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M22 94h1v1h-1zm-2 6h1v1h-1zm1 5h-1v-1h1zm-1 2v-1h1v1z",
    fill: "#d1ccd0"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M64 11v-1h1v1zm4 41v-1h1v1zm1 13v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.02
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13h-1v-1h1zm-43 3v-1h1v1zm16 27v1h-1v-1z",
    fill: "#e8e7ec"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M60 17h-1v-1h1zM19 28v-1h1v1zm29 36v1h-1v-1z",
    fill: "#dadbe3"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M61 17h-1v-1h1zM51 55v1h-1v-1zm0 10h-1v-1h1z",
    fill: "#dad9e1"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M58 17v1h-1v-1zm0 20h-1v-1h1zm0 3v1h-1v-1z",
    fill: "#d5d4d7"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M60 19v-1h1v1zm7 36v1h-1v-1zm-3 9h-1v-1h1z",
    fill: "#d2d1da"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20v-1h1v1zm25 83v1h-1v-1zm12 3h1v1h-1z",
    fill: "#dbdbe1"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19h1v1h-1zm-9 38h-1v-1h1zm1 15h1v1h-1z",
    fill: "#d6d8e0"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M20 21v1h-1v-1zm1 9h-1v-1h1zm25 57v-1h1v1z",
    fill: "#dddee3"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22h-1v-1h1zM22 87h1v1h-1zm5 11h-1v-1h1z",
    fill: "#d4d1d3"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23v-1h1v1zm-3 10v1h-1v-1zm15 9h1v1h-1z",
    fill: "#e6e5e8"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M23 23v1h-1v-1zm2 2h-1v-1h1zm14 35h-1v-1h1z",
    fill: "#e5e5e9"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M58 25h-1v-1h1zm0 8v-1h1v1zm0 2h1v1h-1z",
    fill: "#d2d0d2"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M61 24v1h-1v-1zm2 6h-1v-1h1zm-1 6h1v1h-1z",
    fill: "#d2d4da"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v-1h1v1zM49 62h-1v-1h1zm1 3h-1v-1h1z",
    fill: "#d9dae1"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25v1h-1v-1zm-1 8h-1v-1h1zm57 30h-1v-1h1z",
    fill: "#d7d7d7",
    fillOpacity: 0.051
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M17 26v-1h1v1zm25 40v1h-1v-1zm1 22v-1h1v1z",
    fill: "#dcdde4"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v1h-1v-1zm0 10h-1v-1h1zM18 66v-1h1v1z",
    fill: "#d7d3d4"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27h-1v-1h1zm2 10v1h-1v-1zM26 97v1h-1v-1z",
    fill: "#d3d0d2"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M62 26h1v2h-1v-1zm0 58v1h-1v-1z",
    fill: "#cfcfd7"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27h1v1h-1zm6 15h-1v-1h1zm7 17v1h-1v-1z",
    fill: "#e8e7ea"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27v1h-1v-1zm2 5v1h-1v-1zm-40 76h1v1h-1z",
    fill: "#d2d0d1"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M54 33h2v1h-2zm2-5h1v1h-1z",
    fill: "#d4d2d3"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M65 66v2h-1v-2zm-3-38h1v1h-1z",
    fill: "#d1d2d9"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30v-1h1v1zm13 43v1h-1v-1zm8 34h1v1h-1z",
    fill: "#dddde2"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M55 30v-1h1v1zm2 3v1h-1v-1zm-36 77v1h-1v-1z",
    fill: "#d3d1d2"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M15 32v-1h1v1zm-1 11h-1v-1h1zm2 8v1h-1v-1z",
    fill: "#d1cdc9"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31h1v1h-1zm-2 22h1v1h-1zm17 4v-1h1v1z",
    fill: "#e7e4e8"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33h-1v-1h1zM19 50h-1v-1h1zm38 8h-1v-1h1z",
    fill: "#d6d6dd"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M45 34h1v1h-1zm7 7v-1h1v1zm-9 1v1h-1v-1z",
    fill: "#e4e4e7"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M14 38h-1v-3h1v1z",
    fill: "#d2cfca"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M19 36v-1h1v1zm1 31v-1h1v1zm0 2v-1h1v1z",
    fill: "#e6e1e5"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v-1h1v1zm5 5h-1v-1h1zM32 67v-1h1v1z",
    fill: "#e3e3e6"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v1h-1v-1zM33 91v-1h1v1zm-4 18h1v1h-1z",
    fill: "#d9d9db"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M17 36h1v1h-1zm26 0h1v1h-1zm-1 23h-1v-1h1z",
    fill: "#e0e0e3"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M22 37h-1v-1h1zm27 35v1h-1v-1zm-17 2h1v1h-1z",
    fill: "#dddbe1"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36h1v1h-1zM38 96v-1h1v1zm-12 9h1v1h-1z",
    fill: "#d8d8dc"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38h-1v-1h1zm-9 6h1v1h-1zm11 9v-1h1v1z",
    fill: "#e2e1e5"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38h-1v-1h2v1zm-27 71v1h-1v-1z",
    fill: "#d5d5d7"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M55 37h1v1h-2v-1zm2 1v1h-1v-1z",
    fill: "#d3d2d4"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M13 39v1h-1v-1zm2 5h-1v-1h1zm1 2h-1v-1h1z",
    fill: "#d3ceca"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M22 41h-1v-1h1zm-1 2h-1v-1h1zm43 29v1h-1v-1z",
    fill: "#d4d1d8"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M36 40v1h-1v-1zm2 1h-1v-1h1zm-3 0v1h-1v-1z",
    fill: "#dfdfe1"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M12 42h-1v-1h1zm0 9v-1h1v1zm4 62h-1v-1h1z",
    fill: "#d0c9c5"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M27 96h1v1h-2v-1zm-7-55v1h-1v-1z",
    fill: "#d5d2d8"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42h-1v-1h1zm-4 16v1h-1v-1zm19 0h1v1h-1z",
    fill: "#e4e2e6"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M42 42h-1v-1h1zm9-1v1h-1v-1zm-15 4v1h-1v-1z",
    fill: "#e7e6ea"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M53 42h-1v-1h1zm-12 5h-1v-1h1zm5 61v1h-1v-1z",
    fill: "#e4e2e8"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M62 42h-1v-1h1zm-2 0h1v1h-1zm4 20h1v1h-1z",
    fill: "#d1d0d7"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M18 44v1h-1v-1zm5 47v1h-1v-1zm1 6v1h-1v-1z",
    fill: "#d4ced2"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M26 44v1h-1v-1zm2 29h1v1h-1zm12 8h1v1h-1z",
    fill: "#e0dee1"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h1v1h-1zm-3 49v1h-1v-1zm8 11h1v1h-1z",
    fill: "#d8d8de"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M13 47v-1h1v1zm1 1v-1h1v1zm-1 1h1v1h-1z",
    fill: "#d0cbc7"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M52 46h1v1h-1zM34 88v1h-1v-1zm10 15h1v1h-1z",
    fill: "#dbdae1"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M41 48v-1h1v1zm-17 3h-1v-1h1zm20 0v1h-1v-1z",
    fill: "#e7e5ea"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54v1h-1v-2h1zm0-6v-1h1v1z",
    fill: "#d9d8df"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M21 48v1h-1v-1zm17 19v1h-1v-1zm11 10v-1h1v1z",
    fill: "#dddbe2"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M17 49v1h-1v-1zm4 61h-1v-1h1zm1 0v1h-1v-1z",
    fill: "#d4d0d2"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M17 50h1v1h-1zm45 45h1v1h-1zm2 4h-1v-1h1z",
    fill: "#d0cfd5"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M12 52h-1v-1h1zM9 62h1v1H9zm2 28h-1v-1h1z",
    fill: "#cec5c3"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M18 51v1h-1v-1zm41 14v1h-1v-1zm7 21h-1v-1h1z",
    fill: "#d6d3d9"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M27 53h-1v-1h1zm2 1h-1v-1h1zm-9 9h-1v-1h1z",
    fill: "#e8e4e8"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52v1h-1v-1zm-7 3v-1h1v1zm7 11h1v1h-1z",
    fill: "#eae6e9"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M13 54v-1h1v1zM9 86v-1h1v1zm3 18h-1v-1h1z",
    fill: "#d1c8c6"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M14 74h1v2h-1v-1zm3-20h-1v-1h1z",
    fill: "#cbc4c2"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v-1h3v1z",
    fill: "#eee9ed"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M13 54v1h-1v-1zm2 2h-1v-1h1zm-2 0v1h-1v-1z",
    fill: "#cfc8c6"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M26 55h-1v-1h1zm3 0h1v1h-1zm-3 3h-1v-1h1z",
    fill: "#ece8e9"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M69 55h-1v-1h1zm-1 9v-1h1v1zm-32 47v1h-1v-1z",
    fill: "#e5e5e5",
    fillOpacity: 0.039
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M20 79v-1h1v2h-1zm8-23h1v1h-1z",
    fill: "#e8e3e6"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M24 57v1h-1v-1zm-2 8h-1v-1h1zm-1 3h-1v-1h1z",
    fill: "#e5e0e4"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M30 58v-1h1v1zm4-1v1h-1v-1zm-10 5v1h-1v-1z",
    fill: "#ece8ea"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58h-1v-1h1zm-19 6v-1h1v1zM8 89h1v1H8z",
    fill: "#e8e5e8"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M27 58v1h-1v-1zm7 1h-1v-1h1zm-7 1v-1h1v1z",
    fill: "#ece8eb"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M53 58h1v1h-1zm-9 32h1v1h-1zm-7 2h1v1h-1z",
    fill: "#cdaeac"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M22 59h1v1h-1zm18 22v-1h1v1zm-4 1v1h-1v-1z",
    fill: "#e0dce0"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M10 61v1H9v-1zm3 22v1h-1v-1zm0 6v-1h1v1z",
    fill: "#d3cac8"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M20 62v-1h1v2h-1zm0 9h1v1h-1z",
    fill: "#e9e5e8"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M22 63h-1v-2h1v1zm-1 10h-1v-1h1z",
    fill: "#e6e2e6"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M12 63v-1h1v1zM9 83v1H8v-1zm3 21v1h-1v-1z",
    fill: "#d2cac8"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M63 62v1h-1v-1zm1 20h-1v-1h1zm2 3h-1v-1h1z",
    fill: "#d4d1d9"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M9 64v-1h1v1zm7 45v-1h1v1zm-1 2v1h-1v-1z",
    fill: "#cdc5c1"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M16 67v-2h1v2zm-1 26v1h-1v-1z",
    fill: "#c5bbba"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M37 67v-1h1v1zm-4 14v1h-1v-1zm15 0h1v1h-1z",
    fill: "#dedadf"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M51 66h1v1h-1zm-15 6h1v1h-1zm1 3h1v1h-1z",
    fill: "#ded1d5"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M15 67h1v1h-1zm-3 40v-1h1v1zm4 3v1h-1v-1z",
    fill: "#cac2bf"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69h1v1h-1zm-5 23h1v1h-1zm6 8h1v1h-1z",
    fill: "#d4d2d8"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M40 73v-1h1v1zm7 6h1v1h-1zm-8 3v-1h1v1z",
    fill: "#dfdce0"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72h1v1h-1zm4 1v1h-1v-1zm-1 13v1h-1v-1z",
    fill: "#d3ccd4"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M14 73h1v1h-1zm3 32v1h-1v-1zm-5 2h1v1h-1z",
    fill: "#cbc4c1"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M15 73h1v3h-1v-1z",
    fill: "#c6c1be"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M20 74v-1h1v2h-1zm3 5v-1h1v1z",
    fill: "#e4e0e4"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M30 74v-1h1v2h-1zm9 8h-1v-1h1z",
    fill: "#dfdade"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M21 75v-1h1v1zm27-1v1h-1v-1zm-27 3v-1h1v1z",
    fill: "#ddd7db"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M16 76h1v3h-1z",
    fill: "#c3b9b6"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M52 76h1v1h-1zm-18 30v1h-1v-1zm10 0v1h-1v-1z",
    fill: "#d2bdbe"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M15 79v-1h1v1zm3 17h-1v-1h1zm0 2h-1v-1h1z",
    fill: "#c8bebd"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M48 79v-1h1v1zm2 23v1h-1v-1zm-9 7v-1h1v1z",
    fill: "#dcdce0"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M58 78h1v1h-1zm7 11v1h-1v-1zm0 2v1h-1v-1z",
    fill: "#d2d0d7"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M13 79h1v1h-1zm-2 4h-1v-1h1zm2 15h-1v-1h1z",
    fill: "#cec7c5"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M18 81v-1h1v1zm0 7h-1v-1h1zm0 1v-1h1v1z",
    fill: "#d1c7c5"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M15 81h1v1h-1zm1 3v-1h1v1zm-1 13h-1v-1h1z",
    fill: "#c5bab8"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M35 83h-1v-1h1zm-5 6v-1h1v1zm4 21v-1h1v1z",
    fill: "#dedae0"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M16 84v2h-1v-2zm0 9v1h-1v-1z",
    fill: "#c2b8b6"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M16 86h1v2h-1v-1zm3 8h-1v-1h1z",
    fill: "#c9bebc"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M19 87v1h-1v-2h1zm-7 2v1h-1v-1z",
    fill: "#d2c9c6"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M56 92h1v1h-2v-1zm-8-6v1h-1v-1z",
    fill: "#d9d9dd"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88h-1v-1h1zm-11 1h-1v-1h1zm12 2v1h-1v-1z",
    fill: "#dad9dd"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M9 89v-1h1v1zm10 0v1h-1v-1zm-2 7h-1v-1h1z",
    fill: "#d0c9c7"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M21 100v-1h1v2h-1zm34-11h-1v-1h1z",
    fill: "#d5cfd4"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M15 106v1h-1v-2h1zm1-17h1v1h-1z",
    fill: "#cac0be"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M24 89v1h-1v-1zm-2 10h1v1h-1zm0 4v1h-1v-1z",
    fill: "#d5cfd3"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M34 90h-1v-1h1zm15 0v1h-1v-1zm-20 15v-1h1v1z",
    fill: "#dad7dc"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M19 92v1h-1v-1zm-7 10v-1h1v1zm3 8v-1h1v1z",
    fill: "#ccc3c0"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92v1h-1v-1zm9 9h1v1h-1zm-33 4v-1h1v1z",
    fill: "#d8d5da"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M64 93v1h-1v-1zm0 3h-1v-1h1zm1 2h-1v-1h1z",
    fill: "#cecdd3"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96h-1v-1h1zm11 0v-1h1v1zm-5 3h1v1h-1z",
    fill: "#d8d8dd"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h1v1h-1zm6 2v-1h1v1zm-5 2v-1h1v1z",
    fill: "#d6d5db"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M11 99v-1h1v1zm3 3v-1h1v1zm1 1v1h-1v-1z",
    fill: "#c8bfbc"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M25 99h1v1h-1zm-2 2v-1h1v1zm0 2h-1v-1h1z",
    fill: "#d5d1d5"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M67 11v-1h1v1zM35 34v-1h1v1z",
    fill: "#ebebeb",
    fillOpacity: 0.102
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M69 11v1h-1v-1zm-1 75v1h-1v-1z",
    fill: "#ddd",
    fillOpacity: 0.059
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M63 13h-1v-1h1zm-42 2v1h-1v-1z",
    fill: "#eae9ee"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M26 14v-1h1v1zm43 44h-1v-1h1z",
    fill: "#ececec",
    fillOpacity: 0.055
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15h-1v-1h1zm13 21h-1v-1h1z",
    fill: "#eaeaea",
    fillOpacity: 0.098
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M62 14h1v1h-1zm-45 9v1h-1v-1z",
    fill: "#e0e0e6"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15v1h-1v-1zm33 94h-1v-1h1z",
    fill: "#dbd9df",
    fillOpacity: 0.945
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M60 15v1h-1v-1zm6 5h-1v-1h1z",
    fill: "#dedfe7"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M63 16h-1v-1h1zm-46 6v1h-1v-1z",
    fill: "#dddde5"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M66 16v-1h1v1zM31 36v-1h1v1z",
    fill: "#edecf1"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M57 17v-1h1v1zM17 53h1v1h-1z",
    fill: "#d7d5d8"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M62 16h1v2h-1v-1z",
    fill: "#d8dae1"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M64 16v1h-1v-1zM52 71v1h-1v-1z",
    fill: "#dcdee5"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M64 17v-1h1v1zM52 57h-1v-1h1z",
    fill: "#dadae2"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17h1v1h-1zm7 20v1h-1v-1z",
    fill: "#e6e4ea"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17h1v1h-1zM8 66v1H7v-1z",
    fill: "#ccc",
    fillOpacity: 0.02
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M56 18v-1h1v1zm-31 86h1v1h-1z",
    fill: "#d8d5d9"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M59 17h1v1h-1zm5 9v1h-1v-1z",
    fill: "#d2d3db"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18h1v1h-1zm22 29h1v1h-1z",
    fill: "#e6e5e9"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M29 19h-1v-1h1zm14 91v1h-1v-1z",
    fill: "#e6e6e6",
    fillOpacity: 0.082
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M56 18h1v1h-1zM42 73v1h-1v-1z",
    fill: "#dedbdf"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M60 18v1h-1v-1zm3 6v-1h1v1z",
    fill: "#d0d1d8"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M61 18h1v1h-1zm3 58v-1h1v1z",
    fill: "#d0d0d8"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18h1v1h-1zm2 3h-1v-1h1z",
    fill: "#d5d7df"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19v1h-1v-1zm2 8v-1h1v1z",
    fill: "#dadde3"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20h-1v-1h1zm42 86v1h-1v-1z",
    fill: "#e2e0e6"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19h1v1h-1zm26 68v-1h1v1z",
    fill: "#dcdde2"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19h1v1h-1zm3 4h-1v-1h1z",
    fill: "#e1e1e5"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20h-1v-1h1zm0 1v1h-1v-1z",
    fill: "#e4e5e8"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20v-1h1v1zm-5 38v1h-1v-1z",
    fill: "#e3e2e4"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M26 19h1v1h-1zm17 54v-1h1v1z",
    fill: "#dfdfe5"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19v1h-1v-1zM22 39v1h-1v-1z",
    fill: "#d5d3d9"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19v1h-1v-1zm-8 38v-1h1v1z",
    fill: "#d4d4db"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M28 20h1v1h-1zm21 89h1v1h-1z",
    fill: "#dedede",
    fillOpacity: 0.122
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21h-1v-1h1zM29 82v-1h1v1z",
    fill: "#dedcde"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M63 20v2h-1v-2z",
    fill: "#d8dbe2"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M64 21v1h-1v-2h1z",
    fill: "#d2d3da"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21h1v1h-1zm12 21h-1v-1h1z",
    fill: "#e0dfe2"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M29 22h-1v-1h1zM7 95h1v1H7z",
    fill: "#ebebeb",
    fillOpacity: 0.051
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M59 22v-1h1v1zm0 1h1v1h-1z",
    fill: "#cbcace"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22h1v1h-1zm29 51v1h-1v-1z",
    fill: "#dedee3"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23v-1h1v1zm9 18v1h-1v-1z",
    fill: "#e0e0e1"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M55 23h-1v-1h1zM33 34v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.027
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23v-1h1v1zm4 62v-1h1v1z",
    fill: "#d0d0d5"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23h-1v-1h1zm1 0h1v1h-1z",
    fill: "#d5d8de"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23v-1h1v1zm0 9v-1h1v1z",
    fill: "#d1d2da"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M17 23h1v1h-1zm32 44h1v1h-1z",
    fill: "#dadce3"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M56 23h1v1h-1zM24 82v1h-1v-1z",
    fill: "#d7d5d6"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v1h-1v-1zm0 8h-1v-1h1z",
    fill: "#d2d1d1"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24h1v1h-1zm9 88h-1v-1h1z",
    fill: "#dbd8d8"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25h-1v-1h1zm41 9h1v1h-1z",
    fill: "#d3d2d2"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M23 25v-1h1v1zm17 20h-1v-1h1z",
    fill: "#e6e6e9"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M56 25v-1h1v1zm0 7h-1v-1h1z",
    fill: "#d5d3d4"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h-1v-1h1zM11 95v1h-1v-1z",
    fill: "#d2cdcc"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26h-1v-1h1zm41 3v-1h1v1z",
    fill: "#d1cfcf"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M25 26v-1h1v1zm20 15v1h-1v-1z",
    fill: "#e4e4e9"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v-1h1v1zM24 94v1h-1v-1z",
    fill: "#d4d1d4"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M62 26v-1h1v1zm0 12h1v1h-1z",
    fill: "#cfd0d8"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26v1h-1v-1zm31 37v-1h1v1z",
    fill: "#dadbe1"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26v1h-1v-1zm27 20v1h-1v-1z",
    fill: "#e0e1e6"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M55 26h1v1h-1zM33 83v-1h1v1z",
    fill: "#dcdadb"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M66 26v1h-1v-1zm-7 59h-1v-1h1z",
    fill: "#d3d1d7"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27h1v1h-1zm2 4v1h-1v-1z",
    fill: "#d6d4d5"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M57 28h-1v-1h1zM24 87h-1v-1h1z",
    fill: "#d6d3d4"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28v-1h1v1zm1 11v1h-1v-1z",
    fill: "#d2cfd1"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M63 27h1v1h-1zm2 32h-1v-1h1z",
    fill: "#d0d1d9"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27v1h-1v-1zm-5 52v1h-1v-1z",
    fill: "#d1d3da"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M14 28h1v1h-1zm4 85v-1h1v1z",
    fill: "#d3d1ce"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M19 28v1h-1v-1zm26 79v1h-1v-1z",
    fill: "#dddde3"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M55 29h-1v-1h1zM20 54h1v1h-1z",
    fill: "#dddbde"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M14 29h1v1h-1zm1 6v-1h1v1z",
    fill: "#d4d0cd"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29h1v1h-1zm-2 2v-1h1v1z",
    fill: "#d3d1d0"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30h-1v-1h1zm0 1v1h-1v-1z",
    fill: "#d5d5de"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M15 31v-1h1v1zm1 13v-1h1v1z",
    fill: "#d0ccc9"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M17 31v-1h1v1zm32 77v1h-1v-1z",
    fill: "#dbdbde"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M21 31h-1v-1h1zm26 77v-1h1v1z",
    fill: "#dcdce1"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30v1h-1v-1zm17 27h1v1h-1z",
    fill: "#e3e1e7"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30h1v1h-1zm-4 49h-1v-1h1z",
    fill: "#d3d5db"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31v-1h1v2h-1z",
    fill: "#cac9d0"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v1h-1v-1zM9 45h1v1H9z",
    fill: "#bfbfbf",
    fillOpacity: 0.016
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M17 32h-1v-1h1zm0 23h1v1h-1z",
    fill: "#d2cecd"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M54 31h1v1h-1zm-3 7h1v1h-1z",
    fill: "#d8d6d9"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v-1h1v1zm2 8h-1v-1h1z",
    fill: "#cbc7ce"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32v1h-1v-1zm-2 2h1v1h-1z",
    fill: "#d2cecb"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M17 34h-1v-2h1v1z",
    fill: "#d4d0d0"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M26 32v1h-1v-1zm6 17v1h-1v-1z",
    fill: "#edebee"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h1v1h-1zm11 76h1v1h-1z",
    fill: "#f0f0f0",
    fillOpacity: 0.067
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33v-1h1v1zM39 94h1v1h-1z",
    fill: "#d9d7da"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M55 32v1h-1v-1zm2 1h-1v-1h1z",
    fill: "#d4d3d2"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M56 33h-1v-1h1zm2 1h-1v-1h1z",
    fill: "#d3d1d1"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33h1v1h-1zm-8 26h1v1h-1z",
    fill: "#e8e8eb"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M59 33h1v1h-1zm0 8h-1v-1h1z",
    fill: "#d1cfd1"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35h-1v-2h1v1z",
    fill: "#cdcbcc"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M19 34h1v1h-1zm10 20v1h-1v-1z",
    fill: "#e6e2e5"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M22 35h-1v-1h1zm31 36h1v1h-1z",
    fill: "#d9d8e1"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M44 34v1h-1v-1zm6 10h1v1h-1z",
    fill: "#e4e3e9"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35v-1h1v1zm-8 25h-1v-1h1z",
    fill: "#e7e7ea"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M48 35h-1v-1h1zM29 67h-1v-1h1z",
    fill: "#eaeaed"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M64 35h-1v-1h1zm1 61v1h-1v-1z",
    fill: "#cecdd4"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34h1v1h-1zm0 4v-1h1v1z",
    fill: "#c7c4cb"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M13 36h-1v-1h1zm1 15h1v1h-1z",
    fill: "#d4d0cb"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M15 37v-2h1v2z",
    fill: "#d5d0ce"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M17 36v-1h1v1zm24 1v-1h1v1z",
    fill: "#e0dfe3"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M25 36h-1v-1h1zm0 9h1v1h-1z",
    fill: "#e1dfe3"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35h1v1h-1zm-7 29h-1v-1h1z",
    fill: "#d8d7df"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v-1h1v1zm-5 36h-1v-1h1z",
    fill: "#d5d6dd"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M63 36v-1h1v1zm0 5v-1h1v1z",
    fill: "#cbcad1"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M65 36v-1h1v1zm1 3h-1v-1h1z",
    fill: "#c8c4cb"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M12 36h1v2h-1v-1z",
    fill: "#d7d2cd"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M27 37h-1v-1h1zm1 2v-1h1v1z",
    fill: "#e3e2e5"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h-1v-1h1zm-34 67v-1h1v1z",
    fill: "#d3d0d3"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M65 37h-1v-1h1zm0 2h1v1h-1z",
    fill: "#c8c5cc"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M19 37v1h-1v-1zm19 7h1v1h-1z",
    fill: "#e5e4e8"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M51 37h1v1h-1zm-26 72v-1h1v1z",
    fill: "#d6d6d9"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h1v1h-1zm-2 2h-1v-1h1z",
    fill: "#d5d4d6"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M63 38v-1h1v1zm-2 40v1h-1v-1z",
    fill: "#cdcbd3"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h1v2h-1v-1z",
    fill: "#cac7ce"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M15 39v1h-1v-2h1z",
    fill: "#d5d0cd"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M15 40v-2h1v2z",
    fill: "#d8d3cf"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M60 38h1v1h-1zM18 59v1h-1v-1z",
    fill: "#cecac8"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M54 40v-1h1v1zm-30 67v-1h1v1z",
    fill: "#d6d4d7"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M59 40v-1h1v1zM11 98h-1v-1h1z",
    fill: "#d0cbcb"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v-1h1v1zM20 97v-1h1v1z",
    fill: "#cdc7c8"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M63 40h-1v-1h1zm2 17v1h-1v-1z",
    fill: "#ceced6"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39v2h-1v-2z",
    fill: "#c9c8ce"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M14 42v-2h1v2z",
    fill: "#d4cfcc"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40h1v1h-1zm45 58v1h-1v-1z",
    fill: "#d0ced4"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40v1h-1v-1zm-46 1v1h-1v-1z",
    fill: "#cdcad1"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M18 41v1h-1v-1zm30 52h-1v-1h1z",
    fill: "#dad7db"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M22 41h1v1h-1zm27 35h-1v-1h1z",
    fill: "#dfdce2"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M24 41h1v2h-1v-1z",
    fill: "#e1dfe2"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41h1v1h-1zM31 66h1v1h-1z",
    fill: "#e7e7eb"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M47 41v1h-1v-1zm1 5h1v1h-1z",
    fill: "#e1e2e7"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M13 42v1h-1v-1zm3 3h1v1h-1z",
    fill: "#cfc9c6"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M23 43h-1v-1h1zm11 2v-1h1v1z",
    fill: "#e3e1e5"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43h-1v-1h1zm3 4v1h-1v-1z",
    fill: "#e9e8ec"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43v-1h1v1zm-3 44v-1h1v1z",
    fill: "#ceccd5"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42v2h-1v-2z",
    fill: "#cbcad2"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44v-1h1v1zm4 1v1h-1v-1z",
    fill: "#ebe9eb"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M36 44h-1v-1h1zm5 0v1h-1v-1z",
    fill: "#e8e8ea"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43h1v1h-1zM37 81h-1v-1h1z",
    fill: "#dedee2"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M55 43h1v1h-1zM44 58v-1h1v1z",
    fill: "#e0e1e5"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M22 44v1h-1v-1zm15 21h1v1h-1z",
    fill: "#e1dfe5"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M32 45v-1h1v1zm10 0v-1h1v1z",
    fill: "#e8e7eb"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45h-1v-1h1zm2 19v-1h1v1z",
    fill: "#d4d5dc"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M10 47H9v-1h1zm-2 8v-1h1v1z",
    fill: "#ccc",
    fillOpacity: 0.078
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M19 47h-1v-1h1zm46 41v-1h1v1z",
    fill: "#d7d4da"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M12 47v1h-1v-1zm6 54h1v1h-1z",
    fill: "#cfc8c4"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M14 47v1h-1v-1zm1 6v-1h1v1z",
    fill: "#cfcac6"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M17 47h1v1h-1zm5 43v-1h1v1z",
    fill: "#d4ced1"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M23 48h-1v-1h1zm2 0v-1h1v1z",
    fill: "#eae8ec"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M45 49v-1h1v1zm-21 1h1v1h-1z",
    fill: "#e9e7ec"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M13 49v1h-1v-1zm0 5h-1v-1h1z",
    fill: "#cfc8c5"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M12 50v1h-1v-1zm2 40v1h-1v-1z",
    fill: "#cec5c2"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M14 52h-1v-1h1zm1 1h-1v-1h1z",
    fill: "#d1cbc8"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M27 52h1v1h-1zm6 15v1h-1v-1z",
    fill: "#e5e2e5"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M34 53h-2v-1h2z",
    fill: "#ede9ed"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M35 53h-1v-1h1zm-4 0h1v1h-1z",
    fill: "#edeaed"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M66 52h1v1h-1zm-4 49v-1h1v1z",
    fill: "#d4d3d9"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M69 52v1h-1v-1zm-26 58h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.024
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M21 53v1h-1v-1zm28 38v1h-1v-1z",
    fill: "#dbd9dd"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M28 53v1h-1v-1zm-4 2v1h-1v-1z",
    fill: "#e7e2e6"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55v-1h1v2h-1z",
    fill: "#eae6e8"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M27 55v-1h1v1zm-3 12h-1v-1h1z",
    fill: "#eae5e9"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M29 55v-1h1v1zm-4 1h1v1h-1z",
    fill: "#edeaeb"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56h-1v-1h1zm-2 1v1h-1v-1z",
    fill: "#ece9ea"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56v-1h1v1zm-8 2h1v1h-1z",
    fill: "#ece9ec"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M51 56v-1h1v1zm6 7h1v1h-1z",
    fill: "#d8d7e0"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55h1v1h-1zm1 30v-1h1v1z",
    fill: "#d7d6de"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M68 55h1v1h-1zm-4 53v-1h1v1z",
    fill: "#e9e9e9",
    fillOpacity: 0.047
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M11 56v1h-1v-1zm-1 2H9v-1h1z",
    fill: "#cec5c1"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56v1h-2v-1h1z",
    fill: "#ebe9ea"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57v-1h1v1zM24 74h1v1h-1z",
    fill: "#e2e0e3"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M53 57h-1v-1h1zm-5 27v-1h1v1z",
    fill: "#d8d8e0"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57v-1h1v1zm4 1h-1v-1h1z",
    fill: "#d5d4dd"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M27 57v1h-1v-1zm0 9v1h-1v-1z",
    fill: "#ede9ec"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57h1v1h-1zM19 73h1v1h-1z",
    fill: "#e6e3e6"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M53 57h1v1h-1zm0 17h1v1h-1z",
    fill: "#d4c1c5"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57h1v1h-1zm4 45v1h-1v-1z",
    fill: "#d6d6db"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v-1h1v1zm1 33h-1v-1h1z",
    fill: "#d1cfd7"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M15 58h1v1h-1zm4 32v-1h1v1z",
    fill: "#cdc4c3"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M17 59h-1v-1h1zm-1 46v1h-1v-1z",
    fill: "#c7bebc"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M24 59h-1v-1h1zm5 6h1v1h-1z",
    fill: "#e9e4e7"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v1h-1v-1zM22 73h-1v-1h1z",
    fill: "#ddd8dc"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58h1v1h-1zm3 11h-1v-1h1z",
    fill: "#ddd7de"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M65 58h1v1h-1zm-1 20h1v1h-1z",
    fill: "#cdcdd5"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M68 59v-1h1v1zm1 2v1h-1v-1z",
    fill: "#dfdfdf",
    fillOpacity: 0.063
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M17 60h-1v-1h1zm1 3h-1v-1h1z",
    fill: "#c6bdbc"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h-1v-1h1zm8 20h-1v-1h1z",
    fill: "#d8dbe0"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M50 59h1v1h-1zm-9 35v-1h1v1z",
    fill: "#d1b4b6"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M52 60h-1v-1h1zm1 8h-1v-1h1z",
    fill: "#d5c9cd"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M52 59h1v1h-1zm-27 48h1v1h-1z",
    fill: "#d0bfc1"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M58 59v1h-1v-1zm0 17v1h-1v-1z",
    fill: "#ceaeae"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M28 61h-1v-1h1zm-1 2v1h-1v-1z",
    fill: "#e1c0c1"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M29 60v1h-1v-1zm3 8v1h-1v-1z",
    fill: "#ddbcbb"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61h-1v-1h1zM43 91v-1h1v1z",
    fill: "#d4c3c9"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M55 61v-1h1v1zm-18 47h-1v-1h1z",
    fill: "#d0b7b8"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M59 60h1v1h-1zm-8 27h1v1h-1z",
    fill: "#cca9a8"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M61 60h1v1h-1zm-5 29h1v1h-1z",
    fill: "#c8a9a5"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M10 62v-1h1v1zm14 31h1v1h-1z",
    fill: "#d3cbc9"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M20 61v1h-1v-1zm1 4v1h-1v-1z",
    fill: "#e7e3e7"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M37 62v-1h1v1zM27 79h1v1h-1z",
    fill: "#dcc0be"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M41 61v1h-1v-1zm-6 2v-1h1v1z",
    fill: "#d7abab"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M42 62v-1h1v1zm-11 45h1v1h-1z",
    fill: "#d3bfc1"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M45 61h1v1h-1zm3 6v1h-1v-1z",
    fill: "#d8c8cb"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M47 61h1v1h-1zM31 89h1v1h-1z",
    fill: "#dbd5da"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M50 61h1v1h-1zm-15 47v1h-1v-1z",
    fill: "#d9d5da"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62v-1h1v1zM42 94v-1h1v1z",
    fill: "#d3bcbd"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62v-1h1v1zm-2 3h-1v-1h1z",
    fill: "#d2d0d9"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M19 62v1h-1v-1zm3 14h-1v-1h1z",
    fill: "#dcd6da"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M41 62v1h-1v-1zm-7 3v-1h1v1z",
    fill: "#dbb7b8"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M41 62h1v1h-1zm-8 17v-1h1v1z",
    fill: "#dbc4c5"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M42 63v-1h1v1zm12 18v1h-1v-1z",
    fill: "#d7c0c2"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M18 63v1h-1v-1zm-3 16h1v1h-1z",
    fill: "#c7bcbb"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M22 64h-1v-1h1zm-2 7v-1h1v1z",
    fill: "#e5e1e5"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M39 63h1v1h-1zm-7 8h-1v-1h1z",
    fill: "#dcc4c2"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M41 63h1v1h-1zm1 7h1v1h-1z",
    fill: "#d4b3b3"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M47 63v1h-1v-1zm-8 30v1h-1v-1z",
    fill: "#d1b2b4"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h-1v-1h1zm8 41h-1v-1h1z",
    fill: "#d2bbbf"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M57 64h-1v-1h1zm-2 13v1h-1v-1z",
    fill: "#d6d9de"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M62 64v-1h1v1zm3 37v1h-1v-1z",
    fill: "#d6d4db"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M10 65v1H9v-2h1z",
    fill: "#cec7c3"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M18 64h1v1h-1zm-7 38h-1v-1h1z",
    fill: "#d8d3d3"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M43 64v1h-1v-1zm1 23v-1h1v1z",
    fill: "#dcd1d6"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M17 66v-1h1v2h-1z",
    fill: "#c6bcb9"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M56 66h-1v-1h1zm-21 40h-1v-1h1z",
    fill: "#d4c6c8"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M35 66h1v1h-1zm-1 1h1v1h-1z",
    fill: "#e1dee4"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M40 67h-1v-1h1zm6 41h-1v-1h1z",
    fill: "#dbdce0"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66h1v1h-1zM26 89h-1v-1h1z",
    fill: "#cfacaf"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M18 67h1v1h-1zm-6 39h-1v-1h1z",
    fill: "#d3cccb"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M19 68v-1h1v2h-1z",
    fill: "#e9e4e8"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M22 67h1v1h-1zm-1 10h1v1h-1z",
    fill: "#e1dce0"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M38 68v-1h1v1zm5 36h-1v-1h1z",
    fill: "#dcdce4"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67v1h-1v-1zm-5 9v-1h1v1z",
    fill: "#d5b4b5"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67h1v1h-1zm-15 40v1h-1v-1z",
    fill: "#d3c3c5"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M63 67v1h-1v-1zm-3 22v1h-1v-1z",
    fill: "#cfc1c6"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M17 69h-1v-1h1zm0 5h-1v-1h1z",
    fill: "#c3bab9"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M21 69v-1h1v1zm17 14v-1h1v1z",
    fill: "#e0dbdf"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68h1v1h-1zm-6 4v1h-1v-1z",
    fill: "#d6b3b3"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M47 68v1h-1v-1zM37 91v1h-1v-1z",
    fill: "#d4b5b4"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M52 68h1v1h-1zm-3 37h-1v-1h1z",
    fill: "#d5c3c5"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69h-1v-1h1zm-6 34v1h-1v-1z",
    fill: "#d6c9cc"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M56 69h-1v-1h1zm-7 35v-1h1v1z",
    fill: "#d0b8bc"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M16 69h1v1h-1zm-1 26h-1v-1h1z",
    fill: "#c4bbb9"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M19 69v1h-1v-1zm0 5h-1v-1h1z",
    fill: "#d2cbcb"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M21 69h1v1h-1zm1 4v1h-1v-1z",
    fill: "#dcd7db"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M30 69h1v1h-1zm15 9h1v1h-1z",
    fill: "#dcc2c3"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M46 70v-1h1v1zm-9 36v1h-1v-1z",
    fill: "#d4bfc2"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h1v1h-1zm1 33v1h-1v-1z",
    fill: "#dcdbe2"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M52 71v-2h1v2z",
    fill: "#d5bdc0"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69h1v1h-1zm-1 10h-1v-1h1z",
    fill: "#d8dadf"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M16 71v1h-1v-2h1z",
    fill: "#c8bfbe"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M17 70h1v1h-1zm1 3h-1v-1h1z",
    fill: "#c7bdb9"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M21 71v-1h1v1zm0 12v-1h1v1z",
    fill: "#dad5d9"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M22 70h1v1h-1zm15 12v1h-1v-1z",
    fill: "#e1ddde"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71h-1v-1h1zm-3 19h-1v-1h1z",
    fill: "#ceaead"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M57 70v1h-1v-1zm-6 16h1v1h-1z",
    fill: "#d8d4d9"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M18 71h1v2h-1v-1z",
    fill: "#d6d0d1"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M21 71h1v1h-1zm0 10v-1h1v1z",
    fill: "#dbd6da"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M44 71v1h-1v-1zm-6 8h1v1h-1z",
    fill: "#dabebf"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72v-1h1v1zM31 96v1h-1v-1z",
    fill: "#d4d3d8"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M39 72h1v1h-1zm-8 33h1v1h-1z",
    fill: "#dbd5d9"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M41 72h1v1h-1zm-5 1h1v1h-1z",
    fill: "#dfdbe3"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M43 72v2h-1v-2z",
    fill: "#e0dce3"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M47 72v1h-1v-1zm-12 2h1v1h-1z",
    fill: "#dedde0"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M55 72v1h-1v-1zM33 93h1v1h-1z",
    fill: "#c9a09f"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M55 72h1v1h-1zm5 30v-1h1v1z",
    fill: "#d6cdd3"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M22 73h1v1h-1zm-1 6h1v1h-1z",
    fill: "#ded9dd"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M39 73v1h-1v-1zm10 34v1h-1v-1z",
    fill: "#dedbe1"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73h1v1h-1zm-7 8v-1h1v1z",
    fill: "#dfdce1"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M10 74v2H9v-2z",
    fill: "#d2cbca"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M17 76h-1v-2h1v1z",
    fill: "#c2b9b7"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M17 75v-1h1v1zm0 26v1h-1v-1z",
    fill: "#c7bdbb"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M23 75h-1v-1h1zm25 7h-1v-1h1z",
    fill: "#ddd9dc"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M34 74h1v1h-1zm-1 36v1h-1v-1z",
    fill: "#dddbdf"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M38 75h-1v-1h1zm5 12v1h-1v-1z",
    fill: "#dfdbdf"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M41 74v1h-1v-1zm-11 36v1h-1v-1z",
    fill: "#e0dde0"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M42 74v1h-1v-1zm-2 6v1h-1v-1z",
    fill: "#e0dde2"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74v1h-1v-1zm-7 21h-1v-1h1z",
    fill: "#d7d7de"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M7 75h1v1H7zm43 35v-1h1v1z",
    fill: "#e7e7e7",
    fillOpacity: 0.043
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M18 76h-1v-1h1zm-1 2v-1h1v1z",
    fill: "#c7beb9"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M31 75h1v1h-1zm2 1v1h-1v-1z",
    fill: "#d6b6b4"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76h-1v-1h1zm10 5h-1v-1h1z",
    fill: "#e0dce1"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75v1h-1v-1zm-12 1h1v1h-1z",
    fill: "#d8bcbd"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M50 75v1h-1v-1zm0 32v1h-1v-1z",
    fill: "#dedce3"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M56 75h1v1h-1zm-5 13h1v1h-1z",
    fill: "#d0b6b7"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M13 77v-1h1v2h-1z",
    fill: "#ccc6c3"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M15 76v1h-1v-1zm4 16h-1v-1h1z",
    fill: "#cbc5c2"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M15 76h1v1h-1zm-3 20h-1v-1h1z",
    fill: "#c8bfbd"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M22 77v-1h1v1zm27 4h-1v-1h1z",
    fill: "#e0dcdf"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M56 76v1h-1v-1zm-27 30v1h-1v-1z",
    fill: "#ccb4b6"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76h1v1h-1zm-35 31h-1v-1h1z",
    fill: "#d1c6c7"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M64 77h-1v-1h1zM29 99h-1v-1h1z",
    fill: "#d5d2d7"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M20 77h1v1h-1zm1 6h-1v-1h1z",
    fill: "#e7e2e5"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M22 77h1v1h-1zm-2 7v-1h1v1z",
    fill: "#e4dee2"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78v-1h1v1zm-8 6v-1h1v1z",
    fill: "#d5b3b3"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77h1v1h-1zm-4 11h-1v-1h1z",
    fill: "#d6ccd0"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M55 78v-1h1v1zm-6 11h1v1h-1z",
    fill: "#d8d2d8"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M58 78h-1v-1h1zM26 96v1h-1v-1z",
    fill: "#d6d0d6"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M29 79h-1v-1h1zm14 0v1h-1v-1z",
    fill: "#dfd9da"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78v1h-1v-1zm6 0v1h-1v-1z",
    fill: "#dabcbc"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79h-1v-1h1zm7 22v1h-1v-1z",
    fill: "#d6d5dc"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78h1v1h-1zm8 2v1h-1v-1z",
    fill: "#d1ced6"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M17 79v1h-1v-1zm-2 4h1v1h-1z",
    fill: "#c3b8b6"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M43 80v-1h1v1zm-8 0v1h-1v-1z",
    fill: "#e1d9dd"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79v1h-1v-1zm6 23v1h-1v-1z",
    fill: "#d7d4d9"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80v-1h1v1zm1 12v1h-1v-1z",
    fill: "#d0cfd6"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M63 79v1h-1v-1zm-5 7h1v1h-1z",
    fill: "#d1cfd4"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M9 81v-1h1v1zm0 1h1v1H9z",
    fill: "#d1c9c8"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M20 80h1v2h-1v-1z",
    fill: "#e7e3e5"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M45 81v-1h1v1zm-17 1h-1v-1h1z",
    fill: "#dfdbde"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M14 82v-1h1v2h-1z",
    fill: "#cfc6c3"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M26 82v-1h1v1zm22 1h-1v-1h1z",
    fill: "#ded7db"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82h-2v-1h2z",
    fill: "#dedadd"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M45 81h1v1h-1zM8 91h1v1H8z",
    fill: "#e2e0df"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M55 82h1v1h-1zm-24 5h-1v-1h1z",
    fill: "#b52833"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83v1h-1v-1zm-1 8h-1v-1h1z",
    fill: "#d3d0d7"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M16 84h1v1h-1zm-1 14h-1v-1h1z",
    fill: "#c6bbb9"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M23 84h1v1h-1zm1 2v-1h1v1z",
    fill: "#d7c4c5"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84h1v1h-1zm2 7v1h-1v-1z",
    fill: "#d6d1d4"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M55 84h1v1h-1zm0 2v1h-1v-1z",
    fill: "#d1c3c6"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M64 85v-1h1v1zm-3 8h1v1h-1z",
    fill: "#d0cdd4"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M23 86h-1v-1h1zm32 1h1v1h-1z",
    fill: "#d5d2d4"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M58 85h1v1h-1zm6 9h1v1h-1z",
    fill: "#cfced5"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M65 86v1h-1v-2h1z",
    fill: "#d1ced5"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M13 87v-1h1v2h-1z",
    fill: "#d5cbc9"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M19 87v-1h1v1zm1 6v-1h1v1z",
    fill: "#cfc7c6"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M52 86h1v1h-1zM31 96h-1v-1h1z",
    fill: "#d4cbcf"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86v1h-1v-1zm1 6h1v1h-1z",
    fill: "#d2d2d8"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M48 88h-1v-1h1zm0 2v-1h1v1z",
    fill: "#dbd8df"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87h1v1h-1zm-1 14h1v1h-1z",
    fill: "#e2e2e2",
    fillOpacity: 0.035
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M14 88h1v1h-1zm3 5h-1v-1h1z",
    fill: "#cdc3c1"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88v1h-1v-1zm-5 21h1v1h-1z",
    fill: "#d8dadd"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M37 89v-1h1v1zm10 4v1h-1v-1z",
    fill: "#dad7d9"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M39 88h1v1h-1zm-1 16h1v1h-1z",
    fill: "#d9d7db"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M62 89h-1v-1h1zm-38 6v-1h1v1z",
    fill: "#ccb6b8"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M17 89h1v2h-1v-1z",
    fill: "#cec9c5"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M22 90h-1v-1h1zm6 0h-1v-1h1z",
    fill: "#d8d4d7"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M26 90v-1h1v1zm38 15h-1v-1h1z",
    fill: "#d7d7dc"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M50 89h1v1h-1zm2 15h-1v-1h1z",
    fill: "#ceb4b3"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M40 90h1v1h-1zm-11 2v-1h1v1z",
    fill: "#d1b3b6"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M47 90v1h-1v-1zm-7 18v-1h1v1z",
    fill: "#d9d3d7"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M50 91v-1h1v1zm1 0h1v1h-1z",
    fill: "#d0b6b6"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M51 91v-1h1v1zm-10 13v1h-1v-1z",
    fill: "#d7c9cd"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91h-1v-1h1zm0 12v-1h1v1z",
    fill: "#d2c0c3"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91v-1h1v1zm-37 14v-1h1v1z",
    fill: "#d9d6dc"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M15 91v1h-1v-1zm1 17v1h-1v-1z",
    fill: "#c7bebb"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M16 91h1v1h-1zm-1 8h1v1h-1z",
    fill: "#cbc2bf"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M21 91h1v1h-1zm7 9v-1h1v1z",
    fill: "#d7d3d8"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M30 91h1v1h-1zm13 14v-1h1v1z",
    fill: "#cdb1b2"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M33 91h1v1h-1zm-3 4v1h-1v-1z",
    fill: "#d3bfc3"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M46 92v-1h1v1zm-1 12h1v1h-1z",
    fill: "#d1bbbe"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M51 92h-1v-1h1zm-26 0v1h-1v-1z",
    fill: "#cca9a7"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M11 93h-1v-1h1zm10 1v1h-1v-1z",
    fill: "#ccc6c4"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M19 93v-1h1v1zm-4 11h1v1h-1z",
    fill: "#c5bbb8"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M22 92h1v1h-1zm-1 10v1h-1v-1z",
    fill: "#d4cfd3"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M25 92h1v1h-1zm2 1v1h-1v-1z",
    fill: "#cab5b6"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M30 93h-1v-1h1zm22 10h1v1h-1z",
    fill: "#ceb7b8"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M50 93v-1h1v1zm-16 13h-1v-1h1z",
    fill: "#d6cace"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M17 94h-1v-1h1zm-3 2h-1v-1h1z",
    fill: "#cdc7c4"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M24 94h-1v-1h1zm0 2v1h-1v-1z",
    fill: "#d2cfd2"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93h1v1h-1zm3 14h-1v-1h1z",
    fill: "#d3bec2"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M45 94h-1v-1h1zM9 94h1v1H9z",
    fill: "#dad4d6"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M11 94h1v1h-1zm6 5v1h-1v-1z",
    fill: "#c9c1be"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M16 95h-1v-1h1zm-1 8h1v1h-1z",
    fill: "#c3b9b7"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M17 94h1v1h-1zm0 10v1h-1v-1z",
    fill: "#ccc5c1"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M22 95h-1v-1h1zm3 7v-1h1v1z",
    fill: "#d4d1d5"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h1v1h-1zm13 10h1v1h-1z",
    fill: "#d9d7de"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M20 98h-1v-2h1v1z",
    fill: "#ccc4c0"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M23 96v1h-1v-1zm-3 15h-1v-1h1z",
    fill: "#d3ced0"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96h1v1h-1zm-2 5v1h-1v-1z",
    fill: "#d5d0d5"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M29 97v-1h1v1zm34 5v-1h1v1z",
    fill: "#d4d4d9"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M22 98v1h-1v-1zm-1 4h-1v-1h1z",
    fill: "#d4ced3"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M27 98h1v1h-1zm-2 2h1v1h-1z",
    fill: "#d5d2d6"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M27 99h1v1h-2v-1z",
    fill: "#d6d1d7"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M18 101h-1v-1h1zm-3 7v1h-1v-1z",
    fill: "#ccc2c0"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M9 101h1v1H9zm14 10h1v1h-1z",
    fill: "#dbd9da"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M50 101h1v1h-1zm-6 1v1h-1v-1z",
    fill: "#dbd9e0"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M57 102h-1v-1h1zm-10 5v1h-1v-1z",
    fill: "#dbdce1"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103v-1h1v1zm20 1h1v1h-1z",
    fill: "#d9d9de"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M53 102h1v1h-1zm1 3v1h-1v-1z",
    fill: "#dad2d8"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M32 105v-1h1v1zm0 4v1h-1v-1z",
    fill: "#d9dade"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M50 104v1h-1v-1zm-18 4h1v1h-1z",
    fill: "#d4c4c5"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M20 106v-1h1v1zm-1 1v-1h1v1z",
    fill: "#d0cbcf"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M12 106v1h-1v-1zm4 7v-1h1v1z",
    fill: "#d6d1cf"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M23 106h1v1h-1zm-1 4h-1v-1h1z",
    fill: "#cfbdbe"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M40 107h-1v-1h1zm-11 1h-1v-1h1z",
    fill: "#d3bdbd"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M21 108h-1v-1h1zm-3 1h1v1h-1z",
    fill: "#d1cdd0"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M55 109h-1v-1h1zm-16 1h1v1h-1z",
    fill: "#dddde0",
    fillOpacity: 0.388
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M11 113v-1h1v1zm16 0v-1h1v1z",
    fill: "#d4d4d4",
    fillOpacity: 0.071
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M65 10h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.043
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M66 10h1v1h-1z",
    fill: "#f3f3f3",
    fillOpacity: 0.086
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M58 12h-1v-1h1z",
    fill: "#e5e5f2",
    fillOpacity: 0.078
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M58 11h1v1h-1z",
    fill: "#e3e3e6",
    fillOpacity: 0.361
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M60 12h-1v-1h1z",
    fill: "#e1e1e6",
    fillOpacity: 0.447
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M60 11h1v1h-1z",
    fill: "#e2e2e6",
    fillOpacity: 0.525
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M62 11v1h-1v-1z",
    fill: "#e2e1e6",
    fillOpacity: 0.6
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M62 12v-1h1v1z",
    fill: "#e6e4e9",
    fillOpacity: 0.69
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M64 11v1h-1v-1z",
    fill: "#e5e5e9",
    fillOpacity: 0.757
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M64 12v-1h1v1z",
    fill: "#e3e3e7",
    fillOpacity: 0.812
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M66 12h-1v-1h1z",
    fill: "#e1e0e5",
    fillOpacity: 0.859
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M66 11h1v1h-1z",
    fill: "#e5e4e9",
    fillOpacity: 0.91
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M68 12h-1v-1h1z",
    fill: "#e1e0e4",
    fillOpacity: 0.824
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M57 12h1v1h-1z",
    fill: "#e2e2e5",
    fillOpacity: 0.424
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M58 13v-1h1v1z",
    fill: "#eaeaee"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M59 13v-1h1v1z",
    fill: "#e1e0e7"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M68 12v1h-1v-1z",
    fill: "#dfdfe2",
    fillOpacity: 0.784
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M69 13h-1v-1h1z",
    fill: "#7f7f7f",
    fillOpacity: 0.008
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M27 13h1v1h-1z",
    fill: "#dfdfdf",
    fillOpacity: 0.031
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M57 13v1h-1v-1z",
    fill: "#dadada",
    fillOpacity: 0.027
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M57 14v-1h1v1z",
    fill: "#d8d8dc",
    fillOpacity: 0.761
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M67 14v-1h1v1z",
    fill: "#dbd9dc",
    fillOpacity: 0.675
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15h-1v-1h1z",
    fill: "#e7e7ef",
    fillOpacity: 0.125
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14v1h-1v-1z",
    fill: "#e2e2e7",
    fillOpacity: 0.173
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15v-1h1v1z",
    fill: "#e3e3e3",
    fillOpacity: 0.251
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14h1v1h-1z",
    fill: "#e6e3e6",
    fillOpacity: 0.325
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15h-1v-1h1z",
    fill: "#e6e6e9",
    fillOpacity: 0.412
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15v-1h1v1z",
    fill: "#e2e2e4",
    fillOpacity: 0.494
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15h-1v-1h1z",
    fill: "#e4e4e7",
    fillOpacity: 0.6
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15v-1h1v1z",
    fill: "#e4e2e7",
    fillOpacity: 0.667
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15v-1h1v1z",
    fill: "#e2e2e7",
    fillOpacity: 0.725
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15v-1h1v1z",
    fill: "#e0e0e5",
    fillOpacity: 0.792
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15h-1v-1h1z",
    fill: "#e5e5ea",
    fillOpacity: 0.863
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15v-1h1v1z",
    fill: "#dddde1",
    fillOpacity: 0.482
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M57 14v1h-1v-1z",
    fill: "#d7d7d3",
    fillOpacity: 0.325
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15h-1v-1h1z",
    fill: "#d8d8d9"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M59 14v1h-1v-1z",
    fill: "#d9dbe0"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M66 15v-1h1v1z",
    fill: "#eeedf2"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M68 15h-1v-1h1z",
    fill: "#e6e4e8",
    fillOpacity: 0.529
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16h-1v-1h1z",
    fill: "#e1e1e3",
    fillOpacity: 0.435
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15v1h-1v-1z",
    fill: "#e1e1e6",
    fillOpacity: 0.922
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15h1v1h-1z",
    fill: "#dcdbe1",
    fillOpacity: 0.969
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16v-1h1v1z",
    fill: "#e8e8ed"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15h1v1h-1z",
    fill: "#e8e9ed"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16v-1h1v1z",
    fill: "#e6e7eb"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16h-1v-1h1z",
    fill: "#e2e3e9"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16v-1h1v1z",
    fill: "#e9e9ef"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15h1v1h-1z",
    fill: "#dcdce0",
    fillOpacity: 0.518
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M56 15h1v1h-1z",
    fill: "#d5d3d3",
    fillOpacity: 0.671
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15v1h-1v-1z",
    fill: "#dcdbda"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15h1v1h-1z",
    fill: "#d9dce1"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M63 15h1v1h-1z",
    fill: "#e1e1e7"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16v-1h1v1z",
    fill: "#e1e1e4",
    fillOpacity: 0.412
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17v-1h1v1z",
    fill: "#dee0e6",
    fillOpacity: 0.647
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17h-1v-1h1z",
    fill: "#dfdfe3",
    fillOpacity: 0.541
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M55 16h1v1h-1z",
    fill: "#d7d7d7",
    fillOpacity: 0.102
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M57 16v1h-1v-1z",
    fill: "#d4d2d5",
    fillOpacity: 0.922
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M58 17v-1h1v1z",
    fill: "#d9dae0"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M66 17h-1v-1h1z",
    fill: "#dedfe5"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16v1h-1v-1z",
    fill: "#e5e6eb"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16h1v1h-1z",
    fill: "#dfdce2",
    fillOpacity: 0.318
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18h-1v-1h1z",
    fill: "#d8d8e0",
    fillOpacity: 0.749
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18h-1v-1h1z",
    fill: "#e1e1e9"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17v1h-1v-1z",
    fill: "#e6e6e9",
    fillOpacity: 0.804
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M55 18v-1h1v1z",
    fill: "#d7d7da",
    fillOpacity: 0.302
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M58 18v-1h1v1z",
    fill: "#d4d5db"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18v-1h1v1z",
    fill: "#d9dbe2"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M65 18v-1h1v1z",
    fill: "#dedfe4"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M68 17v1h-1v-1z",
    fill: "#d5d5d9",
    fillOpacity: 0.243
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M13 18h1v1h-1z",
    fill: "#94947f",
    fillOpacity: 0.047
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19h-1v-1h1z",
    fill: "#c6c5ca",
    fillOpacity: 0.855
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18h1v1h-1z",
    fill: "#dde0e7"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19v-1h1v1z",
    fill: "#e6e6ea"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19h-1v-1h1z",
    fill: "#e3e3e6",
    fillOpacity: 0.91
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M55 18h1v1h-1z",
    fill: "#dedcde",
    fillOpacity: 0.486
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M59 19h-1v-1h1z",
    fill: "#d2d3d8"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M63 19h-1v-1h1z",
    fill: "#d8dae2"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M66 18v1h-1v-1z",
    fill: "#dfe0e6"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18v1h-1v-1z",
    fill: "#dcdce2",
    fillOpacity: 0.969
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18h1v1h-1z",
    fill: "#d3d3d3",
    fillOpacity: 0.161
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20v-1h1v1z",
    fill: "#d1d1d1",
    fillOpacity: 0.11
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19v1h-1v-1z",
    fill: "#d2d2d3",
    fillOpacity: 0.925
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M27 19h1v1h-1z",
    fill: "#e4e3e7",
    fillOpacity: 0.945
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M29 19v1h-1v-1z",
    fill: "#e6e6e6",
    fillOpacity: 0.122
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M56 19v1h-1v-1z",
    fill: "#e3e1e3",
    fillOpacity: 0.612
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M57 20h-1v-1h1z",
    fill: "#e0dee0"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M59 20h-1v-1h1z",
    fill: "#d1d1d5"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h-1v-1h1z",
    fill: "#d0ced8"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19h1v1h-1z",
    fill: "#ced0d6"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M62 19h1v1h-1z",
    fill: "#d7dae1"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20h-1v-1h1z",
    fill: "#dbdadf",
    fillOpacity: 0.922
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M67 19h1v1h-1z",
    fill: "#c9c9c9",
    fillOpacity: 0.094
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20h1v1h-1z",
    fill: "#d2d2d2",
    fillOpacity: 0.2
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21v-1h1v1z",
    fill: "#d4d4d2",
    fillOpacity: 0.984
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20h1v1h-1z",
    fill: "#dbdde3"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20v1h-1v-1z",
    fill: "#d8dbe1"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M27 20h1v1h-1z",
    fill: "#e1e1e4",
    fillOpacity: 0.945
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M55 20h1v1h-1z",
    fill: "#dfdee1",
    fillOpacity: 0.702
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21v-1h1v1z",
    fill: "#d6d2d6"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M59 21h-1v-1h1z",
    fill: "#d1cfd3"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20v1h-1v-1z",
    fill: "#ccc9d0"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h1v1h-1z",
    fill: "#cac6c9"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M62 21h-1v-1h1z",
    fill: "#ccccd2"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21v-1h1v1z",
    fill: "#dbdde5"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20v1h-1v-1z",
    fill: "#d8d6db",
    fillOpacity: 0.875
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v-1h1v1z",
    fill: "#c8c8c8",
    fillOpacity: 0.055
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M13 21h1v1h-1z",
    fill: "#d7d4d1",
    fillOpacity: 0.329
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22v-1h1v1z",
    fill: "#d9d7d5"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22v-1h1v1z",
    fill: "#d8dbe3"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M27 22v-1h1v1z",
    fill: "#dcdcdf",
    fillOpacity: 0.871
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21h1v1h-1z",
    fill: "#d9d8db",
    fillOpacity: 0.78
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M57 22h-1v-1h1z",
    fill: "#dad8da"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M58 21h1v1h-1z",
    fill: "#cfcfd0"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M61 22h-1v-1h1z",
    fill: "#c5c1c1"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22h-1v-1h1z",
    fill: "#d0ced2"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22h-1v-1h1z",
    fill: "#d4d6de"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21h1v1h-1z",
    fill: "#dadce4"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v1h-1v-1z",
    fill: "#cecdd2",
    fillOpacity: 0.831
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M67 22v-1h1v1z",
    fill: "#d4d4aa",
    fillOpacity: 0.024
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M13 22h1v1h-1z",
    fill: "#d4d2d0",
    fillOpacity: 0.475
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22v1h-1v-1z",
    fill: "#dcd9d8"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M27 22h1v1h-1z",
    fill: "#dfdfe3",
    fillOpacity: 0.627
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M56 22v1h-1v-1z",
    fill: "#d5d4d5",
    fillOpacity: 0.827
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22v1h-1v-1z",
    fill: "#d2d1d0"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v-1h1v1z",
    fill: "#d1d0d1"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M60 22h1v1h-1z",
    fill: "#d3d3d6"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v-1h1v1z",
    fill: "#cac9cd"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22v1h-1v-1z",
    fill: "#d4d7de"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23h-1v-1h1z",
    fill: "#cbc8cd",
    fillOpacity: 0.808
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M68 22v1h-1v-1z",
    fill: "#aaa",
    fillOpacity: 0.012
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23v1h-1v-1z",
    fill: "#d2d0cd",
    fillOpacity: 0.624
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24h-1v-1h1z",
    fill: "#ddd9d9"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24h-1v-1h1z",
    fill: "#d6d6d8"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M27 24h-1v-1h1z",
    fill: "#e0e0e2",
    fillOpacity: 0.984
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23v1h-1v-1z",
    fill: "#e3e3e7",
    fillOpacity: 0.259
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M54 23h1v1h-1z",
    fill: "#efefef",
    fillOpacity: 0.063
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M55 23h1v1h-1z",
    fill: "#d4d1d2",
    fillOpacity: 0.886
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M59 24h-1v-1h1z",
    fill: "#cfcdce"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v1h-1v-1z",
    fill: "#dadce1"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v-1h1v1z",
    fill: "#d1d4da"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23v1h-1v-1z",
    fill: "#c8c6cc",
    fillOpacity: 0.784
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25v-1h1v1z",
    fill: "#d1d0cc",
    fillOpacity: 0.753
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24v1h-1v-1z",
    fill: "#dbdde4"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M19 25h-1v-1h1z",
    fill: "#dedde4"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M26 25v-1h1v1z",
    fill: "#dfdfe2",
    fillOpacity: 0.733
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25v-1h1v1z",
    fill: "#dadada",
    fillOpacity: 0.192
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M55 25v-1h1v1z",
    fill: "#d3d2d3",
    fillOpacity: 0.973
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25v-1h1v1z",
    fill: "#c8c6c7"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v1h-1v-1z",
    fill: "#d0d2da"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25h-1v-1h1z",
    fill: "#d3d3da"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M64 24h1v1h-1z",
    fill: "#d4d7dd"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25v-1h1v1z",
    fill: "#c6c3c8",
    fillOpacity: 0.757
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M14 25v1h-1v-1z",
    fill: "#d1cfcc",
    fillOpacity: 0.863
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26v-1h1v1z",
    fill: "#d8d5d6"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M19 25v1h-1v-1z",
    fill: "#dadce2"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M26 25h1v1h-1z",
    fill: "#e3e0e3",
    fillOpacity: 0.361
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25h1v1h-1z",
    fill: "#d9d9d9",
    fillOpacity: 0.427
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M56 26h-1v-1h1z",
    fill: "#dad8d9"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M57 25v1h-1v-1z",
    fill: "#d3d0d1"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M59 26h-1v-1h1z",
    fill: "#d1cecd"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h1v1h-1z",
    fill: "#c7c4c2"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M62 25v1h-1v-1z",
    fill: "#d3d4dc"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v1h-1v-1z",
    fill: "#d6d7df"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25h1v1h-1z",
    fill: "#c4c1c6",
    fillOpacity: 0.749
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M13 27h-1v-1h1z",
    fill: "#d9d9d2",
    fillOpacity: 0.133
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M14 27h-1v-1h1z",
    fill: "#d2cecb",
    fillOpacity: 0.945
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27h-1v-1h1z",
    fill: "#d6d4d4"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26v1h-1v-1z",
    fill: "#d2d0cf"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26h1v1h-1z",
    fill: "#dfdfe6"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26h1v1h-1z",
    fill: "#ecebee"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M26 26v1h-1v-1z",
    fill: "#e0e0e4",
    fillOpacity: 0.941
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M26 26h1v1h-1z",
    fill: "#e7e7e7",
    fillOpacity: 0.125
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M54 26h1v1h-1z",
    fill: "#dbdbdb",
    fillOpacity: 0.729
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M59 27h-1v-1h1z",
    fill: "#d1d0d0"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27h-1v-1h1z",
    fill: "#c8c4c3"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M61 27h-1v-1h1z",
    fill: "#ceccd0"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27h-1v-1h1z",
    fill: "#d4d5dd"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M66 27v-1h1v1z",
    fill: "#c4c0c5",
    fillOpacity: 0.753
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28h-1v-1h1z",
    fill: "#d4d4cc",
    fillOpacity: 0.235
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M13 27h1v1h-1z",
    fill: "#d2ceca",
    fillOpacity: 0.996
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27v1h-1v-1z",
    fill: "#d5d3d1"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27h1v1h-1z",
    fill: "#d2d1ce"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M17 27v1h-1v-1z",
    fill: "#d0cecf"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27h1v1h-1z",
    fill: "#e3e4e7"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28v-1h1v1z",
    fill: "#efeef0"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28v-1h1v1z",
    fill: "#e3e3e7",
    fillOpacity: 0.894
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27v1h-1v-1z",
    fill: "#f0f0f0",
    fillOpacity: 0.071
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M53 28v-1h1v1z",
    fill: "#dedede",
    fillOpacity: 0.153
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27v1h-1v-1z",
    fill: "#d7d5d6",
    fillOpacity: 0.953
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27v1h-1v-1z",
    fill: "#cac6c6"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M60 28v-1h1v1z",
    fill: "#cccacd"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h1v1h-1z",
    fill: "#cecbd1"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28h-1v-1h1z",
    fill: "#c6bfc6",
    fillOpacity: 0.761
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M13 29h-1v-1h1z",
    fill: "#d3d0ca",
    fillOpacity: 0.365
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M14 28v1h-1v-1z",
    fill: "#d7d4cf"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M16 29h-1v-1h1z",
    fill: "#d3d0cd"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M17 28v1h-1v-1z",
    fill: "#d0cdcd"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M19 28h1v1h-1z",
    fill: "#dadbe2"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29v-1h1v1z",
    fill: "#eeedf0"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M26 29h-1v-1h1z",
    fill: "#e3e3e6",
    fillOpacity: 0.957
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M27 29h-1v-1h1z",
    fill: "#e4e4e4",
    fillOpacity: 0.149
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M53 29v-1h1v1z",
    fill: "#ddd",
    fillOpacity: 0.447
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28h1v1h-1z",
    fill: "#d2cfd0"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M59 28h1v1h-1z",
    fill: "#cec9c9"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M61 29h-1v-1h1z",
    fill: "#cbc9cb"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M63 29v-1h1v1z",
    fill: "#d0d3da"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29h-1v-1h1z",
    fill: "#cfcfd6"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29v-1h1v1z",
    fill: "#ccc8cf"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v1h-1v-1z",
    fill: "#c4bec4",
    fillOpacity: 0.773
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M13 29v1h-1v-1z",
    fill: "#d0ccca",
    fillOpacity: 0.514
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M13 29h1v1h-1z",
    fill: "#d9d6d1"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M17 30h-1v-1h1z",
    fill: "#cfcbca"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M18 29v1h-1v-1z",
    fill: "#dddde0"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30v-1h1v1z",
    fill: "#ebeaed"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30h-1v-1h1z",
    fill: "#ececee"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M27 29v1h-1v-1z",
    fill: "#e1e1e1",
    fillOpacity: 0.337
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.031
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v-1h1v1z",
    fill: "#d9d9dc",
    fillOpacity: 0.804
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M57 30h-1v-1h1z",
    fill: "#d4d3d3"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M58 30v-1h1v1z",
    fill: "#d4d1d1"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v-1h1v1z",
    fill: "#d0cbca"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M60 30v-1h1v1z",
    fill: "#cecbcb"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30v-1h1v1z",
    fill: "#d2d4dc"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M66 29v1h-1v-1z",
    fill: "#ccc7ce"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M67 30h-1v-1h1z",
    fill: "#c3bec5",
    fillOpacity: 0.796
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M12 31v-1h1v1z",
    fill: "#d0cdca",
    fillOpacity: 0.643
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M14 30v1h-1v-1z",
    fill: "#d8d4d0"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30h1v1h-1z",
    fill: "#d0cdcc"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31v-1h1v1z",
    fill: "#e8e5e9"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M25 31v-1h1v1z",
    fill: "#f2f1f4"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M27 31h-1v-1h1z",
    fill: "#dfdfe1",
    fillOpacity: 0.533
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v1h-1v-1z",
    fill: "#e1e1e4",
    fillOpacity: 0.337
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v-1h1v1z",
    fill: "#dddddf",
    fillOpacity: 0.996
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30h1v1h-1z",
    fill: "#d5d3d6"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31h-1v-1h1z",
    fill: "#d5d4d3"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30h1v1h-1z",
    fill: "#d1cece"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M61 31h-1v-1h1z",
    fill: "#cecdcd"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M64 30v1h-1v-1z",
    fill: "#d1d3db"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h1v1h-1z",
    fill: "#cbc6cd"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M67 31h-1v-1h1z",
    fill: "#c5bec5",
    fillOpacity: 0.812
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M12 31h1v1h-1z",
    fill: "#cdcac5",
    fillOpacity: 0.765
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M13 31h1v1h-1z",
    fill: "#d6d3ce"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M25 31h1v1h-1z",
    fill: "#f1eff2"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M26 31h1v1h-1z",
    fill: "#e1e1e2",
    fillOpacity: 0.675
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32v-1h1v1z",
    fill: "#e7e7e7",
    fillOpacity: 0.086
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v1h-1v-1z",
    fill: "#dddcde",
    fillOpacity: 0.839
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31h1v1h-1z",
    fill: "#dfdee1"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32h-1v-1h1z",
    fill: "#d2d1d2"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M59 32h-1v-1h1z",
    fill: "#d2d1d3"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M59 31h1v1h-1z",
    fill: "#d1cfd0"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M60 31h1v1h-1z",
    fill: "#d0cfcf"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M62 31h1v1h-1z",
    fill: "#d5d7dd"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M66 32v-1h1v1z",
    fill: "#c4bec4",
    fillOpacity: 0.831
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32h-1v-1h1z",
    fill: "#d4d4d4",
    fillOpacity: 0.024
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M13 32v1h-1v-1z",
    fill: "#cec9c4",
    fillOpacity: 0.867
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M14 33h-1v-1h1z",
    fill: "#d4d0cc"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M15 33h-1v-1h1z",
    fill: "#d3cecb"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M19 33v-1h1v1z",
    fill: "#e1e2e6"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M26 33v-1h1v1z",
    fill: "#e3e0e4",
    fillOpacity: 0.788
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M43 32v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.039
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M44 32v1h-1v-1z",
    fill: "#ededed",
    fillOpacity: 0.173
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33v-1h1v1z",
    fill: "#e8e8ec",
    fillOpacity: 0.318
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32v1h-1v-1z",
    fill: "#e4e4e9",
    fillOpacity: 0.227
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33h-1v-1h1z",
    fill: "#ffffda",
    fillOpacity: 0.027
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33h-1v-1h1z",
    fill: "#e8e8e8",
    fillOpacity: 0.18
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33v-1h1v1z",
    fill: "#e0e0e3",
    fillOpacity: 0.722
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32v1h-1v-1z",
    fill: "#d4d2d2"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32h1v1h-1z",
    fill: "#d0cece"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v1h-1v-1z",
    fill: "#c9c7cd"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M65 33v-1h1v1z",
    fill: "#cac6ce"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M66 33v-1h1v1z",
    fill: "#c7c2c9",
    fillOpacity: 0.863
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32v1h-1v-1z",
    fill: "#d0d0e7",
    fillOpacity: 0.043
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M12 33v1h-1v-1z",
    fill: "#d2d2ca",
    fillOpacity: 0.133
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M12 34v-1h1v1z",
    fill: "#ccc8c2",
    fillOpacity: 0.949
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M16 34h-1v-1h1z",
    fill: "#d1cfcb"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M26 33h1v1h-1z",
    fill: "#e4e2e6",
    fillOpacity: 0.882
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34h-1v-1h1z",
    fill: "#d2d2d2",
    fillOpacity: 0.067
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M35 33v1h-1v-1z",
    fill: "#e1e1e1",
    fillOpacity: 0.067
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M36 33h1v1h-1z",
    fill: "#e6e6e6",
    fillOpacity: 0.161
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h1v1h-1z",
    fill: "#e9e9e9",
    fillOpacity: 0.227
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33h1v1h-1z",
    fill: "#eaeaee",
    fillOpacity: 0.298
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M39 33h1v1h-1z",
    fill: "#e8e8ea",
    fillOpacity: 0.396
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M40 34v-1h1v1z",
    fill: "#e5e5e9",
    fillOpacity: 0.518
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34h-1v-1h1z",
    fill: "#e3e3e6",
    fillOpacity: 0.682
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M43 34h-1v-1h1z",
    fill: "#e4e3e7",
    fillOpacity: 0.843
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M43 33h1v1h-1z",
    fill: "#e5e5e7",
    fillOpacity: 0.965
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M45 33h1v1h-1z",
    fill: "#e3e2e7",
    fillOpacity: 0.988
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M47 34h-1v-1h1z",
    fill: "#e4e3e8",
    fillOpacity: 0.878
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v1h-1v-1z",
    fill: "#e5e3e8",
    fillOpacity: 0.773
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M49 33v1h-1v-1z",
    fill: "#e5e4e8",
    fillOpacity: 0.753
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33v1h-1v-1z",
    fill: "#e4e2e6",
    fillOpacity: 0.816
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34v-1h1v1z",
    fill: "#dfdfe2",
    fillOpacity: 0.961
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33v1h-1v-1z",
    fill: "#c7c2c9",
    fillOpacity: 0.878
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33h1v1h-1z",
    fill: "#c8dac8",
    fillOpacity: 0.055
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M12 35h-1v-1h1z",
    fill: "#d2ceca",
    fillOpacity: 0.247
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M13 34v1h-1v-1z",
    fill: "#cecac5",
    fillOpacity: 0.996
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M13 34h1v1h-1z",
    fill: "#d1cfca"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M17 35h-1v-1h1z",
    fill: "#d6d2d2"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M26 34h1v1h-1z",
    fill: "#e3e1e4",
    fillOpacity: 0.957
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M27 34h1v1h-1z",
    fill: "#dcdce3",
    fillOpacity: 0.145
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M31 35h-1v-1h1z",
    fill: "#e7e7e7",
    fillOpacity: 0.212
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34v1h-1v-1z",
    fill: "#e9e9eb",
    fillOpacity: 0.616
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34h1v1h-1z",
    fill: "#e5e5e8",
    fillOpacity: 0.773
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34h1v1h-1z",
    fill: "#e4e3e8",
    fillOpacity: 0.827
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35v-1h1v1z",
    fill: "#e4e4e8",
    fillOpacity: 0.882
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M36 35h-1v-1h1z",
    fill: "#e3e2e8",
    fillOpacity: 0.925
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M37 34v1h-1v-1z",
    fill: "#e3e2e8",
    fillOpacity: 0.961
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M39 34v1h-1v-1z",
    fill: "#e6e6eb"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M42 35v-1h1v1z",
    fill: "#e7e6ec"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h-1v-1h1z",
    fill: "#e8e7ed"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v-1h1v1z",
    fill: "#d8d7d7"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M60 34v1h-1v-1z",
    fill: "#cfcecf"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M67 35h-1v-1h1z",
    fill: "#c5c3c8",
    fillOpacity: 0.902
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M67 34h1v1h-1z",
    fill: "#c9c9d6",
    fillOpacity: 0.075
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M12 35v1h-1v-1z",
    fill: "#d1c9c7",
    fillOpacity: 0.376
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M16 35h1v1h-1z",
    fill: "#d5d1d1"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36v-1h1v1z",
    fill: "#e3e0e5"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M26 36v-1h1v1z",
    fill: "#e3e1e4",
    fillOpacity: 0.992
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36h-1v-1h1z",
    fill: "#dfdfdf",
    fillOpacity: 0.192
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M29 36v-1h1v1z",
    fill: "#e7e7e9",
    fillOpacity: 0.502
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M30 35h1v1h-1z",
    fill: "#e6e6e7",
    fillOpacity: 0.945
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35h1v1h-1z",
    fill: "#d7d7d6"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M58 36h-1v-1h1z",
    fill: "#d5d3d5"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M59 35h1v1h-1z",
    fill: "#d3d0cf"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M60 35h1v1h-1z",
    fill: "#cfcbcb"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M67 35v1h-1v-1z",
    fill: "#c5c1c7",
    fillOpacity: 0.925
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36v-1h1v1z",
    fill: "#c9c9d4",
    fillOpacity: 0.094
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M12 36v1h-1v-1z",
    fill: "#d2cac6",
    fillOpacity: 0.514
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M14 36h1v1h-1z",
    fill: "#d3d0cc"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M16 37v-1h1v1z",
    fill: "#d6d2d1"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36v1h-1v-1z",
    fill: "#e4e3e5",
    fillOpacity: 0.753
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M29 37h-1v-1h1z",
    fill: "#e5e4e7",
    fillOpacity: 0.89
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M30 37h-1v-1h1z",
    fill: "#ebeaee"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36v1h-1v-1z",
    fill: "#e5e5e8"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M53 37h-1v-1h1z",
    fill: "#d8d7da"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h-1v-1h1z",
    fill: "#d5d5d6"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M57 37h-1v-1h1z",
    fill: "#d6d4d6"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M59 36h1v1h-1z",
    fill: "#d3cfd0"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M61 37h-1v-1h1z",
    fill: "#cfcccb"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h-1v-1h1z",
    fill: "#cbc9d0"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M66 36v1h-1v-1z",
    fill: "#c8c4cc"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M67 37h-1v-1h1z",
    fill: "#c6c1c8",
    fillOpacity: 0.949
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36h1v1h-1z",
    fill: "#c7c7c7",
    fillOpacity: 0.125
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M11 38v-1h1v1z",
    fill: "#cec8c5",
    fillOpacity: 0.659
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M16 37v1h-1v-1z",
    fill: "#d5d1ce"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M17 38h-1v-1h1z",
    fill: "#d8d4d3"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M19 38v-1h1v1z",
    fill: "#e5e4e6"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M27 38v-1h1v1z",
    fill: "#ebe9ee"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37v1h-1v-1z",
    fill: "#d4d3d6"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37h1v1h-1z",
    fill: "#d3d1d5"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37h1v1h-1z",
    fill: "#cfccca"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h-1v-1h1z",
    fill: "#d5d4d8"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M62 37h1v1h-1z",
    fill: "#cfd0d7"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M66 37h1v1h-1z",
    fill: "#c5c1c7",
    fillOpacity: 0.976
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M68 38h-1v-1h1z",
    fill: "#c8c8ce",
    fillOpacity: 0.165
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M11 39v-1h1v1z",
    fill: "#cec8c4",
    fillOpacity: 0.784
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M12 39v-1h1v1z",
    fill: "#d5cfcb"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M14 38v1h-1v-1z",
    fill: "#d2ceca"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M16 39v-1h1v1z",
    fill: "#d8d5d3"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38h1v1h-1z",
    fill: "#d2d0d3"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M64 38v1h-1v-1z",
    fill: "#ceccd3"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M67 38v1h-1v-1z",
    fill: "#c5c1c8",
    fillOpacity: 0.996
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M67 38h1v1h-1z",
    fill: "#ccc7cc",
    fillOpacity: 0.216
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M11 39v1h-1v-1z",
    fill: "#d4d4c6",
    fillOpacity: 0.071
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M12 40h-1v-1h1z",
    fill: "#cdc5c3",
    fillOpacity: 0.894
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M17 40h-1v-1h1z",
    fill: "#d5d2d0"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M30 39v1h-1v-1z",
    fill: "#e4e4e6"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39h1v1h-1z",
    fill: "#d8d6d7"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M53 39v1h-1v-1z",
    fill: "#dad9d9"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M53 40v-1h1v1z",
    fill: "#d4d3d4"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M57 39h1v1h-1z",
    fill: "#d1d0d2"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M63 39h1v1h-1z",
    fill: "#cdcbd2"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h-1v-1h1z",
    fill: "#ccc9d0",
    fillOpacity: 0.278
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M11 40v1h-1v-1z",
    fill: "#d3cdc7",
    fillOpacity: 0.161
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M12 40v1h-1v-1z",
    fill: "#cdc5c3",
    fillOpacity: 0.973
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M12 41v-1h1v1z",
    fill: "#d0ccc8"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M15 40h1v1h-1z",
    fill: "#d7d2ce"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M17 40v1h-1v-1z",
    fill: "#d2cfcd"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M20 41h-1v-1h1z",
    fill: "#e0dde4"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v1h-1v-1z",
    fill: "#cfcbcf"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M60 41v-1h1v1z",
    fill: "#d5d2d9"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41v-1h1v1z",
    fill: "#cfcdd6"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M65 40h1v1h-1z",
    fill: "#c8c7cd"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41v-1h1v1z",
    fill: "#cacacd",
    fillOpacity: 0.345
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M11 41v1h-1v-1z",
    fill: "#cecac6",
    fillOpacity: 0.267
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M13 41v1h-1v-1z",
    fill: "#cfcac7"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M15 42v-1h1v1z",
    fill: "#d5d0cc"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M21 42v-1h1v1z",
    fill: "#d8d5dd"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M44 42h-1v-1h1z",
    fill: "#e5e6ea"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M47 42v-1h1v1z",
    fill: "#e2e3e8"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42h-1v-1h1z",
    fill: "#cac9d1"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42h-1v-1h1z",
    fill: "#cac8cf"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42v-1h1v1z",
    fill: "#cfccd3"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41h1v1h-1z",
    fill: "#cbcbcf",
    fillOpacity: 0.404
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M10 43v-1h1v1z",
    fill: "#cbc6c1",
    fillOpacity: 0.408
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M11 42h1v1h-1z",
    fill: "#d6cec9"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M17 42h1v1h-1z",
    fill: "#d9d6d9"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M18 42h1v1h-1z",
    fill: "#d6d4da"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M20 42v1h-1v-1z",
    fill: "#cecbd2"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M29 42v1h-1v-1z",
    fill: "#eae9ec"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M29 43v-1h1v1z",
    fill: "#e6e6e8"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42v1h-1v-1z",
    fill: "#e9e8ea"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M38 42h1v1h-1z",
    fill: "#eae9ed"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43h-1v-1h1z",
    fill: "#e7e7e9"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M65 43v-1h1v1z",
    fill: "#cbc8d0"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h-1v-1h1z",
    fill: "#d1cfd6"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v1h-1v-1z",
    fill: "#cbcbd1",
    fillOpacity: 0.463
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M11 43v1h-1v-1z",
    fill: "#cbc6c0",
    fillOpacity: 0.545
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M12 44h-1v-1h1z",
    fill: "#d8cfc8"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M13 44h-1v-1h1z",
    fill: "#cfc9c4"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M18 43v1h-1v-1z",
    fill: "#d7d4d7"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M27 44h-1v-1h1z",
    fill: "#dedcdf"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M37 44h-1v-1h1z",
    fill: "#ebebed"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M41 43v1h-1v-1z",
    fill: "#ebe8ec"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M66 43v1h-1v-1z",
    fill: "#cccad1"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h1v1h-1z",
    fill: "#cfcdd3",
    fillOpacity: 0.502
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M11 44v1h-1v-1z",
    fill: "#cbc2bf",
    fillOpacity: 0.682
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M11 45v-1h1v1z",
    fill: "#d6cec8"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M13 44v1h-1v-1z",
    fill: "#d1c9c5"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M16 44v1h-1v-1z",
    fill: "#d3cfca"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M17 45h-1v-1h1z",
    fill: "#d1ccc9"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M18 44h1v1h-1z",
    fill: "#ccc9cf"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M19 45v-1h1v1z",
    fill: "#cfcdd1"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M20 44h1v1h-1z",
    fill: "#dcdade"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45h-1v-1h1z",
    fill: "#e9e8eb"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M66 44v1h-1v-1z",
    fill: "#cccad2"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M68 44v1h-1v-1z",
    fill: "#ceccd1",
    fillOpacity: 0.573
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M10 46v-1h1v1z",
    fill: "#ccc3bf",
    fillOpacity: 0.808
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M12 45v1h-1v-1z",
    fill: "#d2cbc7"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M17 45h1v1h-1z",
    fill: "#cac3c7"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M19 45v1h-1v-1z",
    fill: "#cec9cf"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M41 46h-1v-1h1z",
    fill: "#e2e2e5"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45h1v1h-1z",
    fill: "#cdcdd1",
    fillOpacity: 0.643
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M11 46v1h-1v-1z",
    fill: "#ccc4c1",
    fillOpacity: 0.906
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M12 47h-1v-1h1z",
    fill: "#cfcac5"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M12 46h1v1h-1z",
    fill: "#d0cac6"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M17 47h-1v-1h1z",
    fill: "#ccc8c4"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M18 46v1h-1v-1z",
    fill: "#ccc6c9"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M51 46v1h-1v-1z",
    fill: "#dedee4"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M68 46v1h-1v-1z",
    fill: "#cfced2",
    fillOpacity: 0.678
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M10 48H9v-1h1z",
    fill: "#cdc7c7",
    fillOpacity: 0.161
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M10 47h1v1h-1z",
    fill: "#cbc3c1",
    fillOpacity: 0.973
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M16 47h1v1h-1z",
    fill: "#cbc7c3"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M19 47v1h-1v-1z",
    fill: "#d4d1d6"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47v1h-1v-1z",
    fill: "#e5e2e7"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47h1v1h-1z",
    fill: "#e8e6eb"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h-1v-1h1z",
    fill: "#cfced4",
    fillOpacity: 0.698
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M10 49H9v-1h1z",
    fill: "#cbc3c0",
    fillOpacity: 0.271
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M16 49v-1h1v1z",
    fill: "#cfc9c9"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M25 48h1v1h-1z",
    fill: "#ebe9ed"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M68 49h-1v-1h1z",
    fill: "#cfced4",
    fillOpacity: 0.737
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M10 49v1H9v-1z",
    fill: "#cdc5c3",
    fillOpacity: 0.384
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M10 50v-1h1v1z",
    fill: "#d3cac7"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M16 49v1h-1v-1z",
    fill: "#d2cdca"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M17 50v-1h1v1z",
    fill: "#d6d6dc"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50v-1h1v1z",
    fill: "#eae8ed"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M26 49v1h-1v-1z",
    fill: "#e9e7eb"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h1v1h-1z",
    fill: "#e8e6e8"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M46 49v1h-1v-1z",
    fill: "#e6e4e9"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M53 50v-1h1v1z",
    fill: "#d9dadf"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M68 49v1h-1v-1z",
    fill: "#d1d0d6",
    fillOpacity: 0.769
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M9 50h1v1H9z",
    fill: "#cac5c1",
    fillOpacity: 0.518
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M10 50h1v1h-1z",
    fill: "#d3cbc7"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M17 50v1h-1v-1z",
    fill: "#cfcbcc"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M18 50h1v1h-1z",
    fill: "#d4d2d9"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M21 51h-1v-1h1z",
    fill: "#e8e7e9"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M67 51v-1h1v1z",
    fill: "#d2d0d7",
    fillOpacity: 0.804
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M10 51v1H9v-1z",
    fill: "#cac3bf",
    fillOpacity: 0.643
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M11 51v1h-1v-1z",
    fill: "#d2cac4"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M17 52h-1v-1h1z",
    fill: "#d0cbcd"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M19 52h-1v-1h1z",
    fill: "#d3d0d6"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M21 52v-1h1v1z",
    fill: "#dcdae0"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M68 51v1h-1v-1z",
    fill: "#d2d0d8",
    fillOpacity: 0.824
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M9 52h1v1H9z",
    fill: "#c9c1bd",
    fillOpacity: 0.745
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M10 52h1v1h-1z",
    fill: "#d1c7c2"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M16 52h1v1h-1z",
    fill: "#ccc6c6"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52v1h-1v-1z",
    fill: "#eae7ea"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M32 53h-1v-1h1z",
    fill: "#edeaee"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h-1v-1h1z",
    fill: "#ece9ed"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53v-1h1v1z",
    fill: "#d2d1d7",
    fillOpacity: 0.835
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M9 54H8v-1h1z",
    fill: "#ffffd4",
    fillOpacity: 0.024
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M9 54v-1h1v1z",
    fill: "#c9c0bb",
    fillOpacity: 0.835
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M11 54h-1v-1h1z",
    fill: "#cfc4c0"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M15 54v-1h1v1z",
    fill: "#cfc9c5"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M25 54v-1h1v1z",
    fill: "#ebe7eb"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M27 54h-1v-1h1z",
    fill: "#ede7eb"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53h1v1h-1z",
    fill: "#d3d2d9",
    fillOpacity: 0.855
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M69 53v1h-1v-1z",
    fill: "#e5cce5",
    fillOpacity: 0.039
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M10 54v1H9v-1z",
    fill: "#cac1bc",
    fillOpacity: 0.906
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M10 55v-1h1v1z",
    fill: "#cfc5c2"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M16 54v1h-1v-1z",
    fill: "#cdc8c5"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M16 54h1v1h-1z",
    fill: "#c9c1bd"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M18 54v1h-1v-1z",
    fill: "#d6d3d3"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M20 55h-1v-1h1z",
    fill: "#dad7da"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M24 54v1h-1v-1z",
    fill: "#eae5ea"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M27 54v1h-1v-1z",
    fill: "#eeeaec"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M68 54v1h-1v-1z",
    fill: "#d3d2da",
    fillOpacity: 0.859
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M9 55v1H8v-1z",
    fill: "#cec7c7",
    fillOpacity: 0.145
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M9 55h1v1H9z",
    fill: "#c8bfbc",
    fillOpacity: 0.961
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M15 55h1v1h-1z",
    fill: "#cbc7c4"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M17 55v1h-1v-1z",
    fill: "#c8c0bc"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M19 55h1v1h-1z",
    fill: "#dfdcdf"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M22 55h1v1h-1z",
    fill: "#ece8ec"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M27 56v-1h1v1z",
    fill: "#ede8ec"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55h1v1h-1z",
    fill: "#e5e1e4"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M33 55v1h-1v-1z",
    fill: "#eeebeb"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M34 56h-1v-1h1z",
    fill: "#edeaea"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M67 56v-1h1v1z",
    fill: "#d4d3da",
    fillOpacity: 0.867
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M9 56v1H8v-1z",
    fill: "#ccc7c2",
    fillOpacity: 0.216
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M10 56v1H9v-1z",
    fill: "#c8bfbc",
    fillOpacity: 0.996
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M15 56h1v1h-1z",
    fill: "#ccc7c4"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M16 57v-1h1v1z",
    fill: "#c7c0bc"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M18 56v1h-1v-1z",
    fill: "#d2cccd"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M22 56h1v1h-1z",
    fill: "#eae6ea"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M25 57h-1v-1h1z",
    fill: "#ede9eb"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M28 57h-1v-1h1z",
    fill: "#eeeaed"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M30 56v1h-1v-1z",
    fill: "#eae6e7"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M32 57v-1h1v1z",
    fill: "#eceaeb"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M51 56v1h-1v-1z",
    fill: "#d9d9e2"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M54 56v1h-1v-1z",
    fill: "#d7d8e0"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M56 56v1h-1v-1z",
    fill: "#d4d6dd"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57h-1v-1h1z",
    fill: "#d4d3dc"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M67 56h1v1h-1z",
    fill: "#d2d2d9",
    fillOpacity: 0.875
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M68 56h1v1h-1z",
    fill: "#dadada",
    fillOpacity: 0.055
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M9 58H8v-1h1z",
    fill: "#d0c6c3",
    fillOpacity: 0.302
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M16 58h-1v-1h1z",
    fill: "#cdc5c4"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M16 57h1v1h-1z",
    fill: "#c7bfbd"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M17 58v-1h1v1z",
    fill: "#d2cdcb"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M22 57h1v1h-1z",
    fill: "#e7e3e6"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M28 58h-1v-1h1z",
    fill: "#efeaed"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M28 57h1v1h-1z",
    fill: "#e8e6e7"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M29 57h1v1h-1z",
    fill: "#ebe5e7"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58v-1h1v1z",
    fill: "#edeae9"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M43 58h-1v-1h1z",
    fill: "#dfdfe2"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M50 57h1v1h-1z",
    fill: "#d9cfd5"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58h-1v-1h1z",
    fill: "#d6c7cd"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58v-1h1v1z",
    fill: "#d6ced3"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58h-1v-1h1z",
    fill: "#d0b3b3"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M55 57h1v1h-1z",
    fill: "#d1c3cb"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M58 58h-1v-1h1z",
    fill: "#d3d8df"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57h1v1h-1z",
    fill: "#d4d6df"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M59 58v-1h1v1z",
    fill: "#d5d6de"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58h-1v-1h1z",
    fill: "#d5d1d7"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v1h-1v-1z",
    fill: "#ccccd4"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58v-1h1v1z",
    fill: "#d2d1d8",
    fillOpacity: 0.878
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M9 59H8v-1h1z",
    fill: "#cec6c1",
    fillOpacity: 0.388
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M9 59v-1h1v1z",
    fill: "#d1c7c4"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M18 59h-1v-1h1z",
    fill: "#d1cdcb"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M22 59v-1h1v1z",
    fill: "#e1dde1"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M29 59h-1v-1h1z",
    fill: "#ebe6e9"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M30 58v1h-1v-1z",
    fill: "#eae7e9"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M30 59v-1h1v1z",
    fill: "#eae9e9"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58h1v1h-1z",
    fill: "#f0eaef"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M42 58h1v1h-1z",
    fill: "#e1dde5"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v1h-1v-1z",
    fill: "#d9c5c7"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v1h-1v-1z",
    fill: "#dadde4"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M49 58h1v1h-1z",
    fill: "#d6c4c8"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M51 58v1h-1v-1z",
    fill: "#cda9aa"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M51 59v-1h1v1z",
    fill: "#d2bfc0"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58h1v1h-1z",
    fill: "#cea5a6"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58v1h-1v-1z",
    fill: "#caa6a6"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58h1v1h-1z",
    fill: "#d2c5c9"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M57 59h-1v-1h1z",
    fill: "#d2c8ce"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M57 58h1v1h-1z",
    fill: "#d0babf"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59h-1v-1h1z",
    fill: "#d1c5c9"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59v-1h1v1z",
    fill: "#d2c3c6"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M61 58v1h-1v-1z",
    fill: "#ccb1b4"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59v-1h1v1z",
    fill: "#ccaeac"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v1h-1v-1z",
    fill: "#caacae"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M64 58v1h-1v-1z",
    fill: "#d1c1c6"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M68 59h-1v-1h1z",
    fill: "#d1d0d7",
    fillOpacity: 0.886
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M8 60v-1h1v1z",
    fill: "#cdc7c3",
    fillOpacity: 0.467
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M10 59v1H9v-1z",
    fill: "#d4cbc7"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M24 59v1h-1v-1z",
    fill: "#ece7eb"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M25 60v-1h1v1z",
    fill: "#efeced"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M26 59h1v1h-1z",
    fill: "#ebeaeb"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M29 59v1h-1v-1z",
    fill: "#eadfe2"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M29 60v-1h1v1z",
    fill: "#eae5e6"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M30 59h1v1h-1z",
    fill: "#ece2e4"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M32 60h-1v-1h1z",
    fill: "#e9dad9"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M32 59h1v1h-1z",
    fill: "#ede8e9"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59v1h-1v-1z",
    fill: "#eae9eb"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M40 59h1v1h-1z",
    fill: "#e1e3e8"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M42 60v-1h1v1z",
    fill: "#e1dbe1"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M43 60v-1h1v1z",
    fill: "#d4aeb0"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M45 60h-1v-1h1z",
    fill: "#d4b6b5"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h-1v-1h1z",
    fill: "#d8c3c3"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M46 59h1v1h-1z",
    fill: "#d7c4c9"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h-1v-1h1z",
    fill: "#d9ced4"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60v-1h1v1z",
    fill: "#dbd5de"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M54 59v1h-1v-1z",
    fill: "#ceb2b3"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M54 60v-1h1v1z",
    fill: "#d9d5dd"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M55 59h1v1h-1z",
    fill: "#d2c4c7"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60v-1h1v1z",
    fill: "#caa"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M58 59h1v1h-1z",
    fill: "#ccb7b6"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60h-1v-1h1z",
    fill: "#caa3a3"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59v1h-1v-1z",
    fill: "#d0bcc1"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M62 60h-1v-1h1z",
    fill: "#c9a3a3"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M63 60h-1v-1h1z",
    fill: "#d1c4c8"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M64 59v1h-1v-1z",
    fill: "#cdc5ca"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v-1h1v1z",
    fill: "#cfd0d9"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60h-1v-1h1z",
    fill: "#d1d0d6",
    fillOpacity: 0.898
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60v-1h1v1z",
    fill: "#e2d4e2",
    fillOpacity: 0.071
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M9 60v1H8v-1z",
    fill: "#cdc5c3",
    fillOpacity: 0.541
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M10 61H9v-1h1z",
    fill: "#d9d0cd"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M17 60h1v1h-1z",
    fill: "#c8c2c0"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M23 61v-1h1v1z",
    fill: "#eceaec"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M24 60h1v1h-1z",
    fill: "#efe8e9"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M26 60v1h-1v-1z",
    fill: "#e2c9c8"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M26 61v-1h1v1z",
    fill: "#e0c3c2"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61h-1v-1h1z",
    fill: "#ddb2b0"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61v-1h1v1z",
    fill: "#dfb9b9"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M31 61v-1h1v1z",
    fill: "#debdbb"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M32 61v-1h1v1z",
    fill: "#e9dadb"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M33 61v-1h1v1z",
    fill: "#e7e2e2"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M35 61h-1v-1h1z",
    fill: "#ebe7ec"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M36 60v1h-1v-1z",
    fill: "#e4d8d8"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M36 60h1v1h-1z",
    fill: "#e0c3c4"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60v1h-1v-1z",
    fill: "#e1d0d1"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61h-1v-1h1z",
    fill: "#e3d9dc"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M40 61h-1v-1h1z",
    fill: "#dcbfc2"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M40 61v-1h1v1z",
    fill: "#dbbcbd"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M41 60h1v1h-1z",
    fill: "#d6b6b9"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M43 61h-1v-1h1z",
    fill: "#d9c5c5"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60v1h-1v-1z",
    fill: "#dac5c6"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60h1v1h-1z",
    fill: "#d9c4c9"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M46 61h-1v-1h1z",
    fill: "#cea5a4"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h1v1h-1z",
    fill: "#cea2a1"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M48 61h-1v-1h1z",
    fill: "#d5c6c8"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h1v1h-1z",
    fill: "#d9dae3"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M52 61h-1v-1h1z",
    fill: "#cfb4b8"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M53 61h-1v-1h1z",
    fill: "#d4c9cc"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M55 60v1h-1v-1z",
    fill: "#d5d8dd"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60h1v1h-1z",
    fill: "#d3c0c6"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h-1v-1h1z",
    fill: "#caa8ae"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M58 60h1v1h-1z",
    fill: "#d0c5c7"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61h-1v-1h1z",
    fill: "#cfc3ca"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M62 61v-1h1v1z",
    fill: "#d3c6ca"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v1h-1v-1z",
    fill: "#cdbdc3"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60v1h-1v-1z",
    fill: "#d3d1da"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M67 61v-1h1v1z",
    fill: "#d0ced5",
    fillOpacity: 0.894
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60h1v1h-1z",
    fill: "#e1d2e1",
    fillOpacity: 0.067
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M9 61v1H8v-1z",
    fill: "#cbc2c1",
    fillOpacity: 0.616
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M18 61v1h-1v-1z",
    fill: "#c6bfbd"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M18 62v-1h1v1z",
    fill: "#dcd8db"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M24 62h-1v-1h1z",
    fill: "#edecec"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M25 62h-1v-1h1z",
    fill: "#e4d6d5"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M25 62v-1h1v1z",
    fill: "#dab6b3"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M27 61v1h-1v-1z",
    fill: "#e1c1c1"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M27 61h1v1h-1z",
    fill: "#e9dad8"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62h-1v-1h1z",
    fill: "#dab1b0"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M30 62h-1v-1h1z",
    fill: "#daada9"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61h1v1h-1z",
    fill: "#e3c2c0"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M32 62h-1v-1h1z",
    fill: "#e5ceca"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M32 62v-1h1v1z",
    fill: "#dcb2b2"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M33 61h1v1h-1z",
    fill: "#e0bebf"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M35 61v1h-1v-1z",
    fill: "#e7d1d4"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62h-1v-1h1z",
    fill: "#d4a6a4"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M36 61h1v1h-1z",
    fill: "#d5a7a3"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M38 61h1v1h-1z",
    fill: "#d7afb0"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61h1v1h-1z",
    fill: "#e0cccd"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M42 61v1h-1v-1z",
    fill: "#dbc4c4"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M44 62h-1v-1h1z",
    fill: "#d6bdbd"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M44 61h1v1h-1z",
    fill: "#dacdd0"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M47 62h-1v-1h1z",
    fill: "#d4bdbd"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M52 62h-1v-1h1z",
    fill: "#cfbcbc"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h-1v-1h1z",
    fill: "#d4c9ce"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61v1h-1v-1z",
    fill: "#d1bcc2"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h-1v-1h1z",
    fill: "#ccb6b9"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M57 61h1v1h-1z",
    fill: "#caa4a3"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h1v1h-1z",
    fill: "#cebabb"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h-1v-1h1z",
    fill: "#ceb9bb"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61v1h-1v-1z",
    fill: "#cdb0b3"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M61 62v-1h1v1z",
    fill: "#c9a5a4"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v-1h1v1z",
    fill: "#cfafb6"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M63 61h1v1h-1z",
    fill: "#cfc5c9"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M68 62h-1v-1h1z",
    fill: "#cecdd5",
    fillOpacity: 0.886
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M9 63H8v-1h1z",
    fill: "#c9c2c0",
    fillOpacity: 0.675
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M22 62h1v1h-1z",
    fill: "#e2dfe2"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M24 62h1v1h-1z",
    fill: "#e4d1d5"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M26 62v1h-1v-1z",
    fill: "#dcc1c1"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M26 63v-1h1v1z",
    fill: "#dfc2c3"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M28 63h-1v-1h1z",
    fill: "#e5d3d4"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62v1h-1v-1z",
    fill: "#e4c9c8"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62h1v1h-1z",
    fill: "#e5dcd7"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M30 62h1v1h-1z",
    fill: "#e3c9c7"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M32 63h-1v-1h1z",
    fill: "#e4ccca"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M33 62v1h-1v-1z",
    fill: "#dcb9b9"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M33 62h1v1h-1z",
    fill: "#e5d6d5"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M34 62h1v1h-1z",
    fill: "#e2c4c5"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62h1v1h-1z",
    fill: "#d3a6a4"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63v-1h1v1z",
    fill: "#e2cfd3"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M39 63h-1v-1h1z",
    fill: "#d8b9b3"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M40 63h-1v-1h1z",
    fill: "#dbd2d4"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M43 63v-1h1v1z",
    fill: "#d6bdbf"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63h-1v-1h1z",
    fill: "#d8cbcd"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63v-1h1v1z",
    fill: "#d2a8a6"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M46 62h1v1h-1z",
    fill: "#d9c6ce"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62v1h-1v-1z",
    fill: "#d2aeb0"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v-1h1v1z",
    fill: "#d5c9ce"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M51 62h1v1h-1z",
    fill: "#caa5a5"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62v1h-1v-1z",
    fill: "#cfb2b6"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h1v1h-1z",
    fill: "#d1b7ba"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M56 63h-1v-1h1z",
    fill: "#d7d1d7"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h1v1h-1z",
    fill: "#d1b6bb"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M58 63h-1v-1h1z",
    fill: "#d1bbc1"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M58 62h1v1h-1z",
    fill: "#d6d1d8"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h1v1h-1z",
    fill: "#d0c8cd"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v1h-1v-1z",
    fill: "#d5d0d8"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M63 63v-1h1v1z",
    fill: "#d3d1db"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M67 63v-1h1v1z",
    fill: "#cdccd3",
    fillOpacity: 0.871
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M9 63v1H8v-1z",
    fill: "#c9c2bf",
    fillOpacity: 0.725
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M17 64h-1v-1h1z",
    fill: "#c5bcba"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M19 64h-1v-1h1z",
    fill: "#dad4d7"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M23 64h-1v-1h1z",
    fill: "#e4e0e2"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M23 64v-1h1v1z",
    fill: "#eee8eb"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M25 63v1h-1v-1z",
    fill: "#edeaec"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M26 63v1h-1v-1z",
    fill: "#ede9e9"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M28 63v1h-1v-1z",
    fill: "#e3d2d2"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M28 64v-1h1v1z",
    fill: "#e5d3d1"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M30 63v1h-1v-1z",
    fill: "#ece5e9"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M31 64h-1v-1h1z",
    fill: "#e4c8c7"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M32 63v1h-1v-1z",
    fill: "#e4cdcb"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64v-1h1v1z",
    fill: "#e1c2bf"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M34 64h-1v-1h1z",
    fill: "#e8d4d5"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M35 63v1h-1v-1z",
    fill: "#daaeac"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M35 64v-1h1v1z",
    fill: "#e1c2c3"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63v1h-1v-1z",
    fill: "#d49e9e"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63h1v1h-1z",
    fill: "#dfc9cb"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M38 64v-1h1v1z",
    fill: "#d0a0a1"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M40 63h1v1h-1z",
    fill: "#d1aaaa"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M42 63h1v1h-1z",
    fill: "#cfaeb0"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M44 64h-1v-1h1z",
    fill: "#cea4a6"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M44 64v-1h1v1z",
    fill: "#d1b0b3"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M46 64h-1v-1h1z",
    fill: "#d6bcbd"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64v-1h1v1z",
    fill: "#d6ced5"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M52 64v-1h1v1z",
    fill: "#d7cfd5"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M54 64v-1h1v1z",
    fill: "#d7d6e3"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M56 64h-1v-1h1z",
    fill: "#d6d7e0"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M59 63v1h-1v-1z",
    fill: "#d5d5df"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M62 63v1h-1v-1z",
    fill: "#d5d5dc"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M68 63v1h-1v-1z",
    fill: "#ccccd3",
    fillOpacity: 0.859
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M8 64h1v1H8z",
    fill: "#c9c1bc",
    fillOpacity: 0.769
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M18 65h-1v-1h1z",
    fill: "#c7bcb9"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M20 65v-1h1v1z",
    fill: "#e9e5e9"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M23 65h-1v-1h1z",
    fill: "#e5e0e2"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M25 65h-1v-1h1z",
    fill: "#eeebec"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M25 65v-1h1v1z",
    fill: "#e8d6d8"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M26 65v-1h1v1z",
    fill: "#e0c6c1"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M28 65h-1v-1h1z",
    fill: "#ead9d7"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M28 64h1v1h-1z",
    fill: "#dab6b6"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M29 65v-1h1v1z",
    fill: "#e9d9db"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M30 64h1v1h-1z",
    fill: "#dcbbb8"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M31 65v-1h1v1z",
    fill: "#debcbb"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64h1v1h-1z",
    fill: "#d7b0af"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M34 64v1h-1v-1z",
    fill: "#d8babb"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M35 64h1v1h-1z",
    fill: "#d9b7b9"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M36 64h1v1h-1z",
    fill: "#d6b9ba"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65v-1h1v1z",
    fill: "#d6bdbc"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M38 64h1v1h-1z",
    fill: "#dccacc"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M39 64h1v1h-1z",
    fill: "#d7c2c5"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M40 64h1v1h-1z",
    fill: "#dcced1"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M41 65v-1h1v1z",
    fill: "#d8cbcf"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M43 64h1v1h-1z",
    fill: "#dcd7de"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65v-1h1v1z",
    fill: "#d9d5dc"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M53 64v1h-1v-1z",
    fill: "#d8d9df"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65v-1h1v1z",
    fill: "#d4cbd0"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M55 65v-1h1v1z",
    fill: "#d6d3db"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65h-1v-1h1z",
    fill: "#d7d6df"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M58 64v1h-1v-1z",
    fill: "#d3d8dd"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M58 64h1v1h-1z",
    fill: "#d4d4dd"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M60 64h1v1h-1z",
    fill: "#d6d5de"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M61 65v-1h1v1z",
    fill: "#d6d7de"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M63 65h-1v-1h1z",
    fill: "#d4d6dc"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64v1h-1v-1z",
    fill: "#d1cfd8"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M68 65h-1v-1h1z",
    fill: "#cccad1",
    fillOpacity: 0.843
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65h-1v-1h1z",
    fill: "#bfbfbf",
    fillOpacity: 0.031
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M9 66H8v-1h1z",
    fill: "#c7c0bb",
    fillOpacity: 0.796
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M20 66h-1v-1h1z",
    fill: "#e4e3e6"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M23 65v1h-1v-1z",
    fill: "#e5dfe3"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M24 66h-1v-1h1z",
    fill: "#eee9ec"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M24 65h1v1h-1z",
    fill: "#efebee"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M26 66h-1v-1h1z",
    fill: "#e6d4d6"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M27 66h-1v-1h1z",
    fill: "#dfb6ba"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M27 65h1v1h-1z",
    fill: "#e1c1c3"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M28 66v-1h1v1z",
    fill: "#e3d1d1"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M30 66v-1h1v1z",
    fill: "#e5d6d8"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M32 66h-1v-1h1z",
    fill: "#e4d7d9"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M32 65h1v1h-1z",
    fill: "#e6dfe1"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66h-1v-1h1z",
    fill: "#e5dbde"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M34 65h1v1h-1z",
    fill: "#e3e4e9"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M35 66v-1h1v1z",
    fill: "#e4e0e5"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65v1h-1v-1z",
    fill: "#e2e2e9"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M39 66v-1h1v1z",
    fill: "#dddfe3"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66h-1v-1h1z",
    fill: "#dbdbe3"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65v1h-1v-1z",
    fill: "#d9dde2"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65h1v1h-1z",
    fill: "#ddd8de"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66h-1v-1h1z",
    fill: "#d8d9dd"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M48 65h1v1h-1z",
    fill: "#d9d9e3"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65v1h-1v-1z",
    fill: "#d7c9ca"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66v-1h1v1z",
    fill: "#d1b3b3"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65h1v1h-1z",
    fill: "#ceb0b2"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M53 66h-1v-1h1z",
    fill: "#ceb1b2"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65v1h-1v-1z",
    fill: "#d1acaf"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66h-1v-1h1z",
    fill: "#c79697"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65v1h-1v-1z",
    fill: "#d7d5db"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M58 66h-1v-1h1z",
    fill: "#d6c9d1"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M60 65v1h-1v-1z",
    fill: "#d4d0d7"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M60 66v-1h1v1z",
    fill: "#d0c3c8"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M62 65v1h-1v-1z",
    fill: "#d2c3c4"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M63 65v1h-1v-1z",
    fill: "#cbb2b7"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M64 65v1h-1v-1z",
    fill: "#d1ccd1"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M67 65h1v1h-1z",
    fill: "#cdccd2",
    fillOpacity: 0.824
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M9 66v1H8v-1z",
    fill: "#c7bebc",
    fillOpacity: 0.812
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M18 66h1v1h-1z",
    fill: "#d7d1d1"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M20 66v1h-1v-1z",
    fill: "#e6e3e7"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M24 66h1v1h-1z",
    fill: "#e9e6e9"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M26 66v1h-1v-1z",
    fill: "#e9e9ea"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M27 66h1v1h-1z",
    fill: "#eaebed"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M30 66h1v1h-1z",
    fill: "#e9e9ed"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M40 66h1v1h-1z",
    fill: "#dbdce2"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M42 67v-1h1v1z",
    fill: "#dcd9e0"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M44 66v1h-1v-1z",
    fill: "#d7bdc0"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M45 67h-1v-1h1z",
    fill: "#cdacab"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h-1v-1h1z",
    fill: "#dbd2d7"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66v1h-1v-1z",
    fill: "#dddae3"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M47 67v-1h1v1z",
    fill: "#d9dbde"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M49 67v-1h1v1z",
    fill: "#d4c7ca"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M52 66h1v1h-1z",
    fill: "#cda9ac"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67v-1h1v1z",
    fill: "#d0b0ae"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66v1h-1v-1z",
    fill: "#d5cdd0"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M55 67v-1h1v1z",
    fill: "#d5ccd0"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M57 67h-1v-1h1z",
    fill: "#cda9ad"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M57 66h1v1h-1z",
    fill: "#ccafb0"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M59 66v1h-1v-1z",
    fill: "#cdafb1"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M59 67v-1h1v1z",
    fill: "#c8a8a7"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M60 67v-1h1v1z",
    fill: "#cdafad"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M62 67h-1v-1h1z",
    fill: "#c9a3a2"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M62 66h1v1h-1z",
    fill: "#cfbbbd"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67h-1v-1h1z",
    fill: "#d2c7ce"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M68 66v1h-1v-1z",
    fill: "#cbcbd1",
    fillOpacity: 0.796
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M8 67h1v1H8z",
    fill: "#c7bdbc",
    fillOpacity: 0.812
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M17 67v1h-1v-1z",
    fill: "#c4bab9"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M24 67v1h-1v-1z",
    fill: "#e9e7e9"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M25 68h-1v-1h1z",
    fill: "#ebe6e7"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M26 67v1h-1v-1z",
    fill: "#eae1e1"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M27 68h-1v-1h1z",
    fill: "#e8dedb"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M28 67v1h-1v-1z",
    fill: "#ead3d7"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M29 67v1h-1v-1z",
    fill: "#e0ccc8"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M30 67v1h-1v-1z",
    fill: "#e2d2d5"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M30 67h1v1h-1z",
    fill: "#e2cecf"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M32 68h-1v-1h1z",
    fill: "#d9c0c0"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M33 68v-1h1v1z",
    fill: "#e1e2e5"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68v-1h1v1z",
    fill: "#e3dfe4"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M36 67h1v1h-1z",
    fill: "#dddcdc"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M39 67h1v1h-1z",
    fill: "#ded4da"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M40 68v-1h1v1z",
    fill: "#ded4d6"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M41 67h1v1h-1z",
    fill: "#dac5cb"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67v1h-1v-1z",
    fill: "#ddd1d4"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67h1v1h-1z",
    fill: "#d2b1b3"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M45 68h-1v-1h1z",
    fill: "#d8c3c1"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h1v1h-1z",
    fill: "#cda7a7"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68v-1h1v1z",
    fill: "#d9c5ca"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M51 67h1v1h-1z",
    fill: "#d4bec1"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M56 67v1h-1v-1z",
    fill: "#d1bbc0"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M56 68v-1h1v1z",
    fill: "#cfb6b5"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M58 68h-1v-1h1z",
    fill: "#ceb2b5"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M58 67h1v1h-1z",
    fill: "#cfc2c3"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M59 67h1v1h-1z",
    fill: "#caa7a7"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M61 67v1h-1v-1z",
    fill: "#d4c4ca"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M61 67h1v1h-1z",
    fill: "#cdaeae"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68h-1v-1h1z",
    fill: "#d0c5cb"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v1h-1v-1z",
    fill: "#ccccd2",
    fillOpacity: 0.765
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M8 69v-1h1v1z",
    fill: "#ccc2c2",
    fillOpacity: 0.792
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M15 69v-1h1v1z",
    fill: "#cac2c0"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M17 68h1v1h-1z",
    fill: "#c6bcba"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M19 68v1h-1v-1z",
    fill: "#d3cbca"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M23 69h-1v-1h1z",
    fill: "#e3dcdf"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M25 68v1h-1v-1z",
    fill: "#e7dada"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M26 69h-1v-1h1z",
    fill: "#ddb9ba"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M27 69h-1v-1h1z",
    fill: "#dfbcbe"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M27 69v-1h1v1z",
    fill: "#e0c2c4"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M28 69v-1h1v1z",
    fill: "#dcb5b4"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M30 68v1h-1v-1z",
    fill: "#d8a6a5"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M30 69v-1h1v1z",
    fill: "#dcb9b6"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M32 69v-1h1v1z",
    fill: "#dec3c4"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69v-1h1v1z",
    fill: "#dcc7cc"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68v1h-1v-1z",
    fill: "#e0dbdd"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M37 69h-1v-1h1z",
    fill: "#d4a4a5"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M38 68v1h-1v-1z",
    fill: "#d6b9bb"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M38 69v-1h1v1z",
    fill: "#d6bfbb"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M39 69v-1h1v1z",
    fill: "#d7b6b8"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69h-1v-1h1z",
    fill: "#d2a5a8"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69h-1v-1h1z",
    fill: "#d6b8b8"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v-1h1v1z",
    fill: "#d3b9ba"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M44 68v1h-1v-1z",
    fill: "#d7babf"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M44 69v-1h1v1z",
    fill: "#dac3c4"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M45 69v-1h1v1z",
    fill: "#d1b0b0"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M49 68v1h-1v-1z",
    fill: "#dadbdf"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69v-1h1v1z",
    fill: "#dad8e0"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M52 69h-1v-1h1z",
    fill: "#d6bcbf"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M57 68v1h-1v-1z",
    fill: "#d2c1c1"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69h-1v-1h1z",
    fill: "#ceabac"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M58 68h1v1h-1z",
    fill: "#cfbabb"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M59 69v-1h1v1z",
    fill: "#cdaeb2"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M60 68h1v1h-1z",
    fill: "#d1bdbd"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M62 68v1h-1v-1z",
    fill: "#c99d9d"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M62 68h1v1h-1z",
    fill: "#cbb2b5"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68v1h-1v-1z",
    fill: "#d1c0c6"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69h-1v-1h1z",
    fill: "#cccad1",
    fillOpacity: 0.729
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M8 69h1v1H8z",
    fill: "#d0c7c6",
    fillOpacity: 0.773
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M22 69h1v1h-1z",
    fill: "#e2dddf"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M24 69v1h-1v-1z",
    fill: "#ece7ea"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M24 70v-1h1v1z",
    fill: "#dcc3c5"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M25 70v-1h1v1z",
    fill: "#dbb4b4"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M26 70v-1h1v1z",
    fill: "#e1c2c1"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M27 70v-1h1v1z",
    fill: "#e4d7d6"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M29 70h-1v-1h1z",
    fill: "#dbb6b7"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M29 70v-1h1v1z",
    fill: "#dab6b4"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M31 70v-1h1v1z",
    fill: "#dcbfbf"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69v1h-1v-1z",
    fill: "#d7afac"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M34 69v1h-1v-1z",
    fill: "#d8c2bf"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M35 70h-1v-1h1z",
    fill: "#dbbcbe"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M36 69v1h-1v-1z",
    fill: "#d29b99"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M36 70v-1h1v1z",
    fill: "#d5aeb1"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70v-1h1v1z",
    fill: "#d8c1bf"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M39 70h-1v-1h1z",
    fill: "#d4adad"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M39 69h1v1h-1z",
    fill: "#dad3d4"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69v1h-1v-1z",
    fill: "#d5b1af"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v1h-1v-1z",
    fill: "#dbc6ca"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M43 69v1h-1v-1z",
    fill: "#d4bdba"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M43 69h1v1h-1z",
    fill: "#d7bbbc"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70h-1v-1h1z",
    fill: "#daced3"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70v-1h1v1z",
    fill: "#d8c5c5"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69v1h-1v-1z",
    fill: "#d9c7cd"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70h-1v-1h1z",
    fill: "#dadae3"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69h1v1h-1z",
    fill: "#d7c8ca"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M51 69h1v1h-1z",
    fill: "#d3afb2"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M53 70v-1h1v1z",
    fill: "#cfb4b6"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M55 70v-1h1v1z",
    fill: "#d4c3c7"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M57 70h-1v-1h1z",
    fill: "#ceacad"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69v1h-1v-1z",
    fill: "#cfb0b0"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M59 69v1h-1v-1z",
    fill: "#d4c7ce"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70v-1h1v1z",
    fill: "#d2cbcf"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M60 70v-1h1v1z",
    fill: "#cfb9bf"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70h-1v-1h1z",
    fill: "#d0c0c3"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69v1h-1v-1z",
    fill: "#cfc3c9"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M67 70v-1h1v1z",
    fill: "#ceccd2",
    fillOpacity: 0.694
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M9 70v1H8v-1z",
    fill: "#d4cfcc",
    fillOpacity: 0.729
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M17 71h-1v-1h1z",
    fill: "#c4bab7"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M18 70h1v1h-1z",
    fill: "#d2cbcd"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M24 71h-1v-1h1z",
    fill: "#e7e6e7"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M24 70h1v1h-1z",
    fill: "#e5d9db"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M25 70h1v1h-1z",
    fill: "#e6d8d7"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M26 70h1v1h-1z",
    fill: "#e0c4be"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M28 70v1h-1v-1z",
    fill: "#e0cecf"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71v-1h1v1z",
    fill: "#e4d4d1"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71h-1v-1h1z",
    fill: "#e2ddde"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71v-1h1v1z",
    fill: "#dcc0c1"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M33 70v1h-1v-1z",
    fill: "#d7b2b0"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M33 71v-1h1v1z",
    fill: "#ddccd1"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M35 70v1h-1v-1z",
    fill: "#d6b5b4"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M35 71v-1h1v1z",
    fill: "#d7adaa"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M36 70h1v1h-1z",
    fill: "#d4a6a7"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70h1v1h-1z",
    fill: "#dacccd"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M38 71v-1h1v1z",
    fill: "#dab1b3"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M40 70v1h-1v-1z",
    fill: "#decdd1"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M41 71h-1v-1h1z",
    fill: "#d4adac"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71h-1v-1h1z",
    fill: "#dcc3c4"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M43 70h1v1h-1z",
    fill: "#d5b1b2"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71h-1v-1h1z",
    fill: "#d5bbbb"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71v-1h1v1z",
    fill: "#d1a5a1"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M46 70h1v1h-1z",
    fill: "#d7b8bc"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M49 71h-1v-1h1z",
    fill: "#dcdae1"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70v1h-1v-1z",
    fill: "#d9dae2"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M50 71v-1h1v1z",
    fill: "#d9d0d4"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M51 71v-1h1v1z",
    fill: "#d1b9bb"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M54 71h-1v-1h1z",
    fill: "#d8d1d7"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M54 71v-1h1v1z",
    fill: "#d8d5de"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M60 71v-1h1v1z",
    fill: "#d6d8de"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M64 70v1h-1v-1z",
    fill: "#d4d0da"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M67 71v-1h1v1z",
    fill: "#cfcdd3",
    fillOpacity: 0.667
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M8 71h1v1H8z",
    fill: "#d3cfcc",
    fillOpacity: 0.671
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M17 71h1v1h-1z",
    fill: "#c6bcb8"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72h-1v-1h1z",
    fill: "#e0ddde"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72v-1h1v1z",
    fill: "#eae4e6"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M25 72h-1v-1h1z",
    fill: "#e7e2e7"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M26 72h-1v-1h1z",
    fill: "#e6dede"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M27 71v1h-1v-1z",
    fill: "#dfc4c2"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71v1h-1v-1z",
    fill: "#e0d2cf"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71h1v1h-1z",
    fill: "#dec5c7"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M30 72h-1v-1h1z",
    fill: "#e3d9db"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71h1v1h-1z",
    fill: "#dac2c1"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71v1h-1v-1z",
    fill: "#dcc3c1"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71h1v1h-1z",
    fill: "#d6b0ad"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M33 71h1v1h-1z",
    fill: "#ddc9c7"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M35 72h-1v-1h1z",
    fill: "#d1a19e"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M35 71h1v1h-1z",
    fill: "#d8b8b6"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M37 71v1h-1v-1z",
    fill: "#d1a2a2"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72v-1h1v1z",
    fill: "#dab6ba"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M39 71v1h-1v-1z",
    fill: "#d4a9a9"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M39 71h1v1h-1z",
    fill: "#d4afb0"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M41 72h-1v-1h1z",
    fill: "#d4b1af"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71v1h-1v-1z",
    fill: "#d3b4b4"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M42 72v-1h1v1z",
    fill: "#d9bcbe"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72v-1h1v1z",
    fill: "#d6c0bf"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71h1v1h-1z",
    fill: "#ddd5dc"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M47 71v1h-1v-1z",
    fill: "#dacfd1"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71v1h-1v-1z",
    fill: "#ded6dc"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71h1v1h-1z",
    fill: "#dedae1"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M50 71h1v1h-1z",
    fill: "#dddce5"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M53 71v1h-1v-1z",
    fill: "#dcdbe3"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72v-1h1v1z",
    fill: "#d7d8df"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72h-1v-1h1z",
    fill: "#cfd1d7"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71v1h-1v-1z",
    fill: "#d6d2dd"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M68 72h-1v-1h1z",
    fill: "#cfcdd4",
    fillOpacity: 0.631
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M9 73H8v-1h1z",
    fill: "#d6d0cd",
    fillOpacity: 0.671
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M16 73h-1v-1h1z",
    fill: "#c8c0be"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72v1h-1v-1z",
    fill: "#dfdadd"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72h1v1h-1z",
    fill: "#e6e4e4"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M25 73v-1h1v1z",
    fill: "#dcbfbe"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M26 73v-1h1v1z",
    fill: "#d9b7b6"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M27 72h1v1h-1z",
    fill: "#dabfbc"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M30 73h-1v-1h1z",
    fill: "#dccbcc"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M30 72h1v1h-1z",
    fill: "#d3abab"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M32 73h-1v-1h1z",
    fill: "#d5b8b5"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M33 73h-1v-1h1z",
    fill: "#d8b5b6"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M34 72v1h-1v-1z",
    fill: "#d5b8b8"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M35 73h-1v-1h1z",
    fill: "#dccacd"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M36 72v1h-1v-1z",
    fill: "#d9c7ca"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72h1v1h-1z",
    fill: "#dccfd2"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73v-1h1v1z",
    fill: "#dfd9dc"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73v-1h1v1z",
    fill: "#dfdbe1"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73v-1h1v1z",
    fill: "#dedbe0"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72v1h-1v-1z",
    fill: "#dad5d8"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73h-1v-1h1z",
    fill: "#d8c3c4"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M52 73h-1v-1h1z",
    fill: "#d3b9bd"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M53 73h-1v-1h1z",
    fill: "#d4c5c6"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72v1h-1v-1z",
    fill: "#cfb0af"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M59 73h-1v-1h1z",
    fill: "#d6d8dd"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M59 72h1v1h-1z",
    fill: "#d6d3d8"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72v1h-1v-1z",
    fill: "#d1c7cb"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M63 72v1h-1v-1z",
    fill: "#d2bcc2"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M67 73v-1h1v1z",
    fill: "#cecdd2",
    fillOpacity: 0.58
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M9 74H8v-1h1z",
    fill: "#d7d0d0",
    fillOpacity: 0.753
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M9 73h1v1H9z",
    fill: "#d2cbc9"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M18 73v1h-1v-1z",
    fill: "#c7bdbc"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M24 74h-1v-1h1z",
    fill: "#e3e0e3"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M25 73v1h-1v-1z",
    fill: "#e5dfe4"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M26 74h-1v-1h1z",
    fill: "#e5d8db"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M26 73h1v1h-1z",
    fill: "#e1cfd1"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M28 74h-1v-1h1z",
    fill: "#e0cfd4"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M39 74v-1h1v1z",
    fill: "#dedde1"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M40 73h1v1h-1z",
    fill: "#dedce0"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M44 74h-1v-1h1z",
    fill: "#dcd1d2"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M44 74v-1h1v1z",
    fill: "#d7c5c7"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74h-1v-1h1z",
    fill: "#dfdbe0"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74v-1h1v1z",
    fill: "#d6b2b3"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73v1h-1v-1z",
    fill: "#d5b5b7"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M51 74v-1h1v1z",
    fill: "#d7bfc2"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h-1v-1h1z",
    fill: "#cea2a3"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M54 73v1h-1v-1z",
    fill: "#d2aeaf"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74h-1v-1h1z",
    fill: "#d3bcc2"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M56 74h-1v-1h1z",
    fill: "#d5ced2"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73v1h-1v-1z",
    fill: "#cfb1b3"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73h1v1h-1z",
    fill: "#cdb1b5"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M59 74h-1v-1h1z",
    fill: "#d1b6ba"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M60 74h-1v-1h1z",
    fill: "#cbafaf"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M61 74h-1v-1h1z",
    fill: "#c9a3a4"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M62 73v1h-1v-1z",
    fill: "#c8a4a5"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M63 74h-1v-1h1z",
    fill: "#cab2b5"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h-1v-1h1z",
    fill: "#d1d0d9"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74h-1v-1h1z",
    fill: "#cfcdd3",
    fillOpacity: 0.529
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M9 75H8v-1h1z",
    fill: "#d2cbcb",
    fillOpacity: 0.816
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M18 74h1v1h-1z",
    fill: "#cfc8c8"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M19 75v-1h1v1z",
    fill: "#e4e1e4"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M24 74v1h-1v-1z",
    fill: "#e7e1e6"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M26 74v1h-1v-1z",
    fill: "#e8e4e7"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M27 74h1v1h-1z",
    fill: "#e2e3e6"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M28 74h1v1h-1z",
    fill: "#e4dfe2"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M29 75v-1h1v1z",
    fill: "#e4e1e7"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74v1h-1v-1z",
    fill: "#dfd8dd"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M36 75v-1h1v1z",
    fill: "#e0dee5"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M39 75h-1v-1h1z",
    fill: "#e0dbe1"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M39 74h1v1h-1z",
    fill: "#dedee1"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74v1h-1v-1z",
    fill: "#dcd1d1"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h1v1h-1z",
    fill: "#d5acae"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75h-1v-1h1z",
    fill: "#d8b7b4"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M45 74h1v1h-1z",
    fill: "#dbc7ca"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M46 74h1v1h-1z",
    fill: "#d8bdbd"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74h1v1h-1z",
    fill: "#e0d7dc"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M50 75v-1h1v1z",
    fill: "#d2b6b6"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h-1v-1h1z",
    fill: "#dbcdd3"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75v-1h1v1z",
    fill: "#d3bbbc"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M56 74v1h-1v-1z",
    fill: "#cfbbba"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M57 75h-1v-1h1z",
    fill: "#cfa8a8"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M57 74h1v1h-1z",
    fill: "#d2bec1"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M58 75v-1h1v1z",
    fill: "#cfafaf"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75h-1v-1h1z",
    fill: "#c9b0ae"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75v-1h1v1z",
    fill: "#cfb5b8"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M62 75h-1v-1h1z",
    fill: "#c9b2b1"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75h-1v-1h1z",
    fill: "#cfb7bd"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75v-1h1v1z",
    fill: "#d4cad1"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74v1h-1v-1z",
    fill: "#cdcbd1",
    fillOpacity: 0.502
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M8 75h1v1H8z",
    fill: "#cfc8c8",
    fillOpacity: 0.855
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M18 76v-1h1v1z",
    fill: "#cfc8c7"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M19 75h1v1h-1z",
    fill: "#e5e2e4"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M20 76v-1h1v1z",
    fill: "#e4e0e3"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M23 75v1h-1v-1z",
    fill: "#ddd9db"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M23 76v-1h1v1z",
    fill: "#e3dfe3"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M25 76h-1v-1h1z",
    fill: "#e3dbdd"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M25 75h1v1h-1z",
    fill: "#dfc5c7"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M26 75h1v1h-1z",
    fill: "#dbc1c1"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M28 75v1h-1v-1z",
    fill: "#ddbebc"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M28 76v-1h1v1z",
    fill: "#d9b6b2"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M30 75v1h-1v-1z",
    fill: "#d9b5b3"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M31 76h-1v-1h1z",
    fill: "#d3b2b0"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76v-1h1v1z",
    fill: "#ded0d4"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M36 76v-1h1v1z",
    fill: "#dbc5c6"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M39 76h-1v-1h1z",
    fill: "#dcd2d4"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M40 75v1h-1v-1z",
    fill: "#d9babb"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M40 76v-1h1v1z",
    fill: "#d9b8ba"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M43 76h-1v-1h1z",
    fill: "#ddc8c8"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M43 75h1v1h-1z",
    fill: "#d7c1c5"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M46 76h-1v-1h1z",
    fill: "#cfa39d"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M47 76h-1v-1h1z",
    fill: "#d3acaa"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M48 75v1h-1v-1z",
    fill: "#dcd6db"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M51 75v1h-1v-1z",
    fill: "#dcd1d4"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76v-1h1v1z",
    fill: "#d4c2c4"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h1v1h-1z",
    fill: "#d4c3c4"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M53 76v-1h1v1z",
    fill: "#d7d1d9"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M55 76h-1v-1h1z",
    fill: "#d5cbcf"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M56 75v1h-1v-1z",
    fill: "#d1bdbe"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76h-1v-1h1z",
    fill: "#cfb7b7"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M59 75v1h-1v-1z",
    fill: "#cfb4b4"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M60 76h-1v-1h1z",
    fill: "#ccacb1"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75h1v1h-1z",
    fill: "#cbb6b7"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M61 75h1v1h-1z",
    fill: "#c8a6a8"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M62 76v-1h1v1z",
    fill: "#ccb2b6"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M64 75v1h-1v-1z",
    fill: "#d0c8cb"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M67 76v-1h1v1z",
    fill: "#ceced3",
    fillOpacity: 0.455
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M8 76v1H7v-1z",
    fill: "#e7dcdc",
    fillOpacity: 0.086
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M8 77v-1h1v1z",
    fill: "#cfc8c6",
    fillOpacity: 0.91
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M18 77h-1v-1h1z",
    fill: "#c6beb8"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M20 76v1h-1v-1z",
    fill: "#e7e3e4"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M23 77v-1h1v1z",
    fill: "#e4e1e3"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M25 76v1h-1v-1z",
    fill: "#ddc1c0"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M25 76h1v1h-1z",
    fill: "#d6b0ac"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M27 76v1h-1v-1z",
    fill: "#e2c6ca"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M27 76h1v1h-1z",
    fill: "#ddc4c1"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M29 76v1h-1v-1z",
    fill: "#d5afb0"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M29 77v-1h1v1z",
    fill: "#cb9994"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M30 76h1v1h-1z",
    fill: "#dec6c9"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M32 76v1h-1v-1z",
    fill: "#d8b5b2"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76v1h-1v-1z",
    fill: "#d9c2c3"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76h1v1h-1z",
    fill: "#d19c9a"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M36 77v-1h1v1z",
    fill: "#d4a8a5"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M37 77v-1h1v1z",
    fill: "#d8b9b8"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M39 77h-1v-1h1z",
    fill: "#d4b0af"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M39 76h1v1h-1z",
    fill: "#dfc7c8"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M40 76h1v1h-1z",
    fill: "#cea09e"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M41 77v-1h1v1z",
    fill: "#ded1cf"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v-1h1v1z",
    fill: "#d9bcbc"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M44 76v1h-1v-1z",
    fill: "#dac0c2"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M45 77h-1v-1h1z",
    fill: "#decdce"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M45 76h1v1h-1z",
    fill: "#ddcacb"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M46 77v-1h1v1z",
    fill: "#d9babd"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M48 76v1h-1v-1z",
    fill: "#e0dde3"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M50 76h1v1h-1z",
    fill: "#d7c7cc"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76h1v1h-1z",
    fill: "#d4c4c6"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77v-1h1v1z",
    fill: "#d4c2c6"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M54 77v-1h1v1z",
    fill: "#dad6de"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M56 77v-1h1v1z",
    fill: "#d1b0b2"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M59 77v-1h1v1z",
    fill: "#cbb9bc"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M61 76v1h-1v-1z",
    fill: "#c9acaf"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M62 77h-1v-1h1z",
    fill: "#cdb0b4"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M63 77h-1v-1h1z",
    fill: "#cfbdc0"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M67 77h-1v-1h1z",
    fill: "#d5d4db"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v1h-1v-1z",
    fill: "#cdcdd2",
    fillOpacity: 0.404
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M8 78H7v-1h1z",
    fill: "#deded5",
    fillOpacity: 0.122
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M9 78H8v-1h1z",
    fill: "#d1c8c7",
    fillOpacity: 0.941
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M14 77h1v1h-1z",
    fill: "#cac5c2"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M16 78h-1v-1h1z",
    fill: "#c9bebd"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M19 77v1h-1v-1z",
    fill: "#d0c8c7"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M20 78h-1v-1h1z",
    fill: "#e6e1e2"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M24 77v1h-1v-1z",
    fill: "#e3dfe0"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M24 78v-1h1v1z",
    fill: "#d9b6b5"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M26 77v1h-1v-1z",
    fill: "#d6b4af"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M26 78v-1h1v1z",
    fill: "#d6c4c2"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M27 78v-1h1v1z",
    fill: "#d6bcbb"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M29 77v1h-1v-1z",
    fill: "#dcc5c7"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M30 78h-1v-1h1z",
    fill: "#e0c4c2"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M30 78v-1h1v1z",
    fill: "#dcc2c6"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78h-1v-1h1z",
    fill: "#d4afac"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78v-1h1v1z",
    fill: "#dbbbbc"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M34 77v1h-1v-1z",
    fill: "#dac3c0"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78h-1v-1h1z",
    fill: "#d9b6b7"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M36 77v1h-1v-1z",
    fill: "#d49f9f"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M37 77v1h-1v-1z",
    fill: "#d6b4b2"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M38 77v1h-1v-1z",
    fill: "#dbc3c5"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78v-1h1v1z",
    fill: "#d7bcb8"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M40 77v1h-1v-1z",
    fill: "#ddcccb"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M40 78v-1h1v1z",
    fill: "#d5b1b1"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v1h-1v-1z",
    fill: "#ddcccf"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77h1v1h-1z",
    fill: "#d8bebb"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M43 77h1v1h-1z",
    fill: "#dbbebc"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M45 77v1h-1v-1z",
    fill: "#d9bab9"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M47 77v1h-1v-1z",
    fill: "#d9bfbe"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M48 77v1h-1v-1z",
    fill: "#d7b9bb"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M50 77v1h-1v-1z",
    fill: "#dbdedf"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M50 78v-1h1v1z",
    fill: "#d4bec2"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M52 77v1h-1v-1z",
    fill: "#cfb1b1"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M52 78v-1h1v1z",
    fill: "#d2b1b5"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M57 77v1h-1v-1z",
    fill: "#d3c9cd"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78h-1v-1h1z",
    fill: "#d4d2db"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M62 78h-1v-1h1z",
    fill: "#d2d2db"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M67 78v-1h1v1z",
    fill: "#ceced0",
    fillOpacity: 0.369
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M7 78h1v1H7z",
    fill: "#d8d2d2",
    fillOpacity: 0.157
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M9 78v1H8v-1z",
    fill: "#d2cac9",
    fillOpacity: 0.961
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M15 78v1h-1v-1z",
    fill: "#cbc5c3"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M18 79h-1v-1h1z",
    fill: "#c8bfba"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M20 78v1h-1v-1z",
    fill: "#e5e0e1"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M23 79h-1v-1h1z",
    fill: "#ded9d9"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M25 78v1h-1v-1z",
    fill: "#e1dadd"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M25 79v-1h1v1z",
    fill: "#ddcdd2"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M26 78h1v1h-1z",
    fill: "#dcc4c6"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M28 78v1h-1v-1z",
    fill: "#dbc0bd"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M30 79h-1v-1h1z",
    fill: "#deced0"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M31 79h-1v-1h1z",
    fill: "#d8c1c3"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M33 78v1h-1v-1z",
    fill: "#d8bdb9"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78v1h-1v-1z",
    fill: "#d9aeb0"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M35 79v-1h1v1z",
    fill: "#d9b0ae"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M37 79h-1v-1h1z",
    fill: "#d4afa9"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78v1h-1v-1z",
    fill: "#cea3a1"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78h1v1h-1z",
    fill: "#dec0c0"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M40 79v-1h1v1z",
    fill: "#d3a3a0"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M41 78h1v1h-1z",
    fill: "#d8b9b5"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78v1h-1v-1z",
    fill: "#d6aaa7"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78h1v1h-1z",
    fill: "#d3aeab"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78v1h-1v-1z",
    fill: "#d4b6b4"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78v1h-1v-1z",
    fill: "#d7bbba"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78h1v1h-1z",
    fill: "#d9cccf"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M50 79h-1v-1h1z",
    fill: "#ddd9e1"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M54 78v1h-1v-1z",
    fill: "#d9dde3"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M54 79v-1h1v1z",
    fill: "#d9dbe1"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M61 79v-1h1v1z",
    fill: "#d0d0d7"
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M62 79v-1h1v1z",
    fill: "#d1d1d8"
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M68 78v1h-1v-1z",
    fill: "#d0d0d3",
    fillOpacity: 0.325
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M8 79v1H7v-1z",
    fill: "#d2d2d2",
    fillOpacity: 0.18
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M8 79h1v1H8z",
    fill: "#cfc7c7",
    fillOpacity: 0.976
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M17 80v-1h1v1z",
    fill: "#c9c0bc"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M20 80h-1v-1h1z",
    fill: "#e3dede"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M23 79v1h-1v-1z",
    fill: "#ddd6d9"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M24 79v1h-1v-1z",
    fill: "#dfd9db"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M24 79h1v1h-1z",
    fill: "#e1dedf"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M26 80h-1v-1h1z",
    fill: "#dcc5c5"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M26 80v-1h1v1z",
    fill: "#dbcecb"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M29 79v1h-1v-1z",
    fill: "#d7c1bf"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80h-1v-1h1z",
    fill: "#d9bfbf"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M31 79v1h-1v-1z",
    fill: "#dbbbbb"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M31 80v-1h1v1z",
    fill: "#d6b2b0"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M32 79h1v1h-1z",
    fill: "#d4aba8"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M33 79h1v1h-1z",
    fill: "#d7b5b4"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M34 80v-1h1v1z",
    fill: "#d3acab"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M36 80h-1v-1h1z",
    fill: "#d3b0ae"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M36 80v-1h1v1z",
    fill: "#d8b2b4"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M37 80v-1h1v1z",
    fill: "#d9bfc2"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M39 79h1v1h-1z",
    fill: "#dbbfc1"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M41 79v1h-1v-1z",
    fill: "#e0d0d3"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M41 79h1v1h-1z",
    fill: "#decccf"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M45 79h1v1h-1z",
    fill: "#e0dde1"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M47 80h-1v-1h1z",
    fill: "#dfdde5"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M49 80v-1h1v1z",
    fill: "#ded9dc"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M50 80v-1h1v1z",
    fill: "#dacdd1"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M52 80h-1v-1h1z",
    fill: "#d7ccd2"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M53 79v1h-1v-1z",
    fill: "#d8cbd1"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M54 80h-1v-1h1z",
    fill: "#cfa4a8"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M54 79h1v1h-1z",
    fill: "#cb9da0"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79v1h-1v-1z",
    fill: "#d6d9df"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80v-1h1v1z",
    fill: "#d2cfd9"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M64 80v-1h1v1z",
    fill: "#ceccd4"
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M65 79h1v1h-1z",
    fill: "#d0ced6"
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M68 79v1h-1v-1z",
    fill: "#d0cdd4",
    fillOpacity: 0.282
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M7 80h1v1H7z",
    fill: "#d2cdcd",
    fillOpacity: 0.204
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M9 81H8v-1h1z",
    fill: "#cec6c5",
    fillOpacity: 0.988
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M16 80v1h-1v-1z",
    fill: "#c6bbba"
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M19 80h1v1h-1z",
    fill: "#dfdada"
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M23 81h-1v-1h1z",
    fill: "#ddd6da"
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M23 81v-1h1v1z",
    fill: "#e0dcdd"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M24 80h1v1h-1z",
    fill: "#e3dddf"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M25 80h1v1h-1z",
    fill: "#d3b5b4"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M27 80v1h-1v-1z",
    fill: "#d5b0ae"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M27 81v-1h1v1z",
    fill: "#d7b3b5"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M28 80h1v1h-1z",
    fill: "#ddcbcb"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80v1h-1v-1z",
    fill: "#dfcece"
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80h1v1h-1z",
    fill: "#d5b8bd"
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M32 80v1h-1v-1z",
    fill: "#dcc8c9"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M32 80h1v1h-1z",
    fill: "#dccdcf"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M34 81h-1v-1h1z",
    fill: "#ddced2"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M35 81v-1h1v1z",
    fill: "#e0dadd"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M38 80v1h-1v-1z",
    fill: "#e2dbe2"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M41 81v-1h1v1z",
    fill: "#dfdddf"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M43 81v-1h1v1z",
    fill: "#e1dee1"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M45 80v1h-1v-1z",
    fill: "#dfd6d9"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81h-1v-1h1z",
    fill: "#dddcdf"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81h-1v-1h1z",
    fill: "#c9888f"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81v-1h1v1z",
    fill: "#bc3b44"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M52 81h-1v-1h1z",
    fill: "#c25c64"
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "M52 81v-1h1v1z",
    fill: "#ca7d7f"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M54 81h-1v-1h1z",
    fill: "#b6474d"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "M54 80h1v1h-1z",
    fill: "#ce9ea0"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81h-1v-1h1z",
    fill: "#dad2d6"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "M57 80v1h-1v-1z",
    fill: "#cea2a6"
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M57 81v-1h1v1z",
    fill: "#ca999b"
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M58 80h1v1h-1z",
    fill: "#d3c1c4"
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M60 81h-1v-1h1z",
    fill: "#c6969d"
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80h1v1h-1z",
    fill: "#c38a8d"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80v1h-1v-1z",
    fill: "#c27378"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "M63 81h-1v-1h1z",
    fill: "#bf6a74"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80h1v1h-1z",
    fill: "#d4cfd7"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81h-1v-1h1z",
    fill: "#cfccd5"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "M65 80h1v1h-1z",
    fill: "#d1ced7"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81v-1h1v1z",
    fill: "#cdcdd1",
    fillOpacity: 0.243
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M8 81v1H7v-1z",
    fill: "#cecec5",
    fillOpacity: 0.227
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M9 82H8v-1h1z",
    fill: "#cec6c5"
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M9 82v-1h1v1z",
    fill: "#d2caca"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "M13 82v-1h1v1z",
    fill: "#d1c8c5"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "M17 82v-1h1v1z",
    fill: "#ccc1bf"
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "M20 81v1h-1v-1z",
    fill: "#ddd8d9"
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "M22 82v-1h1v1z",
    fill: "#dfdadc"
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "M24 81v1h-1v-1z",
    fill: "#e0dbdc"
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "M25 82h-1v-1h1z",
    fill: "#e1dbdd"
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "M25 82v-1h1v1z",
    fill: "#e2dade"
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82h-1v-1h1z",
    fill: "#e1dee2"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "M34 81v1h-1v-1z",
    fill: "#ded9de"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "M35 81v1h-1v-1z",
    fill: "#dcd9de"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "M36 81v1h-1v-1z",
    fill: "#ded9df"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "M41 82v-1h1v1z",
    fill: "#e2e0e7"
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v-1h1v1z",
    fill: "#dcc9cc"
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "M44 81v1h-1v-1z",
    fill: "#c5686f"
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "M44 82v-1h1v1z",
    fill: "#ca7f81"
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "M46 82v-1h1v1z",
    fill: "#ded2d8"
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82h-1v-1h1z",
    fill: "#dac5c7"
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "M51 81v1h-1v-1z",
    fill: "#c1575e"
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "M51 82v-1h1v1z",
    fill: "#bb2e3b"
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "M53 82h-1v-1h1z",
    fill: "#ba4c50"
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "M54 82v-1h1v1z",
    fill: "#dcdee1"
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81v1h-1v-1z",
    fill: "#be7174"
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "M57 82h-1v-1h1z",
    fill: "#ba3e45"
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "M58 81v1h-1v-1z",
    fill: "#b52b33"
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82v-1h1v1z",
    fill: "#bf6469"
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "M59 82v-1h1v1z",
    fill: "#b64047"
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v-1h1v1z",
    fill: "#be575a"
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h-1v-1h1z",
    fill: "#b95155"
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "M63 82h-1v-1h1z",
    fill: "#bb525c"
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h-1v-1h1z",
    fill: "#d0cdd4",
    fillOpacity: 0.992
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81h1v1h-1z",
    fill: "#cdcdd2",
    fillOpacity: 0.204
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "M7 83v-1h1v1z",
    fill: "#cecec6",
    fillOpacity: 0.247
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "M17 82h1v1h-1z",
    fill: "#cdc2c0"
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "M19 82v1h-1v-1z",
    fill: "#d2c8c5"
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "M20 83h-1v-1h1z",
    fill: "#dbd5d5"
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "M23 83h-1v-1h1z",
    fill: "#ded8db"
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "M24 82h1v1h-1z",
    fill: "#e2dcdc"
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "M26 83h-1v-1h1z",
    fill: "#e1dbdc"
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "M26 83v-1h1v1z",
    fill: "#e0d5d6"
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "M27 82h1v1h-1z",
    fill: "#e0cbcf"
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "M28 83v-1h1v1z",
    fill: "#dfc1c5"
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "M29 83v-1h1v1z",
    fill: "#e0cfd2"
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82v1h-1v-1z",
    fill: "#d3a8a7"
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82h1v1h-1z",
    fill: "#dac3c3"
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82h1v1h-1z",
    fill: "#dfcdd0"
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "M41 83h-1v-1h1z",
    fill: "#dcc1c4"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v1h-1v-1z",
    fill: "#dabcc0"
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82h1v1h-1z",
    fill: "#dec3c5"
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "M44 83h-1v-1h1z",
    fill: "#be3842"
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "M45 82v1h-1v-1z",
    fill: "#cc6f74"
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "M45 82h1v1h-1z",
    fill: "#c8797d"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "M47 83h-1v-1h1z",
    fill: "#ca7d85"
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82v1h-1v-1z",
    fill: "#dbdfe6"
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "M50 83v-1h1v1z",
    fill: "#d6b1b4"
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "M52 82v1h-1v-1z",
    fill: "#b4292f"
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "M52 83v-1h1v1z",
    fill: "#c6727b"
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "M53 83v-1h1v1z",
    fill: "#dbe2e8"
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "M54 82h1v1h-1z",
    fill: "#d3bcbf"
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "M56 82h1v1h-1z",
    fill: "#ca757a"
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83h-1v-1h1z",
    fill: "#b8474e"
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82h1v1h-1z",
    fill: "#bd6166"
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v1h-1v-1z",
    fill: "#ba4d4e"
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82h1v1h-1z",
    fill: "#b84c52"
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "M61 82h1v1h-1z",
    fill: "#b74349"
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h1v1h-1z",
    fill: "#b64a54"
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "M63 83v-1h1v1z",
    fill: "#d3cdd1"
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "M66 82h1v1h-1z",
    fill: "#cfcdd3",
    fillOpacity: 0.976
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h1v1h-1z",
    fill: "#cfcfcf",
    fillOpacity: 0.169
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "M8 84H7v-1h1z",
    fill: "#d1cdcd",
    fillOpacity: 0.263
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "M11 84v-1h1v1z",
    fill: "#d7cdcb"
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "M18 83v1h-1v-1z",
    fill: "#cfc4c2"
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "M18 84v-1h1v1z",
    fill: "#d3c8c6"
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "M20 83v1h-1v-1z",
    fill: "#dbd2d2"
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "M23 83v1h-1v-1z",
    fill: "#d8d3d4"
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "M23 84v-1h1v1z",
    fill: "#dad6d6"
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "M24 83h1v1h-1z",
    fill: "#d29097"
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "M26 84h-1v-1h1z",
    fill: "#c55960"
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "M27 83v1h-1v-1z",
    fill: "#c55159"
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "M28 83v1h-1v-1z",
    fill: "#c24852"
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "M29 84h-1v-1h1z",
    fill: "#bb3b42"
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "M30 83v1h-1v-1z",
    fill: "#c95d66"
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "M30 83h1v1h-1z",
    fill: "#bb2a36"
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "M32 83v1h-1v-1z",
    fill: "#d59899"
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "M32 84v-1h1v1z",
    fill: "#d7b0b1"
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "M33 84v-1h1v1z",
    fill: "#decdcd"
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84h-1v-1h1z",
    fill: "#d5b8be"
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84v-1h1v1z",
    fill: "#cb7f83"
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "M37 84h-1v-1h1z",
    fill: "#c66c71"
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84v-1h1v1z",
    fill: "#c7797d"
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "M39 84v-1h1v1z",
    fill: "#be474d"
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84h-1v-1h1z",
    fill: "#bf444d"
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "M42 83v1h-1v-1z",
    fill: "#bb3940"
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "M42 83h1v1h-1z",
    fill: "#dcb7b7"
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "M44 84h-1v-1h1z",
    fill: "#bc464d"
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "M45 84h-1v-1h1z",
    fill: "#be3843"
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "M45 83h1v1h-1z",
    fill: "#be3e47"
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "M46 84v-1h1v1z",
    fill: "#deb6bc"
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "M47 84v-1h1v1z",
    fill: "#dcdfe1"
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "M49 83h1v1h-1z",
    fill: "#dcdbe4"
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "M50 83h1v1h-1z",
    fill: "#d3a3a8"
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "M51 83h1v1h-1z",
    fill: "#b5262b"
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "M52 83h1v1h-1z",
    fill: "#c05f64"
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84v-1h1v1z",
    fill: "#d8d9dc"
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "M55 83v1h-1v-1z",
    fill: "#d4cbce"
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "M55 84v-1h1v1z",
    fill: "#b64b50"
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "M56 84v-1h1v1z",
    fill: "#b6363f"
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83v1h-1v-1z",
    fill: "#b5494c"
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "M59 83v1h-1v-1z",
    fill: "#ccadb3"
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "M59 83h1v1h-1z",
    fill: "#bb6c71"
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "M60 84v-1h1v1z",
    fill: "#b64e55"
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "M62 84h-1v-1h1z",
    fill: "#bc6a6f"
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "M62 83h1v1h-1z",
    fill: "#c8989f"
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "M66 84v-1h1v1z",
    fill: "#cfcdd2",
    fillOpacity: 0.961
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "M68 83v1h-1v-1z",
    fill: "#ccc",
    fillOpacity: 0.137
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "M7 85v-1h1v1z",
    fill: "#d0ccc9",
    fillOpacity: 0.278
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "M8 85v-1h1v1z",
    fill: "#d3ccc9"
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "M10 85v-1h1v1z",
    fill: "#d1c8c7"
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "M11 85v-1h1v1z",
    fill: "#d8cdcb"
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "M12 85v-1h1v1z",
    fill: "#d4cbc9"
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "M18 85h-1v-1h1z",
    fill: "#d0c5c3"
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "M19 85h-1v-1h1z",
    fill: "#d4c9c7"
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "M19 85v-1h1v1z",
    fill: "#d7cece"
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "M25 84v1h-1v-1z",
    fill: "#bb4f53"
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "M26 84v1h-1v-1z",
    fill: "#cb6a6f"
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "M26 85v-1h1v1z",
    fill: "#bc2833"
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "M28 84v1h-1v-1z",
    fill: "#ca7073"
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "M29 84v1h-1v-1z",
    fill: "#d0888d"
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "M30 84v1h-1v-1z",
    fill: "#ce7d82"
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "M30 84h1v1h-1z",
    fill: "#bc3037"
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "M32 85h-1v-1h1z",
    fill: "#c55258"
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "M32 84h1v1h-1z",
    fill: "#b92d37"
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "M34 84v1h-1v-1z",
    fill: "#ca8588"
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "M34 84h1v1h-1z",
    fill: "#ce8d90"
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84h1v1h-1z",
    fill: "#d48385"
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "M36 85v-1h1v1z",
    fill: "#bb353d"
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84v1h-1v-1z",
    fill: "#d48c90"
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84h1v1h-1z",
    fill: "#c55d63"
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "M39 84h1v1h-1z",
    fill: "#c15058"
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84v1h-1v-1z",
    fill: "#cd7b80"
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84h1v1h-1z",
    fill: "#bb2e3d"
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84v1h-1v-1z",
    fill: "#d8acab"
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84h1v1h-1z",
    fill: "#c14550"
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "M45 85h-1v-1h1z",
    fill: "#c23f4a"
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "M46 85h-1v-1h1z",
    fill: "#b82f38"
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "M47 85h-1v-1h1z",
    fill: "#bd4e54"
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "M48 84v1h-1v-1z",
    fill: "#d9cbcf"
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "M48 85v-1h1v1z",
    fill: "#dadae4"
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "M50 85h-1v-1h1z",
    fill: "#dbd9dc"
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "M50 84h1v1h-1z",
    fill: "#c67c82"
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "M51 84h1v1h-1z",
    fill: "#bb515a"
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "M53 85h-1v-1h1z",
    fill: "#c17b81"
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "M56 84h1v1h-1z",
    fill: "#cca3a8"
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "M58 84v1h-1v-1z",
    fill: "#d1bfc5"
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "M60 85h-1v-1h1z",
    fill: "#cfc8cc"
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "M61 85h-1v-1h1z",
    fill: "#d0c6cd"
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "M62 85v-1h1v1z",
    fill: "#d4d1da"
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "M66 84h1v1h-1z",
    fill: "#d0cdd3",
    fillOpacity: 0.937
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85v-1h1v1z",
    fill: "#d9d9d9",
    fillOpacity: 0.106
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "M7 85h1v1H7z",
    fill: "#d2cfcc",
    fillOpacity: 0.294
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "M9 86H8v-1h1z",
    fill: "#d5cdcb"
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "M10 85h1v1h-1z",
    fill: "#d4cac8"
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "M11 86v-1h1v1z",
    fill: "#dacfcd"
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "M12 85h1v1h-1z",
    fill: "#d7cecc"
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "M17 86h-1v-1h1z",
    fill: "#c7bcba"
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "M18 86h-1v-1h1z",
    fill: "#d1c6c4"
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "M19 85v1h-1v-1z",
    fill: "#d3c9c6"
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "M20 86h-1v-1h1z",
    fill: "#d2c9c9"
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "M23 86v-1h1v1z",
    fill: "#d6ced1"
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "M25 85h1v1h-1z",
    fill: "#d39a9f"
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "M27 86h-1v-1h1z",
    fill: "#b92531"
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "M27 85h1v1h-1z",
    fill: "#cd878c"
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "M28 86v-1h1v1z",
    fill: "#e1e7eb"
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "M30 85v1h-1v-1z",
    fill: "#d09d9e"
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "M30 86v-1h1v1z",
    fill: "#c13642"
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "M32 85v1h-1v-1z",
    fill: "#d6979a"
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "M33 85v1h-1v-1z",
    fill: "#ba3b42"
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "M34 86h-1v-1h1z",
    fill: "#cc7073"
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "M35 86h-1v-1h1z",
    fill: "#c56c72"
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "M35 85h1v1h-1z",
    fill: "#ca5e66"
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "M37 86h-1v-1h1z",
    fill: "#c53d48"
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "M38 85v1h-1v-1z",
    fill: "#d17e83"
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "M38 86v-1h1v1z",
    fill: "#c15659"
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86h-1v-1h1z",
    fill: "#bd4b53"
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v-1h1v1z",
    fill: "#c67071"
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "M41 85h1v1h-1z",
    fill: "#b93038"
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "M43 86h-1v-1h1z",
    fill: "#cc888a"
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "M44 86h-1v-1h1z",
    fill: "#b73946"
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "M45 85v1h-1v-1z",
    fill: "#c47073"
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "M46 85v1h-1v-1z",
    fill: "#cc8a8e"
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "M47 86h-1v-1h1z",
    fill: "#c78387"
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86h-1v-1h1z",
    fill: "#d9cfd4"
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86v-1h1v1z",
    fill: "#dad6da"
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "M52 86v-1h1v1z",
    fill: "#dcd9e1"
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "M54 85h1v1h-1z",
    fill: "#d5d6dc"
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "M55 85h1v1h-1z",
    fill: "#d5d3dd"
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "M57 85v1h-1v-1z",
    fill: "#d3d7da"
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "M57 86v-1h1v1z",
    fill: "#d2d1db"
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "M59 86v-1h1v1z",
    fill: "#cecbd4"
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "M61 86h-1v-1h1z",
    fill: "#cbccd1"
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "M62 86h-1v-1h1z",
    fill: "#cecad1"
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "M62 85h1v1h-1z",
    fill: "#ceced5"
  })), _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "M64 85v1h-1v-1z",
    fill: "#d2ced5"
  })), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85v1h-1v-1z",
    fill: "#ceccd1",
    fillOpacity: 0.91
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85h1v1h-1z",
    fill: "#d8d8d8",
    fillOpacity: 0.078
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "M7 86h1v1H7z",
    fill: "#d9d2d2",
    fillOpacity: 0.318
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "M9 86v1H8v-1z",
    fill: "#d8cfcd"
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "M10 86h1v1h-1z",
    fill: "#d5cbc8"
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "M11 86h1v1h-1z",
    fill: "#dcd1ce"
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "M12 87v-1h1v1z",
    fill: "#d9cfce"
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "M17 87v-1h1v1z",
    fill: "#d2c8c6"
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "M21 86v1h-1v-1z",
    fill: "#ddd7da"
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "M22 87h-1v-1h1z",
    fill: "#d8d3d7"
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "M22 86h1v1h-1z",
    fill: "#d6d0d3"
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "M25 86v1h-1v-1z",
    fill: "#dbdfe3"
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "M26 87h-1v-1h1z",
    fill: "#cf8e94"
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "M26 87v-1h1v1z",
    fill: "#b52331"
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "M27 86h1v1h-1z",
    fill: "#ce878c"
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "M29 87h-1v-1h1z",
    fill: "#dedfe3"
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "M29 86h1v1h-1z",
    fill: "#cf8588"
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "M31 87v-1h1v1z",
    fill: "#d18e91"
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "M33 86v1h-1v-1z",
    fill: "#ba363f"
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "M33 86h1v1h-1z",
    fill: "#c05156"
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "M34 87v-1h1v1z",
    fill: "#bf4950"
  })), _path2271 || (_path2271 = /*#__PURE__*/React.createElement("path", {
    d: "M35 86h1v1h-1z",
    fill: "#c75e65"
  })), _path2272 || (_path2272 = /*#__PURE__*/React.createElement("path", {
    d: "M36 87v-1h1v1z",
    fill: "#be565d"
  })), _path2273 || (_path2273 = /*#__PURE__*/React.createElement("path", {
    d: "M38 87h-1v-1h1z",
    fill: "#ca8484"
  })), _path2274 || (_path2274 = /*#__PURE__*/React.createElement("path", {
    d: "M39 87h-1v-1h1z",
    fill: "#c26f72"
  })), _path2275 || (_path2275 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v1h-1v-1z",
    fill: "#c98689"
  })), _path2276 || (_path2276 = /*#__PURE__*/React.createElement("path", {
    d: "M41 86v1h-1v-1z",
    fill: "#d2a4a6"
  })), _path2277 || (_path2277 = /*#__PURE__*/React.createElement("path", {
    d: "M41 87v-1h1v1z",
    fill: "#d2a1a6"
  })), _path2278 || (_path2278 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v-1h1v1z",
    fill: "#d7c5c8"
  })), _path2279 || (_path2279 = /*#__PURE__*/React.createElement("path", {
    d: "M43 87v-1h1v1z",
    fill: "#d8c1c4"
  })), _path2280 || (_path2280 = /*#__PURE__*/React.createElement("path", {
    d: "M50 86h1v1h-1z",
    fill: "#d8d3d8"
  })), _path2281 || (_path2281 = /*#__PURE__*/React.createElement("path", {
    d: "M54 86v1h-1v-1z",
    fill: "#d0bebd"
  })), _path2282 || (_path2282 = /*#__PURE__*/React.createElement("path", {
    d: "M55 87v-1h1v1z",
    fill: "#d6d4dc"
  })), _path2283 || (_path2283 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87h-1v-1h1z",
    fill: "#d3d5da"
  })), _path2284 || (_path2284 = /*#__PURE__*/React.createElement("path", {
    d: "M59 87v-1h1v1z",
    fill: "#cfccd4"
  })), _path2285 || (_path2285 = /*#__PURE__*/React.createElement("path", {
    d: "M62 87h-1v-1h1z",
    fill: "#cdcad3"
  })), _path2286 || (_path2286 = /*#__PURE__*/React.createElement("path", {
    d: "M63 87v-1h1v1z",
    fill: "#d2cfd5"
  })), _path2287 || (_path2287 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87h-1v-1h1z",
    fill: "#cfcdd1",
    fillOpacity: 0.882
  })), _path2288 || (_path2288 = /*#__PURE__*/React.createElement("path", {
    d: "M7 87h1v1H7z",
    fill: "#dbd8d8",
    fillOpacity: 0.341
  })), _path2289 || (_path2289 = /*#__PURE__*/React.createElement("path", {
    d: "M8 87h1v1H8z",
    fill: "#d9d3d1"
  })), _path2290 || (_path2290 = /*#__PURE__*/React.createElement("path", {
    d: "M10 87h1v1h-1z",
    fill: "#d4cac7"
  })), _path2291 || (_path2291 = /*#__PURE__*/React.createElement("path", {
    d: "M12 87v1h-1v-1z",
    fill: "#dacfcc"
  })), _path2292 || (_path2292 = /*#__PURE__*/React.createElement("path", {
    d: "M13 87v1h-1v-1z",
    fill: "#d8cecd"
  })), _path2293 || (_path2293 = /*#__PURE__*/React.createElement("path", {
    d: "M20 87h1v1h-1z",
    fill: "#d6cfd0"
  })), _path2294 || (_path2294 = /*#__PURE__*/React.createElement("path", {
    d: "M21 88v-1h1v1z",
    fill: "#d9d4d7"
  })), _path2295 || (_path2295 = /*#__PURE__*/React.createElement("path", {
    d: "M25 88h-1v-1h1z",
    fill: "#d9c9c9"
  })), _path2296 || (_path2296 = /*#__PURE__*/React.createElement("path", {
    d: "M25 87h1v1h-1z",
    fill: "#be5058"
  })), _path2297 || (_path2297 = /*#__PURE__*/React.createElement("path", {
    d: "M27 88h-1v-1h1z",
    fill: "#b82c35"
  })), _path2298 || (_path2298 = /*#__PURE__*/React.createElement("path", {
    d: "M27 87h1v1h-1z",
    fill: "#be6268"
  })), _path2299 || (_path2299 = /*#__PURE__*/React.createElement("path", {
    d: "M28 88v-1h1v1z",
    fill: "#dcd0d1"
  })), _path2300 || (_path2300 = /*#__PURE__*/React.createElement("path", {
    d: "M30 88h-1v-1h1z",
    fill: "#c57e82"
  })), _path2301 || (_path2301 = /*#__PURE__*/React.createElement("path", {
    d: "M31 88h-1v-1h1z",
    fill: "#c26569"
  })), _path2302 || (_path2302 = /*#__PURE__*/React.createElement("path", {
    d: "M32 88h-1v-1h1z",
    fill: "#d3a7a7"
  })), _path2303 || (_path2303 = /*#__PURE__*/React.createElement("path", {
    d: "M33 88h-1v-1h1z",
    fill: "#ce9797"
  })), _path2304 || (_path2304 = /*#__PURE__*/React.createElement("path", {
    d: "M33 88v-1h1v1z",
    fill: "#d6b3b9"
  })), _path2305 || (_path2305 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88h-1v-1h1z",
    fill: "#dbc9cf"
  })), _path2306 || (_path2306 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88v-1h1v1z",
    fill: "#dcc9d0"
  })), _path2307 || (_path2307 = /*#__PURE__*/React.createElement("path", {
    d: "M36 88v-1h1v1z",
    fill: "#ded3d9"
  })), _path2308 || (_path2308 = /*#__PURE__*/React.createElement("path", {
    d: "M38 88v-1h1v1z",
    fill: "#dddae1"
  })), _path2309 || (_path2309 = /*#__PURE__*/React.createElement("path", {
    d: "M40 88h-1v-1h1z",
    fill: "#dbdde2"
  })), _path2310 || (_path2310 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v1h-1v-1z",
    fill: "#dcdee3"
  })), _path2311 || (_path2311 = /*#__PURE__*/React.createElement("path", {
    d: "M50 87v1h-1v-1z",
    fill: "#cfacab"
  })), _path2312 || (_path2312 = /*#__PURE__*/React.createElement("path", {
    d: "M50 88v-1h1v1z",
    fill: "#cfb1b2"
  })), _path2313 || (_path2313 = /*#__PURE__*/React.createElement("path", {
    d: "M53 87v1h-1v-1z",
    fill: "#cba9a8"
  })), _path2314 || (_path2314 = /*#__PURE__*/React.createElement("path", {
    d: "M53 88v-1h1v1z",
    fill: "#c99f9e"
  })), _path2315 || (_path2315 = /*#__PURE__*/React.createElement("path", {
    d: "M55 88h-1v-1h1z",
    fill: "#ceb9bc"
  })), _path2316 || (_path2316 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87v1h-1v-1z",
    fill: "#d1c0c4"
  })), _path2317 || (_path2317 = /*#__PURE__*/React.createElement("path", {
    d: "M57 88v-1h1v1z",
    fill: "#cec0c2"
  })), _path2318 || (_path2318 = /*#__PURE__*/React.createElement("path", {
    d: "M59 88h-1v-1h1z",
    fill: "#cfc9d2"
  })), _path2319 || (_path2319 = /*#__PURE__*/React.createElement("path", {
    d: "M59 87h1v1h-1z",
    fill: "#c8b7b8"
  })), _path2320 || (_path2320 = /*#__PURE__*/React.createElement("path", {
    d: "M60 88v-1h1v1z",
    fill: "#c9aeaf"
  })), _path2321 || (_path2321 = /*#__PURE__*/React.createElement("path", {
    d: "M61 87h1v1h-1z",
    fill: "#c3a8ab"
  })), _path2322 || (_path2322 = /*#__PURE__*/React.createElement("path", {
    d: "M62 88v-1h1v1z",
    fill: "#cab2b7"
  })), _path2323 || (_path2323 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87v1h-1v-1z",
    fill: "#cdcbd0",
    fillOpacity: 0.855
  })), _path2324 || (_path2324 = /*#__PURE__*/React.createElement("path", {
    d: "M7 88h1v1H7z",
    fill: "#dedede",
    fillOpacity: 0.369
  })), _path2325 || (_path2325 = /*#__PURE__*/React.createElement("path", {
    d: "M8 89v-1h1v1z",
    fill: "#e2dfde"
  })), _path2326 || (_path2326 = /*#__PURE__*/React.createElement("path", {
    d: "M10 89v-1h1v1z",
    fill: "#d1c8c4"
  })), _path2327 || (_path2327 = /*#__PURE__*/React.createElement("path", {
    d: "M12 89h-1v-1h1z",
    fill: "#d6ccc8"
  })), _path2328 || (_path2328 = /*#__PURE__*/React.createElement("path", {
    d: "M13 88v1h-1v-1z",
    fill: "#d6cdcb"
  })), _path2329 || (_path2329 = /*#__PURE__*/React.createElement("path", {
    d: "M17 89h-1v-1h1z",
    fill: "#cabfbd"
  })), _path2330 || (_path2330 = /*#__PURE__*/React.createElement("path", {
    d: "M20 88h1v1h-1z",
    fill: "#d5cfcc"
  })), _path2331 || (_path2331 = /*#__PURE__*/React.createElement("path", {
    d: "M21 89v-1h1v1z",
    fill: "#d9d4d6"
  })), _path2332 || (_path2332 = /*#__PURE__*/React.createElement("path", {
    d: "M25 89h-1v-1h1z",
    fill: "#d7cacf"
  })), _path2333 || (_path2333 = /*#__PURE__*/React.createElement("path", {
    d: "M27 88v1h-1v-1z",
    fill: "#d4b5b7"
  })), _path2334 || (_path2334 = /*#__PURE__*/React.createElement("path", {
    d: "M28 88v1h-1v-1z",
    fill: "#d9c9cc"
  })), _path2335 || (_path2335 = /*#__PURE__*/React.createElement("path", {
    d: "M28 88h1v1h-1z",
    fill: "#d9d5d8"
  })), _path2336 || (_path2336 = /*#__PURE__*/React.createElement("path", {
    d: "M30 88v1h-1v-1z",
    fill: "#dbd7da"
  })), _path2337 || (_path2337 = /*#__PURE__*/React.createElement("path", {
    d: "M31 89v-1h1v1z",
    fill: "#dadadd"
  })), _path2338 || (_path2338 = /*#__PURE__*/React.createElement("path", {
    d: "M32 89v-1h1v1z",
    fill: "#dadce0"
  })), _path2339 || (_path2339 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89h-1v-1h1z",
    fill: "#dcd8dd"
  })), _path2340 || (_path2340 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89v-1h1v1z",
    fill: "#d7cbd0"
  })), _path2341 || (_path2341 = /*#__PURE__*/React.createElement("path", {
    d: "M44 88v1h-1v-1z",
    fill: "#cfaead"
  })), _path2342 || (_path2342 = /*#__PURE__*/React.createElement("path", {
    d: "M45 89h-1v-1h1z",
    fill: "#d5c4c9"
  })), _path2343 || (_path2343 = /*#__PURE__*/React.createElement("path", {
    d: "M48 89v-1h1v1z",
    fill: "#d6cfd1"
  })), _path2344 || (_path2344 = /*#__PURE__*/React.createElement("path", {
    d: "M49 89v-1h1v1z",
    fill: "#ceaaac"
  })), _path2345 || (_path2345 = /*#__PURE__*/React.createElement("path", {
    d: "M51 88v1h-1v-1z",
    fill: "#dbcfd1"
  })), _path2346 || (_path2346 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89h-1v-1h1z",
    fill: "#cba9a6"
  })), _path2347 || (_path2347 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89v-1h1v1z",
    fill: "#d6cfd3"
  })), _path2348 || (_path2348 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89h-1v-1h1z",
    fill: "#caabad"
  })), _path2349 || (_path2349 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89v-1h1v1z",
    fill: "#caa8a5"
  })), _path2350 || (_path2350 = /*#__PURE__*/React.createElement("path", {
    d: "M58 89h-1v-1h1z",
    fill: "#cdb6ba"
  })), _path2351 || (_path2351 = /*#__PURE__*/React.createElement("path", {
    d: "M59 88v1h-1v-1z",
    fill: "#c29a97"
  })), _path2352 || (_path2352 = /*#__PURE__*/React.createElement("path", {
    d: "M59 89v-1h1v1z",
    fill: "#cab4b8"
  })), _path2353 || (_path2353 = /*#__PURE__*/React.createElement("path", {
    d: "M60 89v-1h1v1z",
    fill: "#c29d9c"
  })), _path2354 || (_path2354 = /*#__PURE__*/React.createElement("path", {
    d: "M63 89h-1v-1h1z",
    fill: "#c8b3b3"
  })), _path2355 || (_path2355 = /*#__PURE__*/React.createElement("path", {
    d: "M66 88v1h-1v-1z",
    fill: "#d8d5db"
  })), _path2356 || (_path2356 = /*#__PURE__*/React.createElement("path", {
    d: "M67 89h-1v-1h1z",
    fill: "#ceccd1",
    fillOpacity: 0.82
  })), _path2357 || (_path2357 = /*#__PURE__*/React.createElement("path", {
    d: "M7 90v-1h1v1z",
    fill: "#d7d4d7",
    fillOpacity: 0.376
  })), _path2358 || (_path2358 = /*#__PURE__*/React.createElement("path", {
    d: "M9 89h1v1H9z",
    fill: "#d7d2d3"
  })), _path2359 || (_path2359 = /*#__PURE__*/React.createElement("path", {
    d: "M21 89v1h-1v-1z",
    fill: "#d7cfce"
  })), _path2360 || (_path2360 = /*#__PURE__*/React.createElement("path", {
    d: "M29 89v1h-1v-1z",
    fill: "#d9d5d7"
  })), _path2361 || (_path2361 = /*#__PURE__*/React.createElement("path", {
    d: "M29 89h1v1h-1z",
    fill: "#d8d3d6"
  })), _path2362 || (_path2362 = /*#__PURE__*/React.createElement("path", {
    d: "M31 89v1h-1v-1z",
    fill: "#d7ced1"
  })), _path2363 || (_path2363 = /*#__PURE__*/React.createElement("path", {
    d: "M33 90h-1v-1h1z",
    fill: "#d9d6db"
  })), _path2364 || (_path2364 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89v1h-1v-1z",
    fill: "#dcd9df"
  })), _path2365 || (_path2365 = /*#__PURE__*/React.createElement("path", {
    d: "M37 89v1h-1v-1z",
    fill: "#dcd8de"
  })), _path2366 || (_path2366 = /*#__PURE__*/React.createElement("path", {
    d: "M40 89v1h-1v-1z",
    fill: "#dbdadb"
  })), _path2367 || (_path2367 = /*#__PURE__*/React.createElement("path", {
    d: "M40 90v-1h1v1z",
    fill: "#dad2d9"
  })), _path2368 || (_path2368 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89h1v1h-1z",
    fill: "#dad9db"
  })), _path2369 || (_path2369 = /*#__PURE__*/React.createElement("path", {
    d: "M43 90h-1v-1h1z",
    fill: "#ccaeb0"
  })), _path2370 || (_path2370 = /*#__PURE__*/React.createElement("path", {
    d: "M44 89v1h-1v-1z",
    fill: "#d8bbbd"
  })), _path2371 || (_path2371 = /*#__PURE__*/React.createElement("path", {
    d: "M46 89v1h-1v-1z",
    fill: "#cba6a4"
  })), _path2372 || (_path2372 = /*#__PURE__*/React.createElement("path", {
    d: "M47 89v1h-1v-1z",
    fill: "#d1bbbb"
  })), _path2373 || (_path2373 = /*#__PURE__*/React.createElement("path", {
    d: "M52 90h-1v-1h1z",
    fill: "#d8ced0"
  })), _path2374 || (_path2374 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89v1h-1v-1z",
    fill: "#d2bdc0"
  })), _path2375 || (_path2375 = /*#__PURE__*/React.createElement("path", {
    d: "M55 89v1h-1v-1z",
    fill: "#cebbbd"
  })), _path2376 || (_path2376 = /*#__PURE__*/React.createElement("path", {
    d: "M55 90v-1h1v1z",
    fill: "#d3bcc0"
  })), _path2377 || (_path2377 = /*#__PURE__*/React.createElement("path", {
    d: "M58 89v1h-1v-1z",
    fill: "#d2c8ca"
  })), _path2378 || (_path2378 = /*#__PURE__*/React.createElement("path", {
    d: "M59 89v1h-1v-1z",
    fill: "#c49e9c"
  })), _path2379 || (_path2379 = /*#__PURE__*/React.createElement("path", {
    d: "M60 90v-1h1v1z",
    fill: "#c5a5a4"
  })), _path2380 || (_path2380 = /*#__PURE__*/React.createElement("path", {
    d: "M61 89h1v1h-1z",
    fill: "#cbbcbd"
  })), _path2381 || (_path2381 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90h-1v-1h1z",
    fill: "#c7acad"
  })), _path2382 || (_path2382 = /*#__PURE__*/React.createElement("path", {
    d: "M66 89h1v1h-1z",
    fill: "#ceccd1",
    fillOpacity: 0.765
  })), _path2383 || (_path2383 = /*#__PURE__*/React.createElement("path", {
    d: "M8 90v1H7v-1z",
    fill: "#d4d4d2",
    fillOpacity: 0.38
  })), _path2384 || (_path2384 = /*#__PURE__*/React.createElement("path", {
    d: "M8 91v-1h1v1z",
    fill: "#eae8e9"
  })), _path2385 || (_path2385 = /*#__PURE__*/React.createElement("path", {
    d: "M9 91v-1h1v1z",
    fill: "#dbd6d8"
  })), _path2386 || (_path2386 = /*#__PURE__*/React.createElement("path", {
    d: "M15 90h1v1h-1z",
    fill: "#c1b6b4"
  })), _path2387 || (_path2387 = /*#__PURE__*/React.createElement("path", {
    d: "M16 91v-1h1v1z",
    fill: "#cac1be"
  })), _path2388 || (_path2388 = /*#__PURE__*/React.createElement("path", {
    d: "M21 90v1h-1v-1z",
    fill: "#d6cece"
  })), _path2389 || (_path2389 = /*#__PURE__*/React.createElement("path", {
    d: "M22 91v-1h1v1z",
    fill: "#d3ced3"
  })), _path2390 || (_path2390 = /*#__PURE__*/React.createElement("path", {
    d: "M23 91v-1h1v1z",
    fill: "#d5ced1"
  })), _path2391 || (_path2391 = /*#__PURE__*/React.createElement("path", {
    d: "M24 90h1v1h-1z",
    fill: "#d0c0c1"
  })), _path2392 || (_path2392 = /*#__PURE__*/React.createElement("path", {
    d: "M25 90h1v1h-1z",
    fill: "#cebab9"
  })), _path2393 || (_path2393 = /*#__PURE__*/React.createElement("path", {
    d: "M26 90h1v1h-1z",
    fill: "#ceb1ae"
  })), _path2394 || (_path2394 = /*#__PURE__*/React.createElement("path", {
    d: "M27 91v-1h1v1z",
    fill: "#ceaeab"
  })), _path2395 || (_path2395 = /*#__PURE__*/React.createElement("path", {
    d: "M28 91v-1h1v1z",
    fill: "#ccaba9"
  })), _path2396 || (_path2396 = /*#__PURE__*/React.createElement("path", {
    d: "M30 90v1h-1v-1z",
    fill: "#ceb0b0"
  })), _path2397 || (_path2397 = /*#__PURE__*/React.createElement("path", {
    d: "M30 91v-1h1v1z",
    fill: "#cca6a5"
  })), _path2398 || (_path2398 = /*#__PURE__*/React.createElement("path", {
    d: "M31 90h1v1h-1z",
    fill: "#d7cccd"
  })), _path2399 || (_path2399 = /*#__PURE__*/React.createElement("path", {
    d: "M32 91v-1h1v1z",
    fill: "#d9cfd3"
  })), _path2400 || (_path2400 = /*#__PURE__*/React.createElement("path", {
    d: "M35 90v1h-1v-1z",
    fill: "#d8cacd"
  })), _path2401 || (_path2401 = /*#__PURE__*/React.createElement("path", {
    d: "M36 90v1h-1v-1z",
    fill: "#d2b8b7"
  })), _path2402 || (_path2402 = /*#__PURE__*/React.createElement("path", {
    d: "M37 90v1h-1v-1z",
    fill: "#d5c3c4"
  })), _path2403 || (_path2403 = /*#__PURE__*/React.createElement("path", {
    d: "M38 90v1h-1v-1z",
    fill: "#dbd0d0"
  })), _path2404 || (_path2404 = /*#__PURE__*/React.createElement("path", {
    d: "M38 91v-1h1v1z",
    fill: "#d4b3b6"
  })), _path2405 || (_path2405 = /*#__PURE__*/React.createElement("path", {
    d: "M39 90h1v1h-1z",
    fill: "#cca7a8"
  })), _path2406 || (_path2406 = /*#__PURE__*/React.createElement("path", {
    d: "M42 91h-1v-1h1z",
    fill: "#d4bec0"
  })), _path2407 || (_path2407 = /*#__PURE__*/React.createElement("path", {
    d: "M42 90h1v1h-1z",
    fill: "#d5bdbf"
  })), _path2408 || (_path2408 = /*#__PURE__*/React.createElement("path", {
    d: "M45 90h1v1h-1z",
    fill: "#cdacac"
  })), _path2409 || (_path2409 = /*#__PURE__*/React.createElement("path", {
    d: "M49 91v-1h1v1z",
    fill: "#dcd6dc"
  })), _path2410 || (_path2410 = /*#__PURE__*/React.createElement("path", {
    d: "M53 90v1h-1v-1z",
    fill: "#cfbabc"
  })), _path2411 || (_path2411 = /*#__PURE__*/React.createElement("path", {
    d: "M54 90h1v1h-1z",
    fill: "#ccb9ba"
  })), _path2412 || (_path2412 = /*#__PURE__*/React.createElement("path", {
    d: "M57 90v1h-1v-1z",
    fill: "#cba9a4"
  })), _path2413 || (_path2413 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91h-1v-1h1z",
    fill: "#cdb5b4"
  })), _path2414 || (_path2414 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v-1h1v1z",
    fill: "#cab3b2"
  })), _path2415 || (_path2415 = /*#__PURE__*/React.createElement("path", {
    d: "M59 90h1v1h-1z",
    fill: "#c7afb0"
  })), _path2416 || (_path2416 = /*#__PURE__*/React.createElement("path", {
    d: "M60 90h1v1h-1z",
    fill: "#c29f9f"
  })), _path2417 || (_path2417 = /*#__PURE__*/React.createElement("path", {
    d: "M62 90v1h-1v-1z",
    fill: "#c6a7a9"
  })), _path2418 || (_path2418 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90v1h-1v-1z",
    fill: "#cbbbbf"
  })), _path2419 || (_path2419 = /*#__PURE__*/React.createElement("path", {
    d: "M66 90h1v1h-1z",
    fill: "#cecbd1",
    fillOpacity: 0.722
  })), _path2420 || (_path2420 = /*#__PURE__*/React.createElement("path", {
    d: "M8 91v1H7v-1z",
    fill: "#cfcfca",
    fillOpacity: 0.38
  })), _path2421 || (_path2421 = /*#__PURE__*/React.createElement("path", {
    d: "M10 91v1H9v-1z",
    fill: "#dfdbdc"
  })), _path2422 || (_path2422 = /*#__PURE__*/React.createElement("path", {
    d: "M16 92h-1v-1h1z",
    fill: "#c1b6b5"
  })), _path2423 || (_path2423 = /*#__PURE__*/React.createElement("path", {
    d: "M17 92v-1h1v1z",
    fill: "#cec9c6"
  })), _path2424 || (_path2424 = /*#__PURE__*/React.createElement("path", {
    d: "M20 91v1h-1v-1z",
    fill: "#c6bebb"
  })), _path2425 || (_path2425 = /*#__PURE__*/React.createElement("path", {
    d: "M20 91h1v1h-1z",
    fill: "#d3cbcb"
  })), _path2426 || (_path2426 = /*#__PURE__*/React.createElement("path", {
    d: "M24 91v1h-1v-1z",
    fill: "#cebdbd"
  })), _path2427 || (_path2427 = /*#__PURE__*/React.createElement("path", {
    d: "M25 91v1h-1v-1z",
    fill: "#caa6a2"
  })), _path2428 || (_path2428 = /*#__PURE__*/React.createElement("path", {
    d: "M25 92v-1h1v1z",
    fill: "#ceb2b2"
  })), _path2429 || (_path2429 = /*#__PURE__*/React.createElement("path", {
    d: "M27 92h-1v-1h1z",
    fill: "#d1bcbd"
  })), _path2430 || (_path2430 = /*#__PURE__*/React.createElement("path", {
    d: "M27 91h1v1h-1z",
    fill: "#c8a1a1"
  })), _path2431 || (_path2431 = /*#__PURE__*/React.createElement("path", {
    d: "M28 91h1v1h-1z",
    fill: "#c79995"
  })), _path2432 || (_path2432 = /*#__PURE__*/React.createElement("path", {
    d: "M31 92v-1h1v1z",
    fill: "#cca9a2"
  })), _path2433 || (_path2433 = /*#__PURE__*/React.createElement("path", {
    d: "M32 91h1v1h-1z",
    fill: "#cbabad"
  })), _path2434 || (_path2434 = /*#__PURE__*/React.createElement("path", {
    d: "M34 92v-1h1v1z",
    fill: "#c89895"
  })), _path2435 || (_path2435 = /*#__PURE__*/React.createElement("path", {
    d: "M36 92h-1v-1h1z",
    fill: "#cb9d9a"
  })), _path2436 || (_path2436 = /*#__PURE__*/React.createElement("path", {
    d: "M38 92h-1v-1h1z",
    fill: "#cda5a4"
  })), _path2437 || (_path2437 = /*#__PURE__*/React.createElement("path", {
    d: "M39 92h-1v-1h1z",
    fill: "#d6c3c5"
  })), _path2438 || (_path2438 = /*#__PURE__*/React.createElement("path", {
    d: "M39 91h1v1h-1z",
    fill: "#c99f9d"
  })), _path2439 || (_path2439 = /*#__PURE__*/React.createElement("path", {
    d: "M40 91h1v1h-1z",
    fill: "#d6c7c8"
  })), _path2440 || (_path2440 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92v-1h1v1z",
    fill: "#d3bdbe"
  })), _path2441 || (_path2441 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v1h-1v-1z",
    fill: "#d0b7b3"
  })), _path2442 || (_path2442 = /*#__PURE__*/React.createElement("path", {
    d: "M44 92h-1v-1h1z",
    fill: "#d7c9cc"
  })), _path2443 || (_path2443 = /*#__PURE__*/React.createElement("path", {
    d: "M44 92v-1h1v1z",
    fill: "#d2bebf"
  })), _path2444 || (_path2444 = /*#__PURE__*/React.createElement("path", {
    d: "M45 91h1v1h-1z",
    fill: "#d5bfbf"
  })), _path2445 || (_path2445 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92h-1v-1h1z",
    fill: "#d5c5cb"
  })), _path2446 || (_path2446 = /*#__PURE__*/React.createElement("path", {
    d: "M53 91v1h-1v-1z",
    fill: "#cdb3b4"
  })), _path2447 || (_path2447 = /*#__PURE__*/React.createElement("path", {
    d: "M53 92v-1h1v1z",
    fill: "#dbd8de"
  })), _path2448 || (_path2448 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91v1h-1v-1z",
    fill: "#cfb6b9"
  })), _path2449 || (_path2449 = /*#__PURE__*/React.createElement("path", {
    d: "M56 92v-1h1v1z",
    fill: "#cfb8b9"
  })), _path2450 || (_path2450 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v1h-1v-1z",
    fill: "#d3cacd"
  })), _path2451 || (_path2451 = /*#__PURE__*/React.createElement("path", {
    d: "M58 92v-1h1v1z",
    fill: "#d2cfd7"
  })), _path2452 || (_path2452 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91v1h-1v-1z",
    fill: "#cdbec2"
  })), _path2453 || (_path2453 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91h1v1h-1z",
    fill: "#cec9ce"
  })), _path2454 || (_path2454 = /*#__PURE__*/React.createElement("path", {
    d: "M61 92v-1h1v1z",
    fill: "#cec9cd"
  })), _path2455 || (_path2455 = /*#__PURE__*/React.createElement("path", {
    d: "M63 92h-1v-1h1z",
    fill: "#cccfd5"
  })), _path2456 || (_path2456 = /*#__PURE__*/React.createElement("path", {
    d: "M63 92v-1h1v1z",
    fill: "#d0ced3"
  })), _path2457 || (_path2457 = /*#__PURE__*/React.createElement("path", {
    d: "M67 92h-1v-1h1z",
    fill: "#cfcdd2",
    fillOpacity: 0.667
  })), _path2458 || (_path2458 = /*#__PURE__*/React.createElement("path", {
    d: "M8 93H7v-1h1z",
    fill: "#dbd8d5",
    fillOpacity: 0.333
  })), _path2459 || (_path2459 = /*#__PURE__*/React.createElement("path", {
    d: "M9 92v1H8v-1z",
    fill: "#dddad9"
  })), _path2460 || (_path2460 = /*#__PURE__*/React.createElement("path", {
    d: "M9 93v-1h1v1z",
    fill: "#dfddde"
  })), _path2461 || (_path2461 = /*#__PURE__*/React.createElement("path", {
    d: "M15 93h-1v-1h1z",
    fill: "#c6bcbb"
  })), _path2462 || (_path2462 = /*#__PURE__*/React.createElement("path", {
    d: "M16 93h-1v-1h1z",
    fill: "#c1b7b5"
  })), _path2463 || (_path2463 = /*#__PURE__*/React.createElement("path", {
    d: "M24 93h-1v-1h1z",
    fill: "#caadad"
  })), _path2464 || (_path2464 = /*#__PURE__*/React.createElement("path", {
    d: "M26 92h1v1h-1z",
    fill: "#d0b7ba"
  })), _path2465 || (_path2465 = /*#__PURE__*/React.createElement("path", {
    d: "M27 92h1v1h-1z",
    fill: "#cdb9ba"
  })), _path2466 || (_path2466 = /*#__PURE__*/React.createElement("path", {
    d: "M28 93v-1h1v1z",
    fill: "#d4c1c3"
  })), _path2467 || (_path2467 = /*#__PURE__*/React.createElement("path", {
    d: "M30 92h1v1h-1z",
    fill: "#cab4b2"
  })), _path2468 || (_path2468 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93h-1v-1h1z",
    fill: "#ceadad"
  })), _path2469 || (_path2469 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93h-1v-1h1z",
    fill: "#d5c3c2"
  })), _path2470 || (_path2470 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93v-1h1v1z",
    fill: "#d1b3b1"
  })), _path2471 || (_path2471 = /*#__PURE__*/React.createElement("path", {
    d: "M35 92v1h-1v-1z",
    fill: "#c89d9b"
  })), _path2472 || (_path2472 = /*#__PURE__*/React.createElement("path", {
    d: "M35 93v-1h1v1z",
    fill: "#cea5a3"
  })), _path2473 || (_path2473 = /*#__PURE__*/React.createElement("path", {
    d: "M36 93v-1h1v1z",
    fill: "#d3bebf"
  })), _path2474 || (_path2474 = /*#__PURE__*/React.createElement("path", {
    d: "M38 93v-1h1v1z",
    fill: "#d6c9cb"
  })), _path2475 || (_path2475 = /*#__PURE__*/React.createElement("path", {
    d: "M40 92v1h-1v-1z",
    fill: "#cea7a2"
  })), _path2476 || (_path2476 = /*#__PURE__*/React.createElement("path", {
    d: "M40 93v-1h1v1z",
    fill: "#d5c1c4"
  })), _path2477 || (_path2477 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92h1v1h-1z",
    fill: "#d0b1b2"
  })), _path2478 || (_path2478 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h-1v-1h1z",
    fill: "#ccaea9"
  })), _path2479 || (_path2479 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93v-1h1v1z",
    fill: "#d3b6b7"
  })), _path2480 || (_path2480 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92v1h-1v-1z",
    fill: "#caa4a6"
  })), _path2481 || (_path2481 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92h1v1h-1z",
    fill: "#d1b5b4"
  })), _path2482 || (_path2482 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93h-1v-1h1z",
    fill: "#cdaaaf"
  })), _path2483 || (_path2483 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h-1v-1h1z",
    fill: "#d8ccd0"
  })), _path2484 || (_path2484 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93h-1v-1h1z",
    fill: "#d0ccd5"
  })), _path2485 || (_path2485 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93v-1h1v1z",
    fill: "#cdcdd3"
  })), _path2486 || (_path2486 = /*#__PURE__*/React.createElement("path", {
    d: "M66 92h1v1h-1z",
    fill: "#d0ccd1",
    fillOpacity: 0.62
  })), _path2487 || (_path2487 = /*#__PURE__*/React.createElement("path", {
    d: "M7 93h1v1H7z",
    fill: "#e1e1dd",
    fillOpacity: 0.235
  })), _path2488 || (_path2488 = /*#__PURE__*/React.createElement("path", {
    d: "M8 93h1v1H8z",
    fill: "#d9d6d5",
    fillOpacity: 0.996
  })), _path2489 || (_path2489 = /*#__PURE__*/React.createElement("path", {
    d: "M10 93v1H9v-1z",
    fill: "#dcd9da"
  })), _path2490 || (_path2490 = /*#__PURE__*/React.createElement("path", {
    d: "M11 93v1h-1v-1z",
    fill: "#cec9c7"
  })), _path2491 || (_path2491 = /*#__PURE__*/React.createElement("path", {
    d: "M20 93v1h-1v-1z",
    fill: "#cac0bd"
  })), _path2492 || (_path2492 = /*#__PURE__*/React.createElement("path", {
    d: "M22 94v-1h1v1z",
    fill: "#d1cbd0"
  })), _path2493 || (_path2493 = /*#__PURE__*/React.createElement("path", {
    d: "M25 93h1v1h-1z",
    fill: "#cfb3b6"
  })), _path2494 || (_path2494 = /*#__PURE__*/React.createElement("path", {
    d: "M27 93h1v1h-1z",
    fill: "#d4c6c7"
  })), _path2495 || (_path2495 = /*#__PURE__*/React.createElement("path", {
    d: "M28 94v-1h1v1z",
    fill: "#d4c8cd"
  })), _path2496 || (_path2496 = /*#__PURE__*/React.createElement("path", {
    d: "M30 93v1h-1v-1z",
    fill: "#d0b9b8"
  })), _path2497 || (_path2497 = /*#__PURE__*/React.createElement("path", {
    d: "M31 94h-1v-1h1z",
    fill: "#cfbaba"
  })), _path2498 || (_path2498 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93v1h-1v-1z",
    fill: "#ccb3b2"
  })), _path2499 || (_path2499 = /*#__PURE__*/React.createElement("path", {
    d: "M35 94h-1v-1h1z",
    fill: "#d4b2b3"
  })), _path2500 || (_path2500 = /*#__PURE__*/React.createElement("path", {
    d: "M35 93h1v1h-1z",
    fill: "#c69a97"
  })), _path2501 || (_path2501 = /*#__PURE__*/React.createElement("path", {
    d: "M36 94v-1h1v1z",
    fill: "#cfb6b4"
  })), _path2502 || (_path2502 = /*#__PURE__*/React.createElement("path", {
    d: "M38 94h-1v-1h1z",
    fill: "#c79899"
  })), _path2503 || (_path2503 = /*#__PURE__*/React.createElement("path", {
    d: "M39 93h1v1h-1z",
    fill: "#caa19c"
  })), _path2504 || (_path2504 = /*#__PURE__*/React.createElement("path", {
    d: "M41 94h-1v-1h1z",
    fill: "#ccacaa"
  })), _path2505 || (_path2505 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h1v1h-1z",
    fill: "#d1bec0"
  })), _path2506 || (_path2506 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h-1v-1h1z",
    fill: "#d8cfd4"
  })), _path2507 || (_path2507 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94h-1v-1h1z",
    fill: "#d0ced3",
    fillOpacity: 0.557
  })), _path2508 || (_path2508 = /*#__PURE__*/React.createElement("path", {
    d: "M8 95H7v-1h1z",
    fill: "#dbe2db",
    fillOpacity: 0.141
  })), _path2509 || (_path2509 = /*#__PURE__*/React.createElement("path", {
    d: "M9 95H8v-1h1z",
    fill: "#dad7d6",
    fillOpacity: 0.953
  })), _path2510 || (_path2510 = /*#__PURE__*/React.createElement("path", {
    d: "M11 95h-1v-1h1z",
    fill: "#d1ccca"
  })), _path2511 || (_path2511 = /*#__PURE__*/React.createElement("path", {
    d: "M20 95h-1v-1h1z",
    fill: "#cdc4c2"
  })), _path2512 || (_path2512 = /*#__PURE__*/React.createElement("path", {
    d: "M26 94v1h-1v-1z",
    fill: "#d0babb"
  })), _path2513 || (_path2513 = /*#__PURE__*/React.createElement("path", {
    d: "M26 95v-1h1v1z",
    fill: "#cfb5b3"
  })), _path2514 || (_path2514 = /*#__PURE__*/React.createElement("path", {
    d: "M28 95h-1v-1h1z",
    fill: "#cbb0b1"
  })), _path2515 || (_path2515 = /*#__PURE__*/React.createElement("path", {
    d: "M29 95h-1v-1h1z",
    fill: "#cbb9b8"
  })), _path2516 || (_path2516 = /*#__PURE__*/React.createElement("path", {
    d: "M29 94h1v1h-1z",
    fill: "#caa8aa"
  })), _path2517 || (_path2517 = /*#__PURE__*/React.createElement("path", {
    d: "M31 94v1h-1v-1z",
    fill: "#c9a8a7"
  })), _path2518 || (_path2518 = /*#__PURE__*/React.createElement("path", {
    d: "M31 95v-1h1v1z",
    fill: "#caa5a6"
  })), _path2519 || (_path2519 = /*#__PURE__*/React.createElement("path", {
    d: "M33 94v1h-1v-1z",
    fill: "#cbacab"
  })), _path2520 || (_path2520 = /*#__PURE__*/React.createElement("path", {
    d: "M34 94v1h-1v-1z",
    fill: "#ccb5b3"
  })), _path2521 || (_path2521 = /*#__PURE__*/React.createElement("path", {
    d: "M35 94v1h-1v-1z",
    fill: "#ceb4b2"
  })), _path2522 || (_path2522 = /*#__PURE__*/React.createElement("path", {
    d: "M36 94v1h-1v-1z",
    fill: "#d0b9bc"
  })), _path2523 || (_path2523 = /*#__PURE__*/React.createElement("path", {
    d: "M36 95v-1h1v1z",
    fill: "#d2bfc3"
  })), _path2524 || (_path2524 = /*#__PURE__*/React.createElement("path", {
    d: "M37 94h1v1h-1z",
    fill: "#d7cdcd"
  })), _path2525 || (_path2525 = /*#__PURE__*/React.createElement("path", {
    d: "M39 95h-1v-1h1z",
    fill: "#d4c7cb"
  })), _path2526 || (_path2526 = /*#__PURE__*/React.createElement("path", {
    d: "M40 95v-1h1v1z",
    fill: "#dbd5dc"
  })), _path2527 || (_path2527 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95v-1h1v1z",
    fill: "#dcd8df"
  })), _path2528 || (_path2528 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94h1v1h-1z",
    fill: "#d8dbde"
  })), _path2529 || (_path2529 = /*#__PURE__*/React.createElement("path", {
    d: "M63 95v-1h1v1z",
    fill: "#cdccd2"
  })), _path2530 || (_path2530 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94v1h-1v-1z",
    fill: "#d1cfd5",
    fillOpacity: 0.506
  })), _path2531 || (_path2531 = /*#__PURE__*/React.createElement("path", {
    d: "M9 95v1H8v-1z",
    fill: "#dcd9d6",
    fillOpacity: 0.871
  })), _path2532 || (_path2532 = /*#__PURE__*/React.createElement("path", {
    d: "M9 96v-1h1v1z",
    fill: "#dcd6d6"
  })), _path2533 || (_path2533 = /*#__PURE__*/React.createElement("path", {
    d: "M15 95v1h-1v-1z",
    fill: "#c4bab8"
  })), _path2534 || (_path2534 = /*#__PURE__*/React.createElement("path", {
    d: "M18 96v-1h1v1z",
    fill: "#c9c0bd"
  })), _path2535 || (_path2535 = /*#__PURE__*/React.createElement("path", {
    d: "M21 95v1h-1v-1z",
    fill: "#cec7c7"
  })), _path2536 || (_path2536 = /*#__PURE__*/React.createElement("path", {
    d: "M22 96v-1h1v1z",
    fill: "#d1ced1"
  })), _path2537 || (_path2537 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96h-1v-1h1z",
    fill: "#d5d1d2"
  })), _path2538 || (_path2538 = /*#__PURE__*/React.createElement("path", {
    d: "M25 96h-1v-1h1z",
    fill: "#caaeb0"
  })), _path2539 || (_path2539 = /*#__PURE__*/React.createElement("path", {
    d: "M26 96h-1v-1h1z",
    fill: "#caa9a8"
  })), _path2540 || (_path2540 = /*#__PURE__*/React.createElement("path", {
    d: "M26 95h1v1h-1z",
    fill: "#ccb3b1"
  })), _path2541 || (_path2541 = /*#__PURE__*/React.createElement("path", {
    d: "M27 96v-1h1v1z",
    fill: "#d4c6ca"
  })), _path2542 || (_path2542 = /*#__PURE__*/React.createElement("path", {
    d: "M28 96v-1h1v1z",
    fill: "#d6cacf"
  })), _path2543 || (_path2543 = /*#__PURE__*/React.createElement("path", {
    d: "M31 95h1v1h-1z",
    fill: "#d7d1d5"
  })), _path2544 || (_path2544 = /*#__PURE__*/React.createElement("path", {
    d: "M34 96h-1v-1h1z",
    fill: "#d8d6dd"
  })), _path2545 || (_path2545 = /*#__PURE__*/React.createElement("path", {
    d: "M47 95v1h-1v-1z",
    fill: "#d7d8dc"
  })), _path2546 || (_path2546 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96v-1h1v1z",
    fill: "#d3d1d6",
    fillOpacity: 0.439
  })), _path2547 || (_path2547 = /*#__PURE__*/React.createElement("path", {
    d: "M8 96h1v1H8z",
    fill: "#dcd8d4",
    fillOpacity: 0.78
  })), _path2548 || (_path2548 = /*#__PURE__*/React.createElement("path", {
    d: "M10 97H9v-1h1z",
    fill: "#dcd7d6"
  })), _path2549 || (_path2549 = /*#__PURE__*/React.createElement("path", {
    d: "M10 96h1v1h-1z",
    fill: "#d2cccc"
  })), _path2550 || (_path2550 = /*#__PURE__*/React.createElement("path", {
    d: "M16 96h1v1h-1z",
    fill: "#cec8c6"
  })), _path2551 || (_path2551 = /*#__PURE__*/React.createElement("path", {
    d: "M28 96h1v1h-1z",
    fill: "#d4d3d7"
  })), _path2552 || (_path2552 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96h1v1h-1z",
    fill: "#d4d2d4",
    fillOpacity: 0.357
  })), _path2553 || (_path2553 = /*#__PURE__*/React.createElement("path", {
    d: "M9 97v1H8v-1z",
    fill: "#d8d3d0",
    fillOpacity: 0.694
  })), _path2554 || (_path2554 = /*#__PURE__*/React.createElement("path", {
    d: "M9 98v-1h1v1z",
    fill: "#dbd6d5"
  })), _path2555 || (_path2555 = /*#__PURE__*/React.createElement("path", {
    d: "M17 97v1h-1v-1z",
    fill: "#cdc7c5"
  })), _path2556 || (_path2556 = /*#__PURE__*/React.createElement("path", {
    d: "M20 97h1v1h-1z",
    fill: "#cdc6c7"
  })), _path2557 || (_path2557 = /*#__PURE__*/React.createElement("path", {
    d: "M22 97h1v1h-1z",
    fill: "#d2cdd2"
  })), _path2558 || (_path2558 = /*#__PURE__*/React.createElement("path", {
    d: "M29 97v1h-1v-1z",
    fill: "#d5d1d8"
  })), _path2559 || (_path2559 = /*#__PURE__*/React.createElement("path", {
    d: "M66 97v1h-1v-1z",
    fill: "#d2d1d6"
  })), _path2560 || (_path2560 = /*#__PURE__*/React.createElement("path", {
    d: "M67 97v1h-1v-1z",
    fill: "#d2d2d5",
    fillOpacity: 0.29
  })), _path2561 || (_path2561 = /*#__PURE__*/React.createElement("path", {
    d: "M9 99H8v-1h1z",
    fill: "#d5d0cd",
    fillOpacity: 0.608
  })), _path2562 || (_path2562 = /*#__PURE__*/React.createElement("path", {
    d: "M10 98v1H9v-1z",
    fill: "#dcd4d2"
  })), _path2563 || (_path2563 = /*#__PURE__*/React.createElement("path", {
    d: "M16 98h1v1h-1z",
    fill: "#cdc7c3"
  })), _path2564 || (_path2564 = /*#__PURE__*/React.createElement("path", {
    d: "M20 98v1h-1v-1z",
    fill: "#ccc5c0"
  })), _path2565 || (_path2565 = /*#__PURE__*/React.createElement("path", {
    d: "M20 99v-1h1v1z",
    fill: "#ccc6c7"
  })), _path2566 || (_path2566 = /*#__PURE__*/React.createElement("path", {
    d: "M22 99v-1h1v1z",
    fill: "#d4cfd1"
  })), _path2567 || (_path2567 = /*#__PURE__*/React.createElement("path", {
    d: "M24 99h-1v-1h1z",
    fill: "#d3d0d0"
  })), _path2568 || (_path2568 = /*#__PURE__*/React.createElement("path", {
    d: "M25 99h-1v-1h1z",
    fill: "#d5d0d2"
  })), _path2569 || (_path2569 = /*#__PURE__*/React.createElement("path", {
    d: "M25 99v-1h1v1z",
    fill: "#d6cfd5"
  })), _path2570 || (_path2570 = /*#__PURE__*/React.createElement("path", {
    d: "M27 98v1h-1v-1z",
    fill: "#d5d1d6"
  })), _path2571 || (_path2571 = /*#__PURE__*/React.createElement("path", {
    d: "M66 98v1h-1v-1z",
    fill: "#ceccd2",
    fillOpacity: 0.996
  })), _path2572 || (_path2572 = /*#__PURE__*/React.createElement("path", {
    d: "M67 99h-1v-1h1z",
    fill: "#d3d3d7",
    fillOpacity: 0.227
  })), _path2573 || (_path2573 = /*#__PURE__*/React.createElement("path", {
    d: "M9 100H8v-1h1z",
    fill: "#d8d4d0",
    fillOpacity: 0.518
  })), _path2574 || (_path2574 = /*#__PURE__*/React.createElement("path", {
    d: "M9 99h1v1H9z",
    fill: "#ded7d4"
  })), _path2575 || (_path2575 = /*#__PURE__*/React.createElement("path", {
    d: "M10 99h1v1h-1z",
    fill: "#d4cdca"
  })), _path2576 || (_path2576 = /*#__PURE__*/React.createElement("path", {
    d: "M12 99h1v1h-1z",
    fill: "#cec7c4"
  })), _path2577 || (_path2577 = /*#__PURE__*/React.createElement("path", {
    d: "M14 100v-1h1v1z",
    fill: "#c3bbb8"
  })), _path2578 || (_path2578 = /*#__PURE__*/React.createElement("path", {
    d: "M17 100v-1h1v1z",
    fill: "#cbc0be"
  })), _path2579 || (_path2579 = /*#__PURE__*/React.createElement("path", {
    d: "M19 100v-1h1v1z",
    fill: "#cbc3bf"
  })), _path2580 || (_path2580 = /*#__PURE__*/React.createElement("path", {
    d: "M21 99v1h-1v-1z",
    fill: "#cdc8c9"
  })), _path2581 || (_path2581 = /*#__PURE__*/React.createElement("path", {
    d: "M24 100v-1h1v1z",
    fill: "#d5d0d3"
  })), _path2582 || (_path2582 = /*#__PURE__*/React.createElement("path", {
    d: "M39 100h-1v-1h1z",
    fill: "#d9d6dd"
  })), _path2583 || (_path2583 = /*#__PURE__*/React.createElement("path", {
    d: "M66 99v1h-1v-1z",
    fill: "#cfcdd3",
    fillOpacity: 0.973
  })), _path2584 || (_path2584 = /*#__PURE__*/React.createElement("path", {
    d: "M66 99h1v1h-1z",
    fill: "#d5d5db",
    fillOpacity: 0.169
  })), _path2585 || (_path2585 = /*#__PURE__*/React.createElement("path", {
    d: "M8 101v-1h1v1z",
    fill: "#dad5d5",
    fillOpacity: 0.408
  })), _path2586 || (_path2586 = /*#__PURE__*/React.createElement("path", {
    d: "M9 101v-1h1v1z",
    fill: "#e1dddd"
  })), _path2587 || (_path2587 = /*#__PURE__*/React.createElement("path", {
    d: "M11 100v1h-1v-1z",
    fill: "#dad5d4"
  })), _path2588 || (_path2588 = /*#__PURE__*/React.createElement("path", {
    d: "M20 100v1h-1v-1z",
    fill: "#c8c0bf"
  })), _path2589 || (_path2589 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101h-1v-1h1z",
    fill: "#d1cfd5",
    fillOpacity: 0.922
  })), _path2590 || (_path2590 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101v-1h1v1z",
    fill: "#dfdfdf",
    fillOpacity: 0.094
  })), _path2591 || (_path2591 = /*#__PURE__*/React.createElement("path", {
    d: "M8 102v-1h1v1z",
    fill: "#dadada",
    fillOpacity: 0.275
  })), _path2592 || (_path2592 = /*#__PURE__*/React.createElement("path", {
    d: "M17 101h1v1h-1z",
    fill: "#cec4c2"
  })), _path2593 || (_path2593 = /*#__PURE__*/React.createElement("path", {
    d: "M20 102h-1v-1h1z",
    fill: "#c9c2c2"
  })), _path2594 || (_path2594 = /*#__PURE__*/React.createElement("path", {
    d: "M61 101h1v1h-1z",
    fill: "#d8d3da"
  })), _path2595 || (_path2595 = /*#__PURE__*/React.createElement("path", {
    d: "M65 102v-1h1v1z",
    fill: "#d4d1d7",
    fillOpacity: 0.843
  })), _path2596 || (_path2596 = /*#__PURE__*/React.createElement("path", {
    d: "M9 102v1H8v-1z",
    fill: "#e7e7e7",
    fillOpacity: 0.129
  })), _path2597 || (_path2597 = /*#__PURE__*/React.createElement("path", {
    d: "M9 103v-1h1v1z",
    fill: "#d8d6d6",
    fillOpacity: 0.949
  })), _path2598 || (_path2598 = /*#__PURE__*/React.createElement("path", {
    d: "M11 103h-1v-1h1z",
    fill: "#d8d3d2"
  })), _path2599 || (_path2599 = /*#__PURE__*/React.createElement("path", {
    d: "M20 103h-1v-1h1z",
    fill: "#cac4c6"
  })), _path2600 || (_path2600 = /*#__PURE__*/React.createElement("path", {
    d: "M21 102h1v1h-1z",
    fill: "#d4cfd4"
  })), _path2601 || (_path2601 = /*#__PURE__*/React.createElement("path", {
    d: "M25 102h1v1h-1z",
    fill: "#d7d4d8"
  })), _path2602 || (_path2602 = /*#__PURE__*/React.createElement("path", {
    d: "M47 103h-1v-1h1z",
    fill: "#dcdae2"
  })), _path2603 || (_path2603 = /*#__PURE__*/React.createElement("path", {
    d: "M48 102v1h-1v-1z",
    fill: "#dcdae3"
  })), _path2604 || (_path2604 = /*#__PURE__*/React.createElement("path", {
    d: "M51 103h-1v-1h1z",
    fill: "#dcdbde"
  })), _path2605 || (_path2605 = /*#__PURE__*/React.createElement("path", {
    d: "M53 103h-1v-1h1z",
    fill: "#dad5db"
  })), _path2606 || (_path2606 = /*#__PURE__*/React.createElement("path", {
    d: "M54 102h1v1h-1z",
    fill: "#d6c8ce"
  })), _path2607 || (_path2607 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103h-1v-1h1z",
    fill: "#d4c4c9"
  })), _path2608 || (_path2608 = /*#__PURE__*/React.createElement("path", {
    d: "M57 103v-1h1v1z",
    fill: "#cbb2b3"
  })), _path2609 || (_path2609 = /*#__PURE__*/React.createElement("path", {
    d: "M59 103h-1v-1h1z",
    fill: "#cdb1b3"
  })), _path2610 || (_path2610 = /*#__PURE__*/React.createElement("path", {
    d: "M60 103h-1v-1h1z",
    fill: "#caabae"
  })), _path2611 || (_path2611 = /*#__PURE__*/React.createElement("path", {
    d: "M60 102h1v1h-1z",
    fill: "#cbb3b7"
  })), _path2612 || (_path2612 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103h-1v-1h1z",
    fill: "#d4d4d8",
    fillOpacity: 0.745
  })), _path2613 || (_path2613 = /*#__PURE__*/React.createElement("path", {
    d: "M8 103h1v1H8z",
    fill: "#e2ffff",
    fillOpacity: 0.035
  })), _path2614 || (_path2614 = /*#__PURE__*/React.createElement("path", {
    d: "M10 103v1H9v-1z",
    fill: "#dad9d9",
    fillOpacity: 0.847
  })), _path2615 || (_path2615 = /*#__PURE__*/React.createElement("path", {
    d: "M11 104h-1v-1h1z",
    fill: "#dbd7d5"
  })), _path2616 || (_path2616 = /*#__PURE__*/React.createElement("path", {
    d: "M19 104h-1v-1h1z",
    fill: "#cac3c2"
  })), _path2617 || (_path2617 = /*#__PURE__*/React.createElement("path", {
    d: "M20 103v1h-1v-1z",
    fill: "#ccc7ca"
  })), _path2618 || (_path2618 = /*#__PURE__*/React.createElement("path", {
    d: "M25 103v1h-1v-1z",
    fill: "#d8d5d8"
  })), _path2619 || (_path2619 = /*#__PURE__*/React.createElement("path", {
    d: "M25 104v-1h1v1z",
    fill: "#d7d5d9"
  })), _path2620 || (_path2620 = /*#__PURE__*/React.createElement("path", {
    d: "M42 103v1h-1v-1z",
    fill: "#dcdce3"
  })), _path2621 || (_path2621 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103v1h-1v-1z",
    fill: "#dbd5db"
  })), _path2622 || (_path2622 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103h1v1h-1z",
    fill: "#d9cdd0"
  })), _path2623 || (_path2623 = /*#__PURE__*/React.createElement("path", {
    d: "M49 104h-1v-1h1z",
    fill: "#d4c1c4"
  })), _path2624 || (_path2624 = /*#__PURE__*/React.createElement("path", {
    d: "M51 104h-1v-1h1z",
    fill: "#cfb1b5"
  })), _path2625 || (_path2625 = /*#__PURE__*/React.createElement("path", {
    d: "M54 103v1h-1v-1z",
    fill: "#d0babd"
  })), _path2626 || (_path2626 = /*#__PURE__*/React.createElement("path", {
    d: "M54 104v-1h1v1z",
    fill: "#d2b5b9"
  })), _path2627 || (_path2627 = /*#__PURE__*/React.createElement("path", {
    d: "M55 104v-1h1v1z",
    fill: "#d2bec0"
  })), _path2628 || (_path2628 = /*#__PURE__*/React.createElement("path", {
    d: "M56 104v-1h1v1z",
    fill: "#d3c4c5"
  })), _path2629 || (_path2629 = /*#__PURE__*/React.createElement("path", {
    d: "M58 103v1h-1v-1z",
    fill: "#d2bfc1"
  })), _path2630 || (_path2630 = /*#__PURE__*/React.createElement("path", {
    d: "M58 103h1v1h-1z",
    fill: "#d8d1d5"
  })), _path2631 || (_path2631 = /*#__PURE__*/React.createElement("path", {
    d: "M62 104h-1v-1h1z",
    fill: "#d7d9dd"
  })), _path2632 || (_path2632 = /*#__PURE__*/React.createElement("path", {
    d: "M65 104v-1h1v1z",
    fill: "#d4d4d9",
    fillOpacity: 0.635
  })), _path2633 || (_path2633 = /*#__PURE__*/React.createElement("path", {
    d: "M10 105H9v-1h1z",
    fill: "#dedcde",
    fillOpacity: 0.671
  })), _path2634 || (_path2634 = /*#__PURE__*/React.createElement("path", {
    d: "M11 105h-1v-1h1z",
    fill: "#dedad9"
  })), _path2635 || (_path2635 = /*#__PURE__*/React.createElement("path", {
    d: "M14 105h-1v-1h1z",
    fill: "#d2c9c7"
  })), _path2636 || (_path2636 = /*#__PURE__*/React.createElement("path", {
    d: "M19 104v1h-1v-1z",
    fill: "#c6c0c1"
  })), _path2637 || (_path2637 = /*#__PURE__*/React.createElement("path", {
    d: "M19 105v-1h1v1z",
    fill: "#cdc8cd"
  })), _path2638 || (_path2638 = /*#__PURE__*/React.createElement("path", {
    d: "M22 104v1h-1v-1z",
    fill: "#d3cdd0"
  })), _path2639 || (_path2639 = /*#__PURE__*/React.createElement("path", {
    d: "M23 104v1h-1v-1z",
    fill: "#d3cfd2"
  })), _path2640 || (_path2640 = /*#__PURE__*/React.createElement("path", {
    d: "M23 104h1v1h-1z",
    fill: "#d6d2d5"
  })), _path2641 || (_path2641 = /*#__PURE__*/React.createElement("path", {
    d: "M25 105h-1v-1h1z",
    fill: "#d6d4d8"
  })), _path2642 || (_path2642 = /*#__PURE__*/React.createElement("path", {
    d: "M39 104h1v1h-1z",
    fill: "#d9d2d5"
  })), _path2643 || (_path2643 = /*#__PURE__*/React.createElement("path", {
    d: "M42 105h-1v-1h1z",
    fill: "#d2bec2"
  })), _path2644 || (_path2644 = /*#__PURE__*/React.createElement("path", {
    d: "M42 105v-1h1v1z",
    fill: "#d1bbbc"
  })), _path2645 || (_path2645 = /*#__PURE__*/React.createElement("path", {
    d: "M45 105h-1v-1h1z",
    fill: "#d1babb"
  })), _path2646 || (_path2646 = /*#__PURE__*/React.createElement("path", {
    d: "M46 104h1v1h-1z",
    fill: "#d2b6bb"
  })), _path2647 || (_path2647 = /*#__PURE__*/React.createElement("path", {
    d: "M48 104v1h-1v-1z",
    fill: "#d7c6ca"
  })), _path2648 || (_path2648 = /*#__PURE__*/React.createElement("path", {
    d: "M50 105v-1h1v1z",
    fill: "#d3c2c5"
  })), _path2649 || (_path2649 = /*#__PURE__*/React.createElement("path", {
    d: "M51 104h1v1h-1z",
    fill: "#d3c0c4"
  })), _path2650 || (_path2650 = /*#__PURE__*/React.createElement("path", {
    d: "M53 104v1h-1v-1z",
    fill: "#d3bec1"
  })), _path2651 || (_path2651 = /*#__PURE__*/React.createElement("path", {
    d: "M53 104h1v1h-1z",
    fill: "#d1babd"
  })), _path2652 || (_path2652 = /*#__PURE__*/React.createElement("path", {
    d: "M55 105h-1v-1h1z",
    fill: "#d0babc"
  })), _path2653 || (_path2653 = /*#__PURE__*/React.createElement("path", {
    d: "M57 104v1h-1v-1z",
    fill: "#cebabd"
  })), _path2654 || (_path2654 = /*#__PURE__*/React.createElement("path", {
    d: "M58 104v1h-1v-1z",
    fill: "#cfb9be"
  })), _path2655 || (_path2655 = /*#__PURE__*/React.createElement("path", {
    d: "M58 105v-1h1v1z",
    fill: "#d6d5d9"
  })), _path2656 || (_path2656 = /*#__PURE__*/React.createElement("path", {
    d: "M65 104h1v1h-1z",
    fill: "#d9d7dd",
    fillOpacity: 0.502
  })), _path2657 || (_path2657 = /*#__PURE__*/React.createElement("path", {
    d: "M9 106v-1h1v1z",
    fill: "#dfdfdf",
    fillOpacity: 0.408
  })), _path2658 || (_path2658 = /*#__PURE__*/React.createElement("path", {
    d: "M10 106v-1h1v1z",
    fill: "#dedcdc"
  })), _path2659 || (_path2659 = /*#__PURE__*/React.createElement("path", {
    d: "M19 106h-1v-1h1z",
    fill: "#c8c0c4"
  })), _path2660 || (_path2660 = /*#__PURE__*/React.createElement("path", {
    d: "M19 105h1v1h-1z",
    fill: "#d0cacf"
  })), _path2661 || (_path2661 = /*#__PURE__*/React.createElement("path", {
    d: "M22 106v-1h1v1z",
    fill: "#d5d1d4"
  })), _path2662 || (_path2662 = /*#__PURE__*/React.createElement("path", {
    d: "M24 106h-1v-1h1z",
    fill: "#d5d4d4"
  })), _path2663 || (_path2663 = /*#__PURE__*/React.createElement("path", {
    d: "M25 106v-1h1v1z",
    fill: "#d5d5d8"
  })), _path2664 || (_path2664 = /*#__PURE__*/React.createElement("path", {
    d: "M28 105v1h-1v-1z",
    fill: "#d7d9dc"
  })), _path2665 || (_path2665 = /*#__PURE__*/React.createElement("path", {
    d: "M31 106h-1v-1h1z",
    fill: "#dcd7dc"
  })), _path2666 || (_path2666 = /*#__PURE__*/React.createElement("path", {
    d: "M32 106v-1h1v1z",
    fill: "#d7d0d4"
  })), _path2667 || (_path2667 = /*#__PURE__*/React.createElement("path", {
    d: "M36 106h-1v-1h1z",
    fill: "#d0bfbb"
  })), _path2668 || (_path2668 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106h-1v-1h1z",
    fill: "#d2b5b5"
  })), _path2669 || (_path2669 = /*#__PURE__*/React.createElement("path", {
    d: "M38 106h-1v-1h1z",
    fill: "#cfb4b3"
  })), _path2670 || (_path2670 = /*#__PURE__*/React.createElement("path", {
    d: "M39 105v1h-1v-1z",
    fill: "#d0b6b8"
  })), _path2671 || (_path2671 = /*#__PURE__*/React.createElement("path", {
    d: "M39 106v-1h1v1z",
    fill: "#d1baba"
  })), _path2672 || (_path2672 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106h-1v-1h1z",
    fill: "#d0bcbc"
  })), _path2673 || (_path2673 = /*#__PURE__*/React.createElement("path", {
    d: "M42 106h-1v-1h1z",
    fill: "#d6c2c3"
  })), _path2674 || (_path2674 = /*#__PURE__*/React.createElement("path", {
    d: "M42 106v-1h1v1z",
    fill: "#d6c4c5"
  })), _path2675 || (_path2675 = /*#__PURE__*/React.createElement("path", {
    d: "M44 105v1h-1v-1z",
    fill: "#d6c1c2"
  })), _path2676 || (_path2676 = /*#__PURE__*/React.createElement("path", {
    d: "M44 106v-1h1v1z",
    fill: "#d3babb"
  })), _path2677 || (_path2677 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106h-1v-1h1z",
    fill: "#d3bab9"
  })), _path2678 || (_path2678 = /*#__PURE__*/React.createElement("path", {
    d: "M47 105v1h-1v-1z",
    fill: "#cfb5b6"
  })), _path2679 || (_path2679 = /*#__PURE__*/React.createElement("path", {
    d: "M47 106v-1h1v1z",
    fill: "#ceb3b6"
  })), _path2680 || (_path2680 = /*#__PURE__*/React.createElement("path", {
    d: "M49 106h-1v-1h1z",
    fill: "#d5bcc0"
  })), _path2681 || (_path2681 = /*#__PURE__*/React.createElement("path", {
    d: "M49 106v-1h1v1z",
    fill: "#ceb7b9"
  })), _path2682 || (_path2682 = /*#__PURE__*/React.createElement("path", {
    d: "M50 105h1v1h-1z",
    fill: "#d3bdc1"
  })), _path2683 || (_path2683 = /*#__PURE__*/React.createElement("path", {
    d: "M52 105v1h-1v-1z",
    fill: "#d3c4c6"
  })), _path2684 || (_path2684 = /*#__PURE__*/React.createElement("path", {
    d: "M53 106h-1v-1h1z",
    fill: "#d7cccf"
  })), _path2685 || (_path2685 = /*#__PURE__*/React.createElement("path", {
    d: "M54 106v-1h1v1z",
    fill: "#dbd7dd"
  })), _path2686 || (_path2686 = /*#__PURE__*/React.createElement("path", {
    d: "M59 105v1h-1v-1z",
    fill: "#d7d7dd"
  })), _path2687 || (_path2687 = /*#__PURE__*/React.createElement("path", {
    d: "M64 105h1v1h-1z",
    fill: "#e3e1e8"
  })), _path2688 || (_path2688 = /*#__PURE__*/React.createElement("path", {
    d: "M65 106v-1h1v1z",
    fill: "#dadadd",
    fillOpacity: 0.384
  })), _path2689 || (_path2689 = /*#__PURE__*/React.createElement("path", {
    d: "M9 106h1v1H9z",
    fill: "#e5e5e5",
    fillOpacity: 0.157
  })), _path2690 || (_path2690 = /*#__PURE__*/React.createElement("path", {
    d: "M11 107h-1v-1h1z",
    fill: "#d8d6d7",
    fillOpacity: 0.969
  })), _path2691 || (_path2691 = /*#__PURE__*/React.createElement("path", {
    d: "M17 106h1v1h-1z",
    fill: "#cbc2c1"
  })), _path2692 || (_path2692 = /*#__PURE__*/React.createElement("path", {
    d: "M19 106v1h-1v-1z",
    fill: "#c7c0c3"
  })), _path2693 || (_path2693 = /*#__PURE__*/React.createElement("path", {
    d: "M21 106h1v1h-1z",
    fill: "#d3cfd3"
  })), _path2694 || (_path2694 = /*#__PURE__*/React.createElement("path", {
    d: "M25 107v-1h1v1z",
    fill: "#d5cdce"
  })), _path2695 || (_path2695 = /*#__PURE__*/React.createElement("path", {
    d: "M26 107v-1h1v1z",
    fill: "#d3c5c5"
  })), _path2696 || (_path2696 = /*#__PURE__*/React.createElement("path", {
    d: "M27 106h1v1h-1z",
    fill: "#d0bcbe"
  })), _path2697 || (_path2697 = /*#__PURE__*/React.createElement("path", {
    d: "M29 107v-1h1v1z",
    fill: "#cfc0bf"
  })), _path2698 || (_path2698 = /*#__PURE__*/React.createElement("path", {
    d: "M30 106h1v1h-1z",
    fill: "#cdb2b3"
  })), _path2699 || (_path2699 = /*#__PURE__*/React.createElement("path", {
    d: "M32 107h-1v-1h1z",
    fill: "#ccb2b0"
  })), _path2700 || (_path2700 = /*#__PURE__*/React.createElement("path", {
    d: "M33 107h-1v-1h1z",
    fill: "#cdb2b0"
  })), _path2701 || (_path2701 = /*#__PURE__*/React.createElement("path", {
    d: "M35 106h1v1h-1z",
    fill: "#d5bfc2"
  })), _path2702 || (_path2702 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106h1v1h-1z",
    fill: "#d5c4c5"
  })), _path2703 || (_path2703 = /*#__PURE__*/React.createElement("path", {
    d: "M39 107h-1v-1h1z",
    fill: "#d4bfc0"
  })), _path2704 || (_path2704 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106v1h-1v-1z",
    fill: "#d0b3b5"
  })), _path2705 || (_path2705 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106h1v1h-1z",
    fill: "#ceb1b3"
  })), _path2706 || (_path2706 = /*#__PURE__*/React.createElement("path", {
    d: "M43 106v1h-1v-1z",
    fill: "#d2bcbd"
  })), _path2707 || (_path2707 = /*#__PURE__*/React.createElement("path", {
    d: "M45 107h-1v-1h1z",
    fill: "#d4bfc1"
  })), _path2708 || (_path2708 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106v1h-1v-1z",
    fill: "#d7c7ca"
  })), _path2709 || (_path2709 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106h1v1h-1z",
    fill: "#dad0d4"
  })), _path2710 || (_path2710 = /*#__PURE__*/React.createElement("path", {
    d: "M48 106v1h-1v-1z",
    fill: "#dbd7db"
  })), _path2711 || (_path2711 = /*#__PURE__*/React.createElement("path", {
    d: "M64 107h-1v-1h1z",
    fill: "#dcdbe0",
    fillOpacity: 0.984
  })), _path2712 || (_path2712 = /*#__PURE__*/React.createElement("path", {
    d: "M65 106v1h-1v-1z",
    fill: "#dadade",
    fillOpacity: 0.812
  })), _path2713 || (_path2713 = /*#__PURE__*/React.createElement("path", {
    d: "M65 107v-1h1v1z",
    fill: "#e0e0e0",
    fillOpacity: 0.129
  })), _path2714 || (_path2714 = /*#__PURE__*/React.createElement("path", {
    d: "M11 108h-1v-1h1z",
    fill: "#dbdada",
    fillOpacity: 0.788
  })), _path2715 || (_path2715 = /*#__PURE__*/React.createElement("path", {
    d: "M12 108h-1v-1h1z",
    fill: "#dcd8d6"
  })), _path2716 || (_path2716 = /*#__PURE__*/React.createElement("path", {
    d: "M17 107h1v1h-1z",
    fill: "#c6bcbd"
  })), _path2717 || (_path2717 = /*#__PURE__*/React.createElement("path", {
    d: "M19 108h-1v-1h1z",
    fill: "#c8c4c5"
  })), _path2718 || (_path2718 = /*#__PURE__*/React.createElement("path", {
    d: "M20 107v1h-1v-1z",
    fill: "#d1ccce"
  })), _path2719 || (_path2719 = /*#__PURE__*/React.createElement("path", {
    d: "M22 108h-1v-1h1z",
    fill: "#d3ced1"
  })), _path2720 || (_path2720 = /*#__PURE__*/React.createElement("path", {
    d: "M23 107v1h-1v-1z",
    fill: "#c5aba9"
  })), _path2721 || (_path2721 = /*#__PURE__*/React.createElement("path", {
    d: "M23 108v-1h1v1z",
    fill: "#c49e9e"
  })), _path2722 || (_path2722 = /*#__PURE__*/React.createElement("path", {
    d: "M25 107v1h-1v-1z",
    fill: "#d4cecf"
  })), _path2723 || (_path2723 = /*#__PURE__*/React.createElement("path", {
    d: "M27 108h-1v-1h1z",
    fill: "#ccb1b2"
  })), _path2724 || (_path2724 = /*#__PURE__*/React.createElement("path", {
    d: "M28 107v1h-1v-1z",
    fill: "#d1bcbc"
  })), _path2725 || (_path2725 = /*#__PURE__*/React.createElement("path", {
    d: "M30 107v1h-1v-1z",
    fill: "#d6c6c4"
  })), _path2726 || (_path2726 = /*#__PURE__*/React.createElement("path", {
    d: "M31 107v1h-1v-1z",
    fill: "#d5c1c3"
  })), _path2727 || (_path2727 = /*#__PURE__*/React.createElement("path", {
    d: "M33 108h-1v-1h1z",
    fill: "#cfb4b7"
  })), _path2728 || (_path2728 = /*#__PURE__*/React.createElement("path", {
    d: "M34 108h-1v-1h1z",
    fill: "#d0bbbc"
  })), _path2729 || (_path2729 = /*#__PURE__*/React.createElement("path", {
    d: "M35 107v1h-1v-1z",
    fill: "#d1b9ba"
  })), _path2730 || (_path2730 = /*#__PURE__*/React.createElement("path", {
    d: "M35 108v-1h1v1z",
    fill: "#cfb3b3"
  })), _path2731 || (_path2731 = /*#__PURE__*/React.createElement("path", {
    d: "M38 108v-1h1v1z",
    fill: "#d6c3c6"
  })), _path2732 || (_path2732 = /*#__PURE__*/React.createElement("path", {
    d: "M39 108v-1h1v1z",
    fill: "#d8cfd2"
  })), _path2733 || (_path2733 = /*#__PURE__*/React.createElement("path", {
    d: "M42 108h-1v-1h1z",
    fill: "#dbd9db"
  })), _path2734 || (_path2734 = /*#__PURE__*/React.createElement("path", {
    d: "M42 107h1v1h-1z",
    fill: "#dadddf"
  })), _path2735 || (_path2735 = /*#__PURE__*/React.createElement("path", {
    d: "M56 108v-1h1v1z",
    fill: "#dadadf",
    fillOpacity: 0.961
  })), _path2736 || (_path2736 = /*#__PURE__*/React.createElement("path", {
    d: "M57 108v-1h1v1z",
    fill: "#d9d9de",
    fillOpacity: 0.89
  })), _path2737 || (_path2737 = /*#__PURE__*/React.createElement("path", {
    d: "M59 108h-1v-1h1z",
    fill: "#dbdadf",
    fillOpacity: 0.792
  })), _path2738 || (_path2738 = /*#__PURE__*/React.createElement("path", {
    d: "M59 107h1v1h-1z",
    fill: "#dcdade",
    fillOpacity: 0.686
  })), _path2739 || (_path2739 = /*#__PURE__*/React.createElement("path", {
    d: "M60 107h1v1h-1z",
    fill: "#ddddde",
    fillOpacity: 0.561
  })), _path2740 || (_path2740 = /*#__PURE__*/React.createElement("path", {
    d: "M62 107v1h-1v-1z",
    fill: "#dedede",
    fillOpacity: 0.427
  })), _path2741 || (_path2741 = /*#__PURE__*/React.createElement("path", {
    d: "M62 107h1v1h-1z",
    fill: "#dfdfdf",
    fillOpacity: 0.314
  })), _path2742 || (_path2742 = /*#__PURE__*/React.createElement("path", {
    d: "M64 107v1h-1v-1z",
    fill: "#e5e5e5",
    fillOpacity: 0.196
  })), _path2743 || (_path2743 = /*#__PURE__*/React.createElement("path", {
    d: "M10 109v-1h1v1z",
    fill: "#ddd",
    fillOpacity: 0.482
  })), _path2744 || (_path2744 = /*#__PURE__*/React.createElement("path", {
    d: "M12 109h-1v-1h1z",
    fill: "#e0dedc"
  })), _path2745 || (_path2745 = /*#__PURE__*/React.createElement("path", {
    d: "M17 109v-1h1v1z",
    fill: "#c3b9bb"
  })), _path2746 || (_path2746 = /*#__PURE__*/React.createElement("path", {
    d: "M18 108h1v1h-1z",
    fill: "#cec9cb"
  })), _path2747 || (_path2747 = /*#__PURE__*/React.createElement("path", {
    d: "M20 109h-1v-1h1z",
    fill: "#d1cdcd"
  })), _path2748 || (_path2748 = /*#__PURE__*/React.createElement("path", {
    d: "M21 108h1v1h-1z",
    fill: "#ccb9b8"
  })), _path2749 || (_path2749 = /*#__PURE__*/React.createElement("path", {
    d: "M22 108h1v1h-1z",
    fill: "#c49f9b"
  })), _path2750 || (_path2750 = /*#__PURE__*/React.createElement("path", {
    d: "M24 108v1h-1v-1z",
    fill: "#c7a09c"
  })), _path2751 || (_path2751 = /*#__PURE__*/React.createElement("path", {
    d: "M25 108v1h-1v-1z",
    fill: "#cebdbc"
  })), _path2752 || (_path2752 = /*#__PURE__*/React.createElement("path", {
    d: "M27 109v-1h1v1z",
    fill: "#d9dadd"
  })), _path2753 || (_path2753 = /*#__PURE__*/React.createElement("path", {
    d: "M28 108h1v1h-1z",
    fill: "#ceb9ba"
  })), _path2754 || (_path2754 = /*#__PURE__*/React.createElement("path", {
    d: "M30 109h-1v-1h1z",
    fill: "#ccb2b1"
  })), _path2755 || (_path2755 = /*#__PURE__*/React.createElement("path", {
    d: "M31 108v1h-1v-1z",
    fill: "#cfb8b8"
  })), _path2756 || (_path2756 = /*#__PURE__*/React.createElement("path", {
    d: "M31 109v-1h1v1z",
    fill: "#d1bcbe"
  })), _path2757 || (_path2757 = /*#__PURE__*/React.createElement("path", {
    d: "M33 108h1v1h-1z",
    fill: "#d8d1d3"
  })), _path2758 || (_path2758 = /*#__PURE__*/React.createElement("path", {
    d: "M35 108h1v1h-1z",
    fill: "#dbd8dd"
  })), _path2759 || (_path2759 = /*#__PURE__*/React.createElement("path", {
    d: "M41 108v1h-1v-1z",
    fill: "#dcdbdf"
  })), _path2760 || (_path2760 = /*#__PURE__*/React.createElement("path", {
    d: "M51 109h-1v-1h1z",
    fill: "#dcdbe0",
    fillOpacity: 0.863
  })), _path2761 || (_path2761 = /*#__PURE__*/React.createElement("path", {
    d: "M51 108h1v1h-1z",
    fill: "#dbdbdf",
    fillOpacity: 0.757
  })), _path2762 || (_path2762 = /*#__PURE__*/React.createElement("path", {
    d: "M53 108v1h-1v-1z",
    fill: "#dbdbde",
    fillOpacity: 0.639
  })), _path2763 || (_path2763 = /*#__PURE__*/React.createElement("path", {
    d: "M53 109v-1h1v1z",
    fill: "#dddbdf",
    fillOpacity: 0.514
  })), _path2764 || (_path2764 = /*#__PURE__*/React.createElement("path", {
    d: "M55 108h1v1h-1z",
    fill: "#e0e0e3",
    fillOpacity: 0.259
  })), _path2765 || (_path2765 = /*#__PURE__*/React.createElement("path", {
    d: "M57 109h-1v-1h1z",
    fill: "#dedee4",
    fillOpacity: 0.153
  })), _path2766 || (_path2766 = /*#__PURE__*/React.createElement("path", {
    d: "M10 110v-1h1v1z",
    fill: "#e3e3e3",
    fillOpacity: 0.18
  })), _path2767 || (_path2767 = /*#__PURE__*/React.createElement("path", {
    d: "M12 109v1h-1v-1z",
    fill: "#dbd9d8",
    fillOpacity: 0.973
  })), _path2768 || (_path2768 = /*#__PURE__*/React.createElement("path", {
    d: "M13 110h-1v-1h1z",
    fill: "#d0cac9"
  })), _path2769 || (_path2769 = /*#__PURE__*/React.createElement("path", {
    d: "M17 109v1h-1v-1z",
    fill: "#c9c2c0"
  })), _path2770 || (_path2770 = /*#__PURE__*/React.createElement("path", {
    d: "M17 110v-1h1v1z",
    fill: "#c5bfc1"
  })), _path2771 || (_path2771 = /*#__PURE__*/React.createElement("path", {
    d: "M19 110v-1h1v1z",
    fill: "#d1cdd1"
  })), _path2772 || (_path2772 = /*#__PURE__*/React.createElement("path", {
    d: "M23 109v1h-1v-1z",
    fill: "#c6a2a1"
  })), _path2773 || (_path2773 = /*#__PURE__*/React.createElement("path", {
    d: "M24 109v1h-1v-1z",
    fill: "#c8acab"
  })), _path2774 || (_path2774 = /*#__PURE__*/React.createElement("path", {
    d: "M25 110h-1v-1h1z",
    fill: "#d6cfcf"
  })), _path2775 || (_path2775 = /*#__PURE__*/React.createElement("path", {
    d: "M28 109v1h-1v-1z",
    fill: "#d7d6d9"
  })), _path2776 || (_path2776 = /*#__PURE__*/React.createElement("path", {
    d: "M42 109v1h-1v-1z",
    fill: "#d9d9dd",
    fillOpacity: 0.973
  })), _path2777 || (_path2777 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110h-1v-1h1z",
    fill: "#dbdade",
    fillOpacity: 0.91
  })), _path2778 || (_path2778 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109v1h-1v-1z",
    fill: "#dddddf",
    fillOpacity: 0.827
  })), _path2779 || (_path2779 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109h1v1h-1z",
    fill: "#dcdcde",
    fillOpacity: 0.718
  })), _path2780 || (_path2780 = /*#__PURE__*/React.createElement("path", {
    d: "M46 109v1h-1v-1z",
    fill: "#dcdce0",
    fillOpacity: 0.584
  })), _path2781 || (_path2781 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110h-1v-1h1z",
    fill: "#dddddf",
    fillOpacity: 0.451
  })), _path2782 || (_path2782 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110v-1h1v1z",
    fill: "#e0e0e3",
    fillOpacity: 0.329
  })), _path2783 || (_path2783 = /*#__PURE__*/React.createElement("path", {
    d: "M48 109h1v1h-1z",
    fill: "#dfdfdf",
    fillOpacity: 0.22
  })), _path2784 || (_path2784 = /*#__PURE__*/React.createElement("path", {
    d: "M12 111h-1v-1h1z",
    fill: "#dadcdc",
    fillOpacity: 0.776
  })), _path2785 || (_path2785 = /*#__PURE__*/React.createElement("path", {
    d: "M12 110h1v1h-1z",
    fill: "#dbd7d7"
  })), _path2786 || (_path2786 = /*#__PURE__*/React.createElement("path", {
    d: "M17 111h-1v-1h1z",
    fill: "#c5bfbd"
  })), _path2787 || (_path2787 = /*#__PURE__*/React.createElement("path", {
    d: "M18 110v1h-1v-1z",
    fill: "#ccc8cb"
  })), _path2788 || (_path2788 = /*#__PURE__*/React.createElement("path", {
    d: "M19 111h-1v-1h1z",
    fill: "#d1ccd2"
  })), _path2789 || (_path2789 = /*#__PURE__*/React.createElement("path", {
    d: "M22 111v-1h1v1z",
    fill: "#d5cfd0"
  })), _path2790 || (_path2790 = /*#__PURE__*/React.createElement("path", {
    d: "M23 110h1v1h-1z",
    fill: "#d7d2d7"
  })), _path2791 || (_path2791 = /*#__PURE__*/React.createElement("path", {
    d: "M25 111h-1v-1h1z",
    fill: "#d5d3d7"
  })), _path2792 || (_path2792 = /*#__PURE__*/React.createElement("path", {
    d: "M25 111v-1h1v1z",
    fill: "#d7d3d6"
  })), _path2793 || (_path2793 = /*#__PURE__*/React.createElement("path", {
    d: "M27 110v1h-1v-1z",
    fill: "#d6d5d8"
  })), _path2794 || (_path2794 = /*#__PURE__*/React.createElement("path", {
    d: "M27 111v-1h1v1z",
    fill: "#dad9da"
  })), _path2795 || (_path2795 = /*#__PURE__*/React.createElement("path", {
    d: "M29 111h-1v-1h1z",
    fill: "#dcdbdd"
  })), _path2796 || (_path2796 = /*#__PURE__*/React.createElement("path", {
    d: "M34 111h-1v-1h1z",
    fill: "#dad6db",
    fillOpacity: 0.984
  })), _path2797 || (_path2797 = /*#__PURE__*/React.createElement("path", {
    d: "M34 110h1v1h-1z",
    fill: "#dad8dc",
    fillOpacity: 0.925
  })), _path2798 || (_path2798 = /*#__PURE__*/React.createElement("path", {
    d: "M35 111v-1h1v1z",
    fill: "#dad9db",
    fillOpacity: 0.851
  })), _path2799 || (_path2799 = /*#__PURE__*/React.createElement("path", {
    d: "M36 111v-1h1v1z",
    fill: "#dcdadc",
    fillOpacity: 0.761
  })), _path2800 || (_path2800 = /*#__PURE__*/React.createElement("path", {
    d: "M37 110h1v1h-1z",
    fill: "#dbdadd",
    fillOpacity: 0.655
  })), _path2801 || (_path2801 = /*#__PURE__*/React.createElement("path", {
    d: "M39 110v1h-1v-1z",
    fill: "#dbdbdd",
    fillOpacity: 0.514
  })), _path2802 || (_path2802 = /*#__PURE__*/React.createElement("path", {
    d: "M41 111h-1v-1h1z",
    fill: "#dcdce0",
    fillOpacity: 0.263
  })), _path2803 || (_path2803 = /*#__PURE__*/React.createElement("path", {
    d: "M41 111v-1h1v1z",
    fill: "#dfdfdf",
    fillOpacity: 0.161
  })), _path2804 || (_path2804 = /*#__PURE__*/React.createElement("path", {
    d: "M11 111h1v1h-1z",
    fill: "#d7d7d7",
    fillOpacity: 0.427
  })), _path2805 || (_path2805 = /*#__PURE__*/React.createElement("path", {
    d: "M12 112v-1h1v1z",
    fill: "#e0dfdf"
  })), _path2806 || (_path2806 = /*#__PURE__*/React.createElement("path", {
    d: "M15 111h1v1h-1z",
    fill: "#c3bcb8"
  })), _path2807 || (_path2807 = /*#__PURE__*/React.createElement("path", {
    d: "M17 111v1h-1v-1z",
    fill: "#cac4c5"
  })), _path2808 || (_path2808 = /*#__PURE__*/React.createElement("path", {
    d: "M17 111h1v1h-1z",
    fill: "#d2cdcf"
  })), _path2809 || (_path2809 = /*#__PURE__*/React.createElement("path", {
    d: "M19 111v1h-1v-1z",
    fill: "#d2ced0"
  })), _path2810 || (_path2810 = /*#__PURE__*/React.createElement("path", {
    d: "M20 111h1v1h-1z",
    fill: "#d7d2d4"
  })), _path2811 || (_path2811 = /*#__PURE__*/React.createElement("path", {
    d: "M22 112h-1v-1h1z",
    fill: "#dbd5d7"
  })), _path2812 || (_path2812 = /*#__PURE__*/React.createElement("path", {
    d: "M26 111v1h-1v-1z",
    fill: "#d6d3d5"
  })), _path2813 || (_path2813 = /*#__PURE__*/React.createElement("path", {
    d: "M26 112v-1h1v1z",
    fill: "#d4d3d4",
    fillOpacity: 0.961
  })), _path2814 || (_path2814 = /*#__PURE__*/React.createElement("path", {
    d: "M28 112h-1v-1h1z",
    fill: "#d6d4d5",
    fillOpacity: 0.886
  })), _path2815 || (_path2815 = /*#__PURE__*/React.createElement("path", {
    d: "M28 111h1v1h-1z",
    fill: "#d7d5d5",
    fillOpacity: 0.804
  })), _path2816 || (_path2816 = /*#__PURE__*/React.createElement("path", {
    d: "M29 112v-1h1v1z",
    fill: "#d9d9d7",
    fillOpacity: 0.69
  })), _path2817 || (_path2817 = /*#__PURE__*/React.createElement("path", {
    d: "M30 111h1v1h-1z",
    fill: "#d9d9d9",
    fillOpacity: 0.557
  })), _path2818 || (_path2818 = /*#__PURE__*/React.createElement("path", {
    d: "M32 111v1h-1v-1z",
    fill: "#dadada",
    fillOpacity: 0.435
  })), _path2819 || (_path2819 = /*#__PURE__*/React.createElement("path", {
    d: "M33 111v1h-1v-1z",
    fill: "#d7dada",
    fillOpacity: 0.302
  })), _path2820 || (_path2820 = /*#__PURE__*/React.createElement("path", {
    d: "M34 111v1h-1v-1z",
    fill: "#dbdbdb",
    fillOpacity: 0.196
  })), _path2821 || (_path2821 = /*#__PURE__*/React.createElement("path", {
    d: "M34 112v-1h1v1z",
    fill: "#e1e1e1",
    fillOpacity: 0.102
  })), _path2822 || (_path2822 = /*#__PURE__*/React.createElement("path", {
    d: "M12 113v-1h1v1z",
    fill: "#d3d2d2",
    fillOpacity: 0.808
  })), _path2823 || (_path2823 = /*#__PURE__*/React.createElement("path", {
    d: "M13 113v-1h1v1z",
    fill: "#d6d0ce"
  })), _path2824 || (_path2824 = /*#__PURE__*/React.createElement("path", {
    d: "M15 113h-1v-1h1z",
    fill: "#d1c9c4"
  })), _path2825 || (_path2825 = /*#__PURE__*/React.createElement("path", {
    d: "M17 112h1v1h-1z",
    fill: "#d8d5d2"
  })), _path2826 || (_path2826 = /*#__PURE__*/React.createElement("path", {
    d: "M19 112h1v1h-1z",
    fill: "#d2d1ce",
    fillOpacity: 0.957
  })), _path2827 || (_path2827 = /*#__PURE__*/React.createElement("path", {
    d: "M20 112h1v1h-1z",
    fill: "#d3d1d0",
    fillOpacity: 0.878
  })), _path2828 || (_path2828 = /*#__PURE__*/React.createElement("path", {
    d: "M21 113v-1h1v1z",
    fill: "#d5d2d1",
    fillOpacity: 0.773
  })), _path2829 || (_path2829 = /*#__PURE__*/React.createElement("path", {
    d: "M22 113v-1h1v1z",
    fill: "#d3d2d2",
    fillOpacity: 0.647
  })), _path2830 || (_path2830 = /*#__PURE__*/React.createElement("path", {
    d: "M24 113h-1v-1h1z",
    fill: "#d6d2d4",
    fillOpacity: 0.518
  })), _path2831 || (_path2831 = /*#__PURE__*/React.createElement("path", {
    d: "M25 112v1h-1v-1z",
    fill: "#d7d7d7",
    fillOpacity: 0.376
  })), _path2832 || (_path2832 = /*#__PURE__*/React.createElement("path", {
    d: "M25 112h1v1h-1z",
    fill: "#dbd7db",
    fillOpacity: 0.255
  })), _path2833 || (_path2833 = /*#__PURE__*/React.createElement("path", {
    d: "M26 112h1v1h-1z",
    fill: "#ded7d7",
    fillOpacity: 0.153
  })), _path2834 || (_path2834 = /*#__PURE__*/React.createElement("path", {
    d: "M13 113v1h-1v-1z",
    fill: "#d3d3d3",
    fillOpacity: 0.114
  })), _path2835 || (_path2835 = /*#__PURE__*/React.createElement("path", {
    d: "M13 114v-1h1v1z",
    fill: "#d0ccca",
    fillOpacity: 0.494
  })), _path2836 || (_path2836 = /*#__PURE__*/React.createElement("path", {
    d: "M15 113v1h-1v-1z",
    fill: "#cac6c3",
    fillOpacity: 0.671
  })), _path2837 || (_path2837 = /*#__PURE__*/React.createElement("path", {
    d: "M15 114v-1h1v1z",
    fill: "#d0cbc9",
    fillOpacity: 0.639
  })), _path2838 || (_path2838 = /*#__PURE__*/React.createElement("path", {
    d: "M17 113v1h-1v-1z",
    fill: "#d2d0ce",
    fillOpacity: 0.518
  })), _path2839 || (_path2839 = /*#__PURE__*/React.createElement("path", {
    d: "M17 114v-1h1v1z",
    fill: "#d5d3d0",
    fillOpacity: 0.388
  })), _path2840 || (_path2840 = /*#__PURE__*/React.createElement("path", {
    d: "M18 113h1v1h-1z",
    fill: "#d9d5d5",
    fillOpacity: 0.267
  })), _path2841 || (_path2841 = /*#__PURE__*/React.createElement("path", {
    d: "M20 113v1h-1v-1z",
    fill: "#d7d7d7",
    fillOpacity: 0.153
  })), _path2842 || (_path2842 = /*#__PURE__*/React.createElement("path", {
    d: "M21 114h-1v-1h1z",
    fill: "#dfefdf",
    fillOpacity: 0.063
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasticBag);
export default __webpack_public_path__ + "static/media/plastic-bag.35ee73c231e6152ce4e057314a40a0c3.svg";
export { ForwardRef as ReactComponent };